<template>
<div id="workorder_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="right-asset-tab-list purchase-order-right-tab wo-edit-sidebar" id="wo-detail-section" v-if="displayLineItem">
        <div class="containerTab mt-3">
            <a href="javascript:void(0)" class="closebtn pull-right mr-4" v-on:click="closeWODetail($event)"><i class="fp-close"></i> </a>
            <div class="content clear">
                <div class="tabcontent">
                    <div class="list-view">
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                            <label class="col">Work Order No :</label>
                            <span class="col">{{titleCase(work_order_no)}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                            <label class="col">Customer :</label>
                            <span class="col">{{customerInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fldelivery-truck"></i> </span> -->
                            <label class="col">Unit :</label>
                            <span class="col">{{assetInfo}}</span>
                        </div>
                      <div class="row form-group border-bottom pb-2" v-if="assetRequired">
                        <!-- <span class="work-order-icon"> <i class="hi-icon icon-fldelivery-truck"></i> </span> -->
                        <label class="col">Asset Pool :</label>
                        <span class="col">{{assetPoolInfo}}</span>
                      </div>
                        <template v-if="sectionArr && sectionArr.length">
                            <template v-for="(sc,sval) in sectionArr">
                                <div class="row form-group border-bottom pb-2" :key="sval" v-if="sc.read_on_wo != undefined && sc.read_on_wo.toLowerCase() == 'mandatory'">

                                    <!-- to change lable for distance to odomter as req by Kevin -->
                                  <template>
                                    <template v-if="sc.sectionName.toLowerCase() == 'dist'">
                                      <label class="col">Odometer :</label>
                                    </template>
                                    <template v-else>
                                      <label class="col">{{ sc.sectionName }} :</label>
                                    </template>
                                    <template v-if='addMiles==false'>
                                      <span class="col">{{ sc.reading }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="col">
                                            <input class="form-inline form-control" v-model="sc.reading"
                                                   :id="'woMiles'+sval" :placeholder="sc.sectionName" name="woMiles"
                                                   @keypress="isAmountCheck($event)">
                                        </span>
                                    </template>
                                  </template>
                                </div>
                            </template>
                        </template>
                            <div class="row form-group border-bottom pb-2" v-if='addMiles==true'>
                                <label class="col"></label>
                                <button type="submit" id="createVehicleBtn"  class="btn btn-primary adjMarginRV" v-on:click.prevent="saveMiles()" >
                                    <i class="fp-save"> </i>  Save
                                </button>
                            </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                            <label class="col">Status :</label>
                            <span class="col">{{woStatusInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                            <label class="col">Open Date :</label>
                            <span class="col">{{openDateInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                            <label class="col">Close Date :</label>
                            <span class="col">{{closeDateInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <!-- <span class="work-order-icon"> <i class="hi-icon icon-flplaceholder-filled-point"></i> </span> -->
                            <label class="col">Location :</label>
                            <span class="col">{{locationInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Requested Completion :</label>
                            <span class="col">{{requestCompInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">User :</label>
                            <span class="col">{{userInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Maintenance Type :</label>
                            <span class="col">{{maintenanceTypeInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Notes :</label>
                            <span class="col">{{woNotesInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Miscellaneous :</label>
                            <span class="col">{{woIsMiscellaneous}}</span>
                        </div>
                        <div v-if="woIsMiscellaneous == 'Yes'" class="row form-group border-bottom pb-2">
                            <label class="col">Vin Number :</label>
                            <span class="col">{{woCustomerVinInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Agreed Date :</label>
                            <span class="col">{{agreedDateInfo}}</span>
                        </div>
                        <div class="row form-group border-bottom pb-2">
                            <label class="col">Priority :</label>
                            <span class="col">{{priorityInfo}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="workOrderHeader" v-if="$route.params.id > 0">Update Work Order <span v-if="assetUnitNo != undefined">-</span> {{ work_order_no }} | {{ assetUnitNo }}</span>
                <span class="page-title" id="workOrderHeader" v-else>Add Work Order</span>
                <div class="btn-groups text-right">
                <button type="submit" id="createWorkOrderBtn" v-if="$route.params.id > 0 && displayLineItem == true" class="btn btn-primary" v-on:click.prevent="checkStatus(flag='final','workorder')">
                    <i class="fp-reload"> </i> Update
                </button>
                <button v-if="$route.params.id && displayLineItem == true && (woStatusInfo != '' && woStatusInfo.toLowerCase() != 'approved')" type="submit" id="editWorkOrderBtn" v-on:click="editWODetails()" class="btn btn-primary">
                    <i class="fp-edit-icon"></i> Edit WO Details
                </button>
                <button type="submit" v-show="displayLineItem" class="btn btn-secondary" v-on:click="showDetail($event)"><i class="fa fa-info"></i> Details</button>
                <!-- <button type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath"> -->
                  <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="backButton" >
                    <i class="fp-back"> </i> Back
                </button>
                <a v-if="displayLineItem" href="javascript:void(0)" class="btn btn-secondary pull-right ml-1" v-on:click="openModal()">
                      <i class="fp-export"></i> Import
                  </a>
                </div>
                <div class="field-error" :id="'error_msg'"></div>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content work-order-crud">
                    <section :class="'internal-container border-top-table-fl '+itemClass">
                        <template v-if="displayLineItem == false && displaySchedule == false">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WorkOrderForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <!-- <div v-if="$route.params.id > 0" class="col form-group pt-md-4">
                                        <label class="control-label" for="vehicle_id">#WO: </label>
                                        <span class="label">{{work_order_no}}</span>
                                    </div> -->
                                    <div class="col form-group pt-md-4">
                                        <div class="custom-checkbox">
                                            <label for="is_miscellaneous" class="checkbox-custom">Miscellaneous
                                            <input type="checkbox" v-model="is_miscellaneous" id="is_miscellaneous" name="is_miscellaneous" v-on:click="isMiscellaneous($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label require" for="work_order_no">Work Order # :</label>
                                        <input type="number" disabled class="form-control" v-model="work_order_no" id="work_order_no" placeholder="Work Order" name="work_order_no" @blur="onWorkOrderTypeIn()">
                                        <div class="field-error">{{ work_order_no_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="wo_order_type">Work Order Type:</label>
                                        <v-select id="work_order_type" v-model="work_order_type" name="work_order_type" placeholder="Select Work Order Type." label="text" class="close-remove" :options="workOrderTypesArr" @input="onSelectWoType()" :disabled="!!$route.params.id">
                                        </v-select>
                                        <div class="field-error">{{ work_order_type_error_msg }}</div>
                                    </div>
                                    <template v-if="!showMiscellaneousFields && assetRequired">
                                        <div class="col form-group">
                                            <label class="control-label require" for="vehicle_id">Unit:</label>
                                            <router-link class="pull-right color-blue link-text" v-bind:to="{name: 'AssetCreate', params:{newAsset: searchedAsset, redirectFrom: 'WorkOrderCreate'}}"> <i class="fp-add font-weight-bold" style="font-size:8px;"></i> Add Unit</router-link>
                                            <v-select v-model="vehicle_id" id="vehicle_select" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" @input="onAssetChange" placeholder="Select Unit" class='custom-ci-auto-search close-remove'>
                                                <template slot="no-options">
                                                    Search Unit...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ vehicle_error_msg }}</div>
                                        </div>
                                    </template>
                                    <template v-else-if="assetRequired">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_email">Email:</label>
                                            <input type="text" class="form-control" v-model="customer_email" id="customer_email" placeholder="Email" name="customer_email">
                                            <div class="field-error">{{ customer_email_error_msg }}</div>
                                        </div>
                                    </template>
                                    <div class="col form-group" v-if="assetRequired">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <router-link class="pull-right color-blue link-text" v-bind:to="{name: 'CustomerCreate', params:{newCustomer: searchedCustomer, redirectFrom: 'WorkOrderCreate'}}"> <i class="fp-add" style="font-size:8px;font-weight:bold;"></i> Add Customer</router-link>
                                        <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" @input="onCustomerChange" placeholder="Select Customer" class='custom-ci-auto-search close-remove' :disabled="disableCustField">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" v-if="customer_id != null && customer_id.status && customer_id.status != undefined && customer_id.status == 'inactive'">Customer Marked as DNU</div>
                                        <div class="field-error" v-if="customer_id != null && customer_id.status && customer_id.status != undefined && customer_id.status == 'hold'">Customer account is on Hold</div>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group" v-if="assetRequired">
                                        <label id="customer_po" class="control-label" for="customer_purchase_order">Customer PO:</label>
                                        <input class="form-control" v-model="customerPoNo" id="customer_purchase_order" placeholder="Customer PO# " name="customer_purchase_order">
                                        <div class="field-error">{{ customer_po_error_msg }}</div>
                                    </div>
                                    <template v-if="showMiscellaneousFields && assetRequired">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_vin_number">Vin Number:</label>
                                            <input type="text" class="form-control" v-model="customer_vin_number" id="customer_vin_number" placeholder="Vin Number" name="customer_vin_number">
                                            <div class="field-error">{{ customer_vin_number_error_msg }}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="customer_unit_no">Unit No:</label>
                                            <input type="text" class="form-control" v-model="customer_unit_no" id="customer_unit_no" placeholder="Unit No" name="customer_unit_no">
                                            <div class="field-error">{{ customer_unit_no_error_msg }}</div>
                                        </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" class='close-remove' :options="locationArr" @input="onLocationChange">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Open Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="open_date" name="open_date" v-model="open_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon' :disabled="disableWOFields"></date-picker>
                                            <label for="open_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group" v-show="role != 'technician'">
                                        <label class="control-label">Requested Completion</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="requested_completion" name="requested_completion" v-model="requested_completion" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                            <label for="requested_completion" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group" v-show="role != 'technician'">
                                        <label class="control-label">Agreed Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="agreed_date" name="agreed_date" v-model="agreed_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon' :disabled="disableWOFields"></date-picker>
                                            <label for="agreed_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label required" for="notes">Miles:</label>
                                        <input type="text" class="form-control" v-model="miles" id="miles" autocomplete="off" placeholder="Miles" name="miles" :disabled="disableWOFields" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{ miles_error_msg }}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="user_id">User:</label>
                                        <v-select v-model="user_id" name="user_id" id="user_id" label="text" :filterable="false" :options="userArr" @search="onSearchUser" placeholder="Select User" class='custom-ci-auto-search contract-data close-remove' :disabled="disableWOFields">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ user_error_msg }}</div>
                                    </div>
                                    <div class="col form-group" v-show="role != 'technician'">
                                        <label class="control-label" for="priority">Priority:</label>
                                        <v-select v-model="priority" name="priority" placeholder="Select Priority." label="text" :options="priorityArr" :disabled="disableWOFields">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="status">Status:</label>
                                        <v-select v-model="wostatus" id="wostatus" name="wostatus" placeholder="Select Status." label="text" class='close-remove' :options="woStatusArr" :disabled="disableWoStatusField">
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <template v-if="sectionArr && sectionArr.length && assetRequired">
                                        <template v-for="(sec,scval) in sectionArr">
                                            <div class="col form-group col-md-2" :key="scval">
                                                <template v-if="sec.read_on_wo != undefined && sec.read_on_wo.toLowerCase() == 'mandatory'">
                                                    <label class="control-label required" v-if="sec.section_code.toLowerCase() == 'dist'" for="notes">Odometer:</label>
                                                    <label class="control-label required" v-else for="notes">{{sec.sectionName}}</label>
                                                    <input type="text" class="form-control" v-model="sec.reading" id="miles" autocomplete="off" :placeholder="'Odometer'" name="miles" :disabled="disableWOFields" @keypress="isAmountCheck($event)">
                                                </template>
<!--                                                <template v-else>-->
<!--                                                    <label class="control-label required" for="notes">{{sec.sectionName}}:</label>-->
<!--                                                    <input type="text" class="form-control" v-model="sec.reading" id="miles" autocomplete="off" :placeholder="sec.sectionName" name="miles" :disabled="disableWOFields" @keypress="isAmountCheck($event)">-->
<!--                                                </template>-->
                                                <div class="field-error">{{ sec.reading_error }}</div>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Notes:</label>
                                        <small v-if="wonotes" style="float: right;">
                                            ( {{ 250 - wonotes.length }} Characters left )
                                        </small>
                                        <textarea class='form-control rounded-0' v-model="wonotes" ref="textarea" id="wonotes" rows="3" :disabled="disableWOFields" maxlength="250"></textarea>
                                        <div class="field-error"></div>
                                    </div>
                                    <!-- Shows open work orders for the selected asset to warn user -->

                                    <div class="col form-group" v-if="openWoArr.length > 0">
                                        <div class="table-reponsive-sm ">
                                            <label class="control-label" style="color:#cf0010" for="notes">Open work orders found for the selected asset:</label>
                                            <table aria-describedby="table" class="table table-bordered table-sm font-1">
                                                <thead>
                                                    <tr class="table-primary">
                                                        <th>WO#</th>
                                                        <th>Status</th>
                                                        <th>Open Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(wo, index) in openWoArr">
                                                        <tr>
                                                            <td><router-link class="color-blue"  v-bind:to="{name:'WorkOrderView',params:{id:wo.id}}" target="_blank">{{ wo.work_order_no }}</router-link></td>
                                                            <td>{{ wo.status }}</td>
                                                            <td>{{ wo.open_date }}</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </template>

                         <div class="wo-maintenance" v-if="displaySchedule">
                            <div class="modal-header">
                                <h5 class="modal-title">Maintenance For: <span v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">{{scheduleMaintenanceArr[0].vUnitNo}}</span></h5>
                            </div>
                            <div class="modal-body">
                                <p v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">The following Program exist on the work roster for unit: <span>{{scheduleMaintenanceArr[0].vUnitNo}}</span>&nbsp; Select to place
                                the entries on the current work order.</p>
                                <template v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">
                                    <h5 class="mb-2">Due:</h5>
                                    <template v-for="(main,mKey) in scheduleMaintenanceArr">
                                        <div :key="mKey" class="form-group mb-3">
                                            <div class="custom-checkbox">
                                                <label class="checkbox-custom">
                                                    {{main.program}}
                                                    <input type="checkbox" @change="selectMaintenance(main,$event,'program')"/>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-if="dueNotFound">
                                        <span>&nbsp;&nbsp; No Due Found.</span>
                                    </div>
                                    <br>
                                </template>
                                <p v-if="warrantyTriggerArr && warrantyTriggerArr.length > 0">The following Warranty exist on the work roster.</p>
                                <template v-if="warrantyTriggerArr && warrantyTriggerArr.length > 0">
                                    <h5 class="mb-2">Warranty:</h5>
                                    <template v-for="(war,wKey) in warrantyTriggerArr">
                                        <div :key="wKey" class="form-group mb-3">
                                            <!-- <div class="custom-checkbox"> -->
                                                <label class="checkbox-custom">
                                                    {{war.warranty}}
                                                    <!-- <input type="checkbox" @change="selectMaintenance(war,$event,'warranty')"/> -->
                                                    <!-- <span class="checkmark"></span> -->
                                                </label>
                                            <!-- </div> -->
                                        </div>
                                    </template>
                                    <div v-if="dueNotFound">
                                        <span>&nbsp;&nbsp; No Due Found.</span>
                                    </div>
                                    <br>
                                </template>
                            </div>
                            <div class="modal-footer btm-action-btn-fl">
                                <button class="btn btn-primary" v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0" id="importFileBtn" v-on:click="loadWorkOrder('program')"> <i class="fp-submit"> </i> Submit</button>
                                <button class="btn btn-primary" v-else id="importFileBtn" v-on:click="redirectToItem"> <i class="fp-submit"> </i> Continue</button>
                                <button type="button" class="btn btn-secondary" v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0" v-on:click="loadWorkOrder('program_skip')">SKIP</button>
                            </div>
                            <!-- <div v-else class="modal-footer btm-action-btn-fl">
                                <button type="button" class="btn btn-secondary" v-on:click="redirectToItem">Continue</button>
                            </div> -->
                        </div>
                        <!-- <div v-if="selectedProgramArr && selectedProgramArr.length > 0 && displayLineItem==true">
                            These are the selected programs to be triggered:
                            <div class="clearfix"></div>
                            <template>
                                <div class="btn-groups badge-buttons text-left mb-3">
                                    <div class="">
                                        <div v-for="(pr,prkey) in selectedProgramArr" :key="prkey" id="divTabMenu" class="btn-group" role="group" aria-label="Basic example">
                                            &nbsp;
                                            <button  type="button" id="geteltsbconfig" class="btn btn-primary"> {{pr.program}} </button>
                                        </div>

                                    </div>
                                </div>
                            </template>
                        </div> -->
                        <div class="work-order-create-section mt-4" v-if="displayLineItem==true">
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm">
                                    <thead>
                                        <tr class="table-primary">
                                            <th class="require" style="width:200px;">#Line</th>
                                            <th class="require" v-if="!assetRequired" style="width:400px;">Unit</th>
                                            <th class="require" style="width:400px;">VMRS</th>
                                            <th class="require" style="width:400px;">Task</th>
                                            <!-- <th style="width:400px;">Reason</th> -->
                                            <th style="width:400px;">Billable</th>
                                            <th style="width:400px;">Program</th>
                                            <!-- <th style="width:400px;">Part Fail</th> -->
                                            <th>Status</th>
                                            <th style="width:200px">Sublet</th>
                                            <th style="width:100px;"></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="taskArr.length == 0">
                                        <tr>
                                            <td colspan="8" class="text-center">
                                                No Line Item Added
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <template v-for="(task, index) in taskArr">
                                            <tr :id="'showRow'+index" :key="index" class="component-row">
                                                <td>
                                                    <input type="text" class="form-control" v-model="task.line_number" :id="'line_number'+index" placeholder="Line Number" name="line_number" @keypress="isIntegerCheck($event)">
                                                </td>
                                                <td v-if="!assetRequired">
                                                    <v-select v-model="task.unit_id" :id="'unit_id'+index" name="unit_id" label="unit_no" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Search Unit" class="custom-ci-auto-search">
                                                        <template slot="no-options">
                                                            Search Unit Number...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.unit_no }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.unit_no }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select v-model="task.component_category_id" class="close-remove" name="component_category_id" placeholder="Select VMRS." label="text" :options="vmrsArr" :id="'component_category_id'+index" @search="onSearchVMRS" :filterable="false" :disabled="task.disable_task" @input="selectVmrs(task.component_category_id,index)">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select v-model="task.taskid" class="close-remove" name="taskid" placeholder="Select Task." label="text" :options="workOrderTaskArr" :id="'taskid'+index" :disabled="task.disable_task || task.disable_task_id" @input="fetchStdRepairTime(index)">
                                                    </v-select>
                                                </td>
                                                <!-- <td>
                                                    <v-select v-model="task.wi_reason_id" class="close-remove" name="wi_reason_id" placeholder="Select Reason." label="text" :options="reasonArr" :disabled="task.disable_task">
                                                    </v-select>
                                                </td> -->
                                                <td>
                                                    <v-select v-model="task.billable_code" class="close-remove" name="billable_code" placeholder="Select Billable." label="text" :options="billableCodeArr" :id="'billable_code'+index" :disabled="task.disable_billable || !assetRequired" @input="changeBillableCode($event,index)">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select v-model="task.program_id" :id="'program_id'+index" name="program_id" label="text" :filterable="false" :options="programArr" @search="onSearchProgram" placeholder="Search Program" class="custom-ci-auto-search" @change="onProgramChange(task.program_id,index)">
                                                        <template slot="no-options">
                                                            Search Program Name...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <!-- <td>
                                                    <v-select v-model="task.defect_id" class="close-remove" name="defect_id" placeholder="Select Standard Defect." label="text" :options="standardDefectsArr" :disabled="task.disable_task">
                                                    </v-select>
                                                </td> -->
                                                <td>
                                                    <v-select v-model="task.woistatus" name="woistatus" placeholder="Select Status." label="text" class="close-remove"
                                                    :options="woiStatusArr" :id="'woistatus'+index" @change="statusChange($event,index)"> <!-- :disabled="task.disable_task" -->
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <!-- <p> {{ ( task.issublet == true )?'Yes':'No' }} </p> -->
                                                    <div class="ml-3 custom-checkbox">
                                                        <label class="checkbox-custom">
                                                            <input type="checkbox" :value="task.issublet" :id="'issublet'+index" v-model="task.issublet" :disabled="task.disable_task || disableSubletCheckbox" @input="onSubletSelect(index,$event)">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </td>
                                                <td class="valign-middle pull-left" style="width:50px;">
                                                    <template v-if="role.toLowerCase() == 'technician'">
                                                        <template> <!-- v-if="task.wo_item_created_by != undefined && task.wo_item_created_by === loggedInUser.value" -->
                                                            <a v-on:click="removeLine('task',index)"> <i class="fp-close color-red close-icon"> </i></a> <!-- v-show=" canDeleteWoLineItem === true " -->
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <a v-show=" canDeleteWoLineItem === true " v-on:click="removeLine('task',index)"> <i class="fp-close color-red close-icon"> </i></a>
                                                    </template>
                                                    <i v-bind:class="[(index === activeLineItemIdx) ? 'fp-up-arrow' : 'fp-down-arrow']" v-on:click=" activeLineItemIdx = (activeLineItemIdx === index)?'':index; clearService(index)" style="font-size:23px;"> </i>
                                                </td>
                                            </tr>
                                            <tr :id="'collapseRow'+index" v-bind:class="[(index === activeLineItemIdx) ? '' : 'accordion-btm-row']" :key="'collapseRow'+index">
                                                <td colspan="8">
                                                    <div class="form-row" v-if="assetRequired">
                                                        <div class="col form-group">
                                                            <label class="control-label">Complaint:</label>
                                                            <textarea rows="3" v-model="task.woicomplaint" class="form-control" spellcheck="true" :id="'woicomplaint'+index"></textarea> <!-- :disabled="task.disable_task" -->
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label">Cause:</label>
                                                            <textarea rows="3" v-model="task.woicause" class="form-control" spellcheck="true" :id="'woicause'+index"></textarea> <!-- :disabled="task.disable_task" -->
                                                        </div>
                                                        <div class="col form-group">
                                                            <label class="control-label">Correction:</label>
                                                            <textarea rows="3" v-model="task.woicorrection" class="form-control" spellcheck="true" :id="'woicorrection'+index"></textarea> <!-- :disabled="task.disable_task" -->
                                                        </div>
                                                    </div>

                                                    <div class="form-row">
                                                        <!-- <div class="col-md-3 form-group">
                                                            <label> Program </label>
                                                            <v-select v-model="task.program_id" :id="'program_id'+index" name="program_id" label="text" :filterable="false" :options="programArr" @search="onSearchProgram" placeholder="Search Program" class="custom-ci-auto-search">
                                                                <template slot="no-options">
                                                                    Search Program Name...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div> -->
                                                        <div class="col-md-3 form-group">
                                                            <label> Reason </label>
                                                                <v-select v-model="task.wi_reason_id" class="close-remove" name="wi_reason_id" placeholder="Select Reason." label="text" :options="reasonArr" :disabled="task.disable_task">
                                                                </v-select>
                                                        </div>
                                                        <div class="col-md-3 form-group">
                                                            <label> Part Fail </label>
                                                                <v-select v-model="task.defect_id" class="close-remove" name="defect_id" placeholder="Select Standard Defect." label="text" :options="standardDefectsArr" :disabled="task.disable_task">
                                                                </v-select>
                                                        </div>
                                                        <div class="col-md-3 form-group">
                                                            <label> Warranty </label>
                                                                <v-select v-model="task.warranty_id" class="" name="warranty_id" placeholder="Select Warranty." label="text" :options="task.warrantyArr" @input="task.available_warranty_msg = ''">
                                                                </v-select>
                                                                <span style="color:green" v-if="task.available_warranty_msg !='' && (task.warranty_id == '' || task.warranty_id == null)">{{task.available_warranty_msg}}</span>
                                                        </div>
                                                        <!-- <div class="col form-group">
                                                            <label>&nbsp;</label>
                                                            <div class="custom-checkbox">
                                                                <label class="checkbox-custom">
                                                                    Is Sublet
                                                                    <input type="checkbox" :value="task.issublet" :id="'issublet'+index" v-model="task.issublet" :disabled="task.disable_task || disableSubletCheckbox" @input="onSubletSelect(index,$event)">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                    <div class="form-row">
                                                        <!-- <div class="col form-group" v-show="task.issublet == true">
                                                            <label class="require"> #PO </label>
                                                            <input type="text" class="form-control" v-model="task.po_number" :id="'po_number'+index" placeholder="Sublet PO Number" name="po_number" :disabled="task.purchaseorderid != null && task.purchaseorderid != ''" @blur="po_number = leavepoFocus($event,index)" @keypress="isIntegerCheck($event)">
                                                            <div class="field-error">{{ task.po_error_msg }}</div>
                                                        </div> -->
                                                        <template v-if="!assetRequired">
                                                        <!-- <template v-if="task.purchaseorderid != null && task.issublet == true"> -->
                                                        <template v-if="task.issublet == true">
                                                          <div class="col form-group">
                                                              <label>Vendor PO </label>
                                                              <v-select v-model="task.purchaseorderid" :id="'vendorpo'+index" name="purchaseorderid" label="text" :filterable="false" :options="purchaseOrderArr" @search="onSearchPurchaseOrder" placeholder="Select Purchase Order" class="custom-ci-auto-search" :disabled="task.disable_po_sublet" @input="selectVendorPo(task.purchaseorderid,index)">
                                                                  <template slot="no-options">
                                                                      Search Purchase Order...
                                                                  </template>
                                                                  <template slot="option" slot-scope="option">
                                                                      <div class="d-center">
                                                                          {{ option.text }}
                                                                      </div>
                                                                  </template>
                                                                  <template slot="selected-option" slot-scope="option">
                                                                      <div class="selected d-center">
                                                                          {{ option.text }}
                                                                      </div>
                                                                  </template>
                                                              </v-select>
                                                          </div>
                                                        </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="task.issublet == true">
                                                                <div class="col form-group">
                                                                <label>Vendor PO </label>
                                                                <v-select v-model="task.purchaseorderid" :id="'vendorpo'+index" name="purchaseorderid" label="text" :filterable="false" :options="purchaseOrderArr" @search="onSearchPurchaseOrder" placeholder="Select Purchase Order" class="custom-ci-auto-search" :disabled="task.disable_vendor_sublet" @change="onPOSelect(task.purchaseorderid,index)">
                                                                    <template slot="no-options">
                                                                        Search Purchase Order...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                            </div>
                                                            </template>
                                                        </template>

                                                        <div class="col form-group" v-show="task.issublet == true">
                                                            <label> Vendor </label>
                                                            <v-select v-model="task.vendorid" :id="'vendorid'+index" name="vendorid" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Search Vendor Code or Name" class="custom-ci-auto-search" :disabled="task.disable_vendor_sublet" @input="onChangeVendor(task.vendorid,index)">
                                                                <template slot="no-options">
                                                                    Search Vendor Code or Name...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                        <div class="col form-group" v-show="task.issublet == true">
                                                            <label> Sublet Amount </label>
                                                            <input type="text" class="form-control" @blur="task.sublet_amount = leaveFocus($event)"
                                                            @focus="task.sublet_amount = enterVal($event)" v-model="task.sublet_amount" :id="'sublet_amount'+index" placeholder="Sublet Amount" name="sublet_amount" @keypress="isAmountCheck($event)" :disabled="task.disable_amount_sublet">
                                                        </div>
                                                        <div class="col form-group" v-if="task.billId != null">
                                                            <label> Vendor Invoice </label>
                                                            <v-select v-model="task.billId" :id="'bill_id'+index" @input="selectVendorPo(task.billId,index)" name="billId" label="text" :filterable="false" :options="billArr" @search="onSearchBill" placeholder="Select Vendor Invoice" class="custom-ci-auto-search" :disabled="task.disable_sublet">
                                                                <template slot="no-options">
                                                                    Search Vendor Invoice...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                        {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>

                                                    <div class="form-row">

                                                        <div class="col-sm-2 form-group">
                                                            <label class="" v-if="task.issublet == true"> SRT </label>
                                                            <label class="require" v-else> SRT </label>
                                                            <input type="text" class="form-control" @blur="task.std_repair_time = leaveFocus($event)"
                                                            @focus="task.std_repair_time = enterVal($event)" v-model="task.std_repair_time" :id="'std_repair_time'+index" placeholder="Standard Repair Time" :name="'std_repair_time'+index" @keypress="isAmountCheck($event)">
                                                        </div>
                                                        <!-- <div class="col-sm-2 form-group">
                                                            <label class="require"> ETC </label>
                                                            <input type="text" class="form-control" @blur="task.est_repair_time = leaveFocus($event)"
                                                            @focus="task.est_repair_time = enterVal($event)" v-model="task.est_repair_time" :id="'est_repair_time'+index" placeholder="Estimated Time of Completion" :name="'est_repair_time'+index" @keypress="isAmountCheck($event)">
                                                        </div> -->
                                                        <div class="col-sm-2 form-group">
                                                            <label :class="requireEtc"> ETC </label>
                                                            <div class="input-group">
                                                                <date-picker placeholder="MM/DD/YYYY" :id="'est_repair_time'+index" :name="'est_repair_time'+index" v-model="task.est_repair_time" :config="optionsDateOnly" aria-describedby="basic-addon3" class='cal-icon' @input="addEtcDate(task,index)"></date-picker>
                                                                <label for="est_repair_time" class="fp-calendar input-calender-icon"></label>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-3 form-group" v-if="task.etcExtend">
                                                            <label class="require"> ETC Reason </label>
                                                            <small v-if="task.etc_reason" style="float: right;">
                                                             ( {{ 250 - task.etc_reason.length }} Characters left )
                                                            </small>
                                                            <input type="text" class="form-control"
                                                            v-model="task.etc_reason" :id="'etc_reason'+index" placeholder="ETC Reason" :name="'etc_reason'+index" maxlength="250">
                                                        </div>

                                                    </div>

                                                    <div class="form-row">
                                                        <div class="col-sm-6 pro-wo-view" v-if="task.vendor_estimate_no">
                                                            <label class="control-label"> Vendor Estimate</label>
                                                            <div class="list-view">
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.vendor_estimate_no">
                                                                    <label class="col"> #Estimate: </label>
                                                                    <span class="col"> <router-link class="color-blue"  v-bind:to="{name: 'VendorEstimateView',params:{id:task.vendor_est_id}}">{{task.vendor_estimate_no}}</router-link>  </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.sent_status">
                                                                    <label class="col"> Sent Status: </label>
                                                                    <span class="col"> {{titleCase(task.sent_status)}} </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.vendor_estimate_part_amount">
                                                                    <label class="col"> Parts Amount: </label>
                                                                    <span class="col"> {{amountFormat(task.vendor_estimate_part_amount)}} </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.vendor_estimate_labor_amount">
                                                                    <label class="col"> Labor Amount: </label>
                                                                    <span class="col"> {{amountFormat(task.vendor_estimate_labor_amount)}} </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6 pro-wo-view" v-if="task.cust_estimate_no">
                                                            <label> Customer Estimate</label>
                                                            <div class="pro-wo-view-block">
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.cust_estimate_no">
                                                                    <label class="col"> #Estimate: </label>
                                                                    <span class="col"> <router-link class="color-blue"  v-bind:to="{name:'CustomerEstimateView',params:{id:task.cust_est_id}}">{{task.cust_estimate_no}} </router-link> </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.cust_sent_status">
                                                                    <label class="col"> Sent Status: </label>
                                                                    <span class="col"> {{titleCase(task.cust_sent_status)}} </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.cust_estimate_part_amount">
                                                                    <label class="col"> Parts Amount: </label>
                                                                    <span class="col"> {{amountFormat(task.cust_estimate_part_amount)}} </span>
                                                                </p>
                                                                <p class="row form-group border-bottom pb-2 pl-3 pr-3" v-if="task.cust_estimate_labor_amount">
                                                                    <label class="col"> Labor Amount: </label>
                                                                    <span class="col"> {{amountFormat(task.cust_estimate_labor_amount)}} </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="field-error mb-3" :id="'common_error_msg' + index"></div>
                                                    <div class="containerTab">
                                                        <div id="divTabMenu" class="tabs">
                                                            <a id="getPastReservationList" v-on:click=" showTab='labor', laborActive = '', serviceTaskActive = 'active', partActive = '',activityActive = ''" :class="' '+ serviceTaskActive">  Labor</a>
                                                            <a id="getCurrentReservationList" v-on:click=" showTab='part', laborActive = 'active', serviceTaskActive = '', partActive = '',activityActive = ''" :class="' '+ laborActive">  Parts</a>
                                                            <!--a id="getPendingReservationList" v-on:click="showComments" :class="' '+ partActive">  Comments</a-->
                                                            <a id="activityTab" v-if="role != 'technician'" v-on:click="showActivities(index)" :class="' '+ activityActive">  Activity</a>
                                                        </div>
                                                        <div class="tabcontent p-0" :id="'addLabor'+index">
                                                            <div class="hiddenRow" v-if="showTab == 'labor'">
                                                                <div class="text-right">
                                                                    <template v-if="role == 'technician'">
                                                                    <template v-if="task.labor_found == 1">
                                                                        <template v-if="task.woistatus != null && task.woistatus.value != 'closed' && task.issublet == false">
                                                                            <div class="add-remove-filter-btn start-end-time-btn d-inline-block">
                                                                                <a v-show="canAddLaborActivityLog === true" class="color-blue log-time-btn mt-2 mb-2 mr-3 d-inline-block" href="javascript:void(0)" v-on:click="startStopTimeNew(task.task_labor,task.log_btn_title,index)">
                                                                                    <i class="fp-reminder mr-1"></i>{{ task.log_btn_title }}
                                                                                </a>
                                                                            </div>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        <!-- <template v-if="!task.disable_task && task.labor_found == 1"> -->
                                                                        <template v-if="task.woistatus != null && task.woistatus.value != 'closed' && task.issublet == false">
                                                                            <div class="add-remove-filter-btn start-end-time-btn d-inline-block">
                                                                                <a v-show="canAddLaborActivityLog === true" class="color-blue log-time-btn mt-2 mb-2 mr-3 d-inline-block" href="javascript:void(0)" v-on:click="startStopTimeClick('new',task.log_btn_title,index)">
                                                                                    <i class="fp-reminder mr-1"></i>{{ task.log_btn_title }}
                                                                                </a>
                                                                            </div>
                                                                        </template>
                                                                        <!-- </template> -->
                                                                    </template>
                                                                </template>
                                                                <template v-if="task.issublet == false">
                                                                    <template class="order-link-text">
                                                                        <template v-if="role.toLowerCase() == 'technician'">
                                                                            <template> <!-- v-if="!task.disable_task" -->
                                                                                <a v-on:click=" taskValidations('labor',index); clearLabor(); showActiveTaskLabor = (showActiveTaskLabor == 'addLabor'+index)?'':'addLabor'+index" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block">
                                                                                    <i class="fp-add font-weight-bold add-icon"></i> Add
                                                                                </a>
                                                                            </template>
                                                                        </template>
                                                                        <template v-else>
                                                                            <a v-on:click=" taskValidations('labor',index); showActiveTaskLabor = (showActiveTaskLabor == 'addLabor'+index)?'':'addLabor'+index" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block">
                                                                                <i class="fp-add font-weight-bold add-icon"></i> Add
                                                                            </a>
                                                                        </template>
                                                                    </template>
                                                                </template>

                                                                </div>
                                                                <div class="table-responsive-sm">
                                                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                                                        <thead>
                                                                            <tr class="table-primary">
                                                                                <th style="width:300px;"> Technician </th>
                                                                                <th> Description </th>
                                                                                <th class="text-right"> Hours </th>
                                                                                <th class="text-right" v-show="canViewWoSummary == true"> Rate </th>
                                                                                <th class="text-right" v-show="canViewWoSummary == true"> Total </th>
                                                                                <th class="text-center">Action </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-if=" showActiveTaskLabor == 'addLabor'+index ">
                                                                                <tr>
                                                                                    <td>
                                                                                        <v-select v-model="serviceTaskLabor" name="serviceTaskLabor" :id="'serviceTaskLabor'+index" label="text" :filterable="false" :options="techArr" @search="onSearchTechnician" placeholder="Select Labor" class="close-remove custom-ci-auto-search contract-data" :disabled="disableTechnicianField">
                                                                                            <template slot="no-options">
                                                                                                Search Labor...
                                                                                            </template>
                                                                                            <template slot="option" slot-scope="option">
                                                                                                <div class="d-center">
                                                                                                    {{ option.text }}
                                                                                                </div>
                                                                                            </template>
                                                                                            <template slot="selected-option" slot-scope="option">
                                                                                                <div class="selected d-center">
                                                                                                    {{ option.text }}
                                                                                                </div>
                                                                                            </template>
                                                                                        </v-select>
                                                                                        <div class="field-error">{{ serviceTaskLabor_error_msg }}</div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <textarea rows="1" class="form-control rounded-0" v-model="labor_description" name="labor_description" spellcheck="false"></textarea>
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="number" placeholder="Hours" v-model="serviceTaskLaborHour" :id="'serviceTaskLaborHour' + index" v-on:keyup="calculateSubTotalForLabor()" name="serviceTaskLaborHour" class="form-control text-right" @keypress="isAmountCheck($event)" :disabled="disableTechnicianField">
                                                                                        <div class="field-error">{{ serviceTaskLaborHour_error_msg }}</div>
                                                                                    </td>
                                                                                    <td v-show="canViewWoSummary == true">
                                                                                        <div class="input-group">
                                                                                            <div class="input-group-prepend">
                                                                                                <span class="input-group-text" id="basic-addon4">$</span>
                                                                                            </div>
                                                                                            <input placeholder="Rate" v-model="serviceTaskLaborHourRate"
                                                                                            @blur="serviceTaskLaborHourRate = leaveFocus($event)"
                                                                                            @focus="serviceTaskLaborHourRate = enterVal($event)"
                                                                                            id="serviceTaskLaborHourRate" v-on:keyup="calculateSubTotalForLabor()"
                                                                                            name="serviceTaskLaborHourRate" class="form-control text-right" :disabled="disableLineItemLabourRate" @keypress="isAmountCheck($event)">
                                                                                        </div>
                                                                                        <div class="field-error">{{ serviceTaskLaborHourRate_error_msg }}</div>
                                                                                    </td>
                                                                                    <td class="valign-middle" v-show="canViewWoSummary == true">
                                                                                        {{amountFormat(serviceTaskLaborSubTotal)}}
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        <button v-if="serviceTaskLaborIndex == 'create'" class="btn btn-primary" v-on:click="saveServiceTaskLabor(serviceTaskLabor, task.taskid, index)">
                                                                                            <i class="fp-save"></i> Save </button>
                                                                                        <button v-if="serviceTaskLaborIndex != 'create'" class="btn btn-primary" v-on:click="updateWoLabor(index)">
                                                                                            <i class="fp-save"></i> Update </button>
                                                                                        <button v-if="serviceTaskLaborIndex == 'create'" class="btn btn-secondary" v-on:click="clearLabor()">
                                                                                            <i class="fp-refresh"></i> Reset </button>
                                                                                        <button v-if="serviceTaskLaborIndex != 'create'" class="btn btn-tertiary" v-on:click="showActiveTaskLabor = ''; clearLabor()">
                                                                                            <i class="fp-close"></i> Cancel </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                            <template v-else-if="task.hasLabor === true">
                                                                                <tr v-for="(labor, ind) in laborArr" :key="ind">
                                                                                    <template v-if="(labor.service_task_id != null) && (labor.service_task_id.index == index)">
                                                                                        <td v-if="labor.laborid != null">
                                                                                            <p class="m-0"> {{labor.laborid.text}} </p>
                                                                                        </td>
                                                                                        <td v-else>
                                                                                            <p class="m-0"> Labor Not Added </p>
                                                                                        </td>
                                                                                        <td>{{labor.labordescription}} </td>
                                                                                        <td class="text-right"> {{labor.laborhours}} Hrs </td>
                                                                                        <td class="text-right" v-show="canViewWoSummary == true">{{amountFormat(labor.laborhourrate)}} </td>
                                                                                        <td class="text-right" v-show="canViewWoSummary == true">{{amountFormat(labor.laborsubtotal)}}</td>
                                                                                        <td class="text-center">
                                                                                            <template v-if="role == 'technician'">

                                                                                                <template v-if="(!task.disable_task && loggedInUser != undefined && labor.laborid != null && labor.laborid.value === loggedInUser.value) || ( canUpdateWoLabor === true ) || ( canDeleteWoLabor === true ) || (!task.disable_task && labor.labor_created_by != undefined && labor.labor_created_by === loggedInUser.value)">
                                                                                                    <button style="line-height:12px;margin-right:10px;" v-show=" canUpdateWoLabor === true " v-bind:class="[(ind === serviceTaskLaborIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('labor',ind, index)">
                                                                                                        <i class="fp-edit-icon color-blue" style="font-size:15px"> </i>
                                                                                                    </button>
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoLabor === true " v-bind:class="[(ind === serviceTaskLaborIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="removeLine('labor',ind)">
                                                                                                        <i class="fp-close color-red" style="font-size:12px"> </i>
                                                                                                    </button>
                                                                                                </template>

                                                                                            </template>
                                                                                            <template v-else>

                                                                                                <template v-if="labor.lid == 0">
                                                                                                    <template v-if="task.issublet == false && workOrderEstimateId != undefined && workOrderEstimateId != null && workOrderEstimateId != 0">
                                                                                                        <button style="line-height:12px;margin-right:10px;" v-show="canUpdateWoLabor === true" v-bind:class="[(ind === serviceTaskLaborIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('labor',ind, index)">
                                                                                                            <i class="fp-edit-icon color-blue" style="font-size:15px"> </i>
                                                                                                        </button>
                                                                                                    </template>
                                                                                                    <template v-else>
                                                                                                        <button style="line-height:12px;margin-right:10px;" v-show="canUpdateWoLabor === true" class="disable-btn" v-on:click="editServiceTask('labor',ind, index)">
                                                                                                            <i class="fp-edit-icon color-blue" style="font-size:15px"> </i>
                                                                                                        </button>
                                                                                                    </template>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <button style="line-height:12px;margin-right:10px;" v-show="canUpdateWoLabor === true" v-bind:class="[(ind === serviceTaskLaborIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('labor',ind, index)">
                                                                                                        <i class="fp-edit-icon color-blue" style="font-size:15px"> </i>
                                                                                                    </button>
                                                                                                </template>

                                                                                                <template v-if="index === currentTaskIndex && serviceTaskLaborIndex != 'create'">
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoLabor === true " class="disable-btn" v-on:click="removeLine('labor',ind)">
                                                                                                        <i class="fp-close color-red" style="font-size:12px"> </i>
                                                                                                    </button>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoLabor === true " v-bind:class="[(ind === serviceTaskLaborIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="removeLine('labor',ind)">
                                                                                                        <i class="fp-close color-red" style="font-size:12px"> </i>
                                                                                                    </button>
                                                                                                </template>

                                                                                            </template>
                                                                                        </td>
                                                                                    </template>
                                                                                </tr>
                                                                            </template>
                                                                            <template v-else>
                                                                                <tr>
                                                                                    <td colspan="6" class="text-center">
                                                                                        No labor available
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <!-- <template v-if="(role == 'technician' && task.labor_found == 1) || (role != 'technician')"> -->

                                                                    <!-- <template v-if="(role == 'technician' && task.task_labor_user === loggedInUser.value) || (role != 'technician')"> -->
                                                                        <template v-show="canAddLaborActivityLog === true && task.log_found == 1">
                                                                            <div class="form-row">
                                                                                <div class="col-md-6">
                                                                                    <h4 class="color-blue mt-4"> Time Log </h4>
                                                                                    <div class="table-responsive-sm">
                                                                                        <table aria-describedby="table" class="table table-sm table-striped">
                                                                                            <thead>
                                                                                                <tr class="table-primary">
                                                                                                    <th> Technician </th>
                                                                                                    <th> Start Time </th>
                                                                                                    <th> End Time </th>
                                                                                                    <th> Duration </th>
                                                                                                    <th v-if="(role == 'technician' && task.task_labor_user === loggedInUser.value)"> Action </th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>

                                                                                                <template v-if="task.log_found == 0">
                                                                                                    <td colspan="5" style="text-align: center"> No time log available </td>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <template v-for="(labor, index) in laborHourArr">
                                                                                                        <tr v-if="labor.woiId == task.woiId" v-bind:key="index">
                                                                                                            <td> {{labor.labor_name}} </td>
                                                                                                            <td> {{labor.start_time}} </td>
                                                                                                            <td> {{labor.end_time}} </td>
                                                                                                            <td> {{labor.duration}} </td>
                                                                                                            <td v-if="(role == 'technician' && labor.laborid === loggedInUser.value)">
                                                                                                                <template v-if="labor.log_status != undefined">
                                                                                                                    <template v-if="labor.log_status == 'wip' || labor.log_status === 'done' || labor.log_status == 'disapprove'">
                                                                                                                        <!-- <button class="btn" v-on:click="removeLine('log',index)"> <i class="hi-icon icon-flicon"> </i></button> -->
                                                                                                                        <i v-on:click="removeLine('log',index)" class="fp-delete cursor-pointer"> </i>
                                                                                                                    </template>
                                                                                                                </template>
                                                                                                            </td>
                                                                                                            <!-- <td v-if="labor.labor_id == task.task_labor"><i v-on:click="removeLine('log',index)" class="fp-delete cursor-pointer"> </i></td> -->
                                                                                                        </tr>
                                                                                                    </template>
                                                                                                </template>

                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    <!-- </template> -->
                                                                <!-- </template> -->
                                                            </div>
                                                        </div>
                                                        <div class="tabcontent p-0" :id="'addComponent'+index">
                                                            <div class="hiddenRow" v-if="showTab === 'part'">
                                                                <template v-if="task.issublet == false">
                                                                    <div class="order-link-text text-right" v-show=" canAddWoComp === true ">
                                                                        <div class="col-md-3 form-group mt-2 mb-2 d-inline-block">
                                                                            <div class="custom-checkbox">
                                                                                <label class="checkbox-custom">
                                                                                    Use Default Warehouse
                                                                                    <input type="checkbox" :value="task.default_warehouse" :id="'default_warehouse'+index" v-model="task.default_warehouse" @change="onselectwarehouse()">
                                                                                    <span class="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <template v-if="role == 'technician'">
                                                                            <template> <!-- v-if="!task.disable_task" -->
                                                                                <a v-if="serviceTaskCompIndex == 'create'" v-on:click="specialPOItems(index)" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"> Special Orders </a>&nbsp;&nbsp;
                                                                                <!-- <a v-on:click=" taskValidations('serviceTaskComp',index); clearServiceTaskComp(index); showActiveTaskLabor = (showActiveTaskLabor == 'addComponent'+index)?'':'addComponent'+index" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"><i class="fp-add font-weight-bold add-icon"></i> Add </a> -->
                                                                                <a v-if="serviceTaskCompIndex == 'create'" v-on:click="partAddLine(index)" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"><i class="fp-add font-weight-bold add-icon"></i> Add </a><!-- Multiple Part Issue Changes -->
                                                                            </template>
                                                                        </template>
                                                                        <template v-else>
                                                                            <a v-if="serviceTaskCompIndex == 'create'" v-on:click="specialPOItems(index)" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"> Special Orders </a>&nbsp;&nbsp;
                                                                            <!-- <a v-on:click=" taskValidations('serviceTaskComp',index); clearServiceTaskComp(index); showActiveTaskLabor = (showActiveTaskLabor == 'addComponent'+index)?'':'addComponent'+index" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"><i class="fp-add font-weight-bold add-icon"></i> Add </a> -->
                                                                            <a v-if="serviceTaskCompIndex == 'create'" v-on:click="partAddLine(index)" href="javascript:void(0)" class="color-blue mt-2 mb-2 d-inline-block"><i class="fp-add font-weight-bold add-icon"></i> Add </a><!-- Multiple Part Issue Changes -->
                                                                        </template>
                                                                    </div>
                                                                </template>
                                                                <div class="table-responsive-sm">
                                                                    <table aria-describedby="table" class="table table-sm table-bordered mt-2">
                                                                        <thead>
                                                                            <tr class="table-primary">
                                                                                <th v-if="showActiveTaskLabor == '' && task.selectedSpItemsArr.length == 0">&nbsp;</th>
                                                                                <th style="width:300px;"> Part name </th>
                                                                                <th>Description</th>
                                                                                <th class="text-right" v-if="showActiveTaskLabor == '' && task.selectedSpItemsArr.length == 0"> Is Issued ?</th>
                                                                                <th class="text-right"> Quantity </th>
                                                                                <th class="text-right" v-show="canViewWoSummary == true"> Rate </th>
                                                                                <th class="text-right" v-show="canViewWoSummary == true"> Total</th>
                                                                                <th class="text-center" style="width:250px"> Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <!-- Multiple Part Issue Changes -->
                                                                            <template v-if="task.isPartAdd != undefined && task.isPartAdd == 1 && showActiveTaskLabor == 'addComponent'+index">
                                                                                <template v-if="task.partAddArr && task.partAddArr.length > 0">
                                                                                    <tr v-for="(pai, paInd) in task.partAddArr" :key="'pai'+paInd">
                                                                                        <template v-if="pai.task_index == index">
                                                                                            <td :key="'part'+paInd">
                                                                                                <v-select v-model="pai.item" name="pai_item" label="text" @input="changePartItem($event,paInd,index,'add_part')" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                                                                                                    <template slot="no-options">
                                                                                                        Search Part...
                                                                                                    </template>
                                                                                                    <template slot="option" slot-scope="option">
                                                                                                        <div class="d-center">
                                                                                                            {{ option.text }}
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template slot="selected-option" slot-scope="option">
                                                                                                        <div class="selected d-center">
                                                                                                            {{ option.text }}
                                                                                                        </div>
                                                                                                    </template>
                                                                                                </v-select>
                                                                                                <div class="field-error">{{ pai.item_error_msg }}</div>
                                                                                            </td>
                                                                                            <td :key="'partDesc'+paInd">
                                                                                                <textarea rows="1" class="form-control" v-model="pai.description" name="pai_description" spellcheck="false"></textarea>
                                                                                            </td>
                                                                                            <td :key="'partQty'+paInd">
                                                                                                <input type="text" placeholder="Quantity" v-model="pai.quantity" id="pai_quantity" v-on:keyup="calculatePartItemTotal(paInd,index)" name="pai_quantity" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                                <div class="field-error">{{ pai.quantity_error_msg }}</div>
                                                                                            </td>
                                                                                            <td v-show="canViewWoSummary == true" :key="'partRate'+paInd">
                                                                                                <div class="input-group">
                                                                                                    <div class="input-group-prepend">
                                                                                                        <span class="input-group-text" id="basic-addon4">$</span>
                                                                                                    </div>
                                                                                                    <input type="text" placeholder="Rate" v-model="pai.comp_cost"
                                                                                                    @blur="pai.comp_cost = leaveFocus($event)"
                                                                                                    @focus="pai.comp_cost = enterVal($event)"
                                                                                                    id="pai_comp_cost" v-on:keyup="calculatePartItemTotal(paInd,index)"
                                                                                                    name="pai_comp_cost" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                                </div>
                                                                                            </td>
                                                                                            <td class="text-right" v-show="canViewWoSummary == true" :key="'partSub'+paInd">
                                                                                                {{amountFormat(pai.comp_subtotal)}}
                                                                                            </td>
                                                                                            <td class="text-center" :key="'partCancel'+paInd">
                                                                                                <button class="btn btn-tertiary" v-on:click="removePartItem(paInd,index)"><i class="fp-close"></i> Cancel </button>
                                                                                            </td>
                                                                                        </template>
                                                                                    </tr>
                                                                                </template>
                                                                            </template>
                                                                            <template v-else-if=" showActiveTaskLabor == 'addComponent'+index">
                                                                                <tr>
                                                                                    <td>
                                                                                        <v-select v-model="serviceTaskComp" name="serviceTaskComp" label="text" :filterable="false" @input="changePartItem($event,serviceTaskCompIndex,index,'change_part')" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                                                                                            <template slot="no-options">
                                                                                                Search Part...
                                                                                            </template>
                                                                                            <template slot="option" slot-scope="option">
                                                                                                <div class="d-center">
                                                                                                    {{ option.text }}
                                                                                                </div>
                                                                                            </template>
                                                                                            <template slot="selected-option" slot-scope="option">
                                                                                                <div class="selected d-center">
                                                                                                    {{ option.text }}
                                                                                                </div>
                                                                                            </template>
                                                                                        </v-select>
                                                                                        <div class="field-error">{{ serviceTaskComp_error_msg }}</div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <textarea rows="1" class="form-control" v-model="comp_description" name="comp_description" spellcheck="false"></textarea>
                                                                                    </td>
                                                                                    <td>
                                                                                        <input type="text" placeholder="Quantity" v-model="serviceTaskCompQuantity" id="serviceTaskCompQuantity" v-on:keyup="calculateSubTotalForComp()" name="serviceTaskCompQuantity" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                        <div class="field-error">{{ serviceTaskQty_error_msg }}</div>
                                                                                    </td>
                                                                                    <td v-show="canViewWoSummary == true">
                                                                                        <div class="input-group">
                                                                                            <div class="input-group-prepend">
                                                                                                <span class="input-group-text" id="basic-addon4">$</span>
                                                                                            </div>
                                                                                            <input type="text" placeholder="Rate" v-model="serviceTaskCompCost"
                                                                                            @blur="serviceTaskCompCost = leaveFocus($event)"
                                                                                            @focus="serviceTaskCompCost = enterVal($event)"
                                                                                            id="serviceTaskCompCost" v-on:keyup="calculateSubTotalForComp()"
                                                                                            name="serviceTaskCompCost" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                        </div>
                                                                                    </td>
                                                                                    <td class="text-right" v-show="canViewWoSummary == true">
                                                                                        {{amountFormat(serviceTaskCompSubTotal)}}
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        <!-- <button class="btn btn-primary" v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index)"><i class="fp-save"></i> Fully Issue Part </button>
                                                                                        <button v-if="serviceTaskCompIndex == 'create'" class="btn btn-secondary" v-on:click="clearServiceTaskComp()"><i class="fp-refresh"></i> Reset </button>
                                                                                        <button v-if="serviceTaskCompIndex != 'create'" class="btn btn-tertiary" v-on:click="showActiveTaskLabor = ''; clearServiceTaskComp()"><i class="fp-close"></i> Cancel </button> -->
                                                                                        <button class="btn btn-tertiary" v-on:click="showActiveTaskLabor = ''; clearServiceTaskComp(index)"><i class="fp-close"></i> Cancel </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                            <template v-else-if="task.isItemModal != undefined && task.isItemModal == 1">
                                                                                <template v-if="task.selectedSpItemsArr && task.selectedSpItemsArr.length > 0">
                                                                                    <tr v-for="(spi, idx) in task.selectedSpItemsArr" :key="'spi'+idx">
                                                                                        <template v-if="spi.task_index == index">
                                                                                        <td :key="'P'+idx">
                                                                                            <v-select v-model="spi.item" name="spi_item" label="text" @input="changeSpecialItem($event,idx,index)" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                                                                                                <template slot="no-options">
                                                                                                    Search Part...
                                                                                                </template>
                                                                                                <template slot="option" slot-scope="option">
                                                                                                    <div class="d-center">
                                                                                                        {{ option.text }}
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template slot="selected-option" slot-scope="option">
                                                                                                    <div class="selected d-center">
                                                                                                        {{ option.text }}
                                                                                                    </div>
                                                                                                </template>
                                                                                            </v-select>
                                                                                            <div class="field-error">{{ spi.item_error_msg }}</div>
                                                                                        </td>
                                                                                        <td :key="'D'+idx">
                                                                                            <textarea rows="1" class="form-control" v-model="spi.description" name="spi_description" spellcheck="false"></textarea>
                                                                                        </td>
                                                                                        <td :key="'Q'+idx">
                                                                                            <input type="text" placeholder="Quantity" v-model="spi.quantity" id="spi_quantity" v-on:keyup="calculateSpItemTotal(idx,index)" name="spi_quantity" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                            <div class="field-error">{{ spi.quantity_error_msg }}</div>
                                                                                        </td>
                                                                                        <td v-show="canViewWoSummary == true" :key="'R'+idx">
                                                                                            <div class="input-group">
                                                                                                <div class="input-group-prepend">
                                                                                                    <span class="input-group-text" id="basic-addon4">$</span>
                                                                                                </div>
                                                                                                <input type="text" placeholder="Rate" v-model="spi.comp_cost"
                                                                                                @blur="spi.comp_cost = leaveFocus($event)"
                                                                                                @focus="spi.comp_cost = enterVal($event)"
                                                                                                id="spi_comp_cost" v-on:keyup="calculateSpItemTotal(idx,index)"
                                                                                                name="spi_comp_cost" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                                                            </div>
                                                                                        </td>
                                                                                        <td class="text-right" v-show="canViewWoSummary == true" :key="'S'+idx">
                                                                                            {{amountFormat(spi.comp_subtotal)}}
                                                                                        </td>
                                                                                        <td class="text-center" :key="'C'+idx">
                                                                                            <button class="btn btn-tertiary" v-on:click="removeSelectedSpItem(idx,index)"><i class="fp-close"></i> Cancel </button>
                                                                                        </td>
                                                                                        </template>
                                                                                    </tr>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <tr>
                                                                                        <td colspan="6" class="text-center">
                                                                                            No parts available
                                                                                        </td>
                                                                                    </tr>
                                                                                </template>
                                                                            </template>
                                                                            <template v-else-if="task.hasComp === true">
                                                                                <tr v-for="(comp, idx) in compArr" :key="'A'+idx">
                                                                                    <template v-if="comp.service_task_id != null && comp.service_task_id.index == index">
                                                                                        <td v-if="showActiveTaskLabor == ''">
                                                                                            <span v-if="comp.is_issued == 0">
                                                                                                <input type="checkbox" :id="'workorderpart'+comp.cid" class="paymentSelect"
                                                                                                        name="workorderpart" :data-id="comp.id" @input="selectComp($event,comp.cid,'part')">
                                                                                            </span>
                                                                                            <span v-else>
                                                                                                &nbsp;
                                                                                            </span>

                                                                                        </td>
                                                                                        <td>{{comp.compid.text}} </td>
                                                                                        <td>{{ comp.compdescription }} </td>
                                                                                        <td class="text-right" v-if="comp.is_issued == 1 && showActiveTaskLabor == ''"> Yes</td>
                                                                                        <td class="text-right" v-else-if ="showActiveTaskLabor == ''"> No</td>
                                                                                        <td class="text-right">{{ comp.compquantity }} Qty </td>
                                                                                        <td v-show="canViewWoSummary == true" class="text-right">{{amountFormat(comp.compcost)}} </td>
                                                                                        <td v-show="canViewWoSummary == true" class="text-right">{{amountFormat(comp.compsubtotal)}} </td>
                                                                                        <td class="text-center">
                                                                                            <template v-if="role == 'technician'">
                                                                                                <template v-if="!task.disable_task || (comp.comp_created_by != undefined && comp.comp_created_by === loggedInUser.value)">
                                                                                                    <button style="line-height:12px;margin-right:10px;" v-show=" canUpdateWoComp === true " v-bind:class="[(idx === serviceTaskCompIndex || task.issublet == true || comp.is_issued == 1) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('component',idx, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoComp === true " v-bind:class="[(idx === serviceTaskCompIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="removeLine('component',idx)"> <i class="fp-close color-red" style="font-size:12px"> </i></button>
                                                                                                </template>
                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <template v-if="comp.cid == 0">
                                                                                                    <template v-if="task.issublet == false && workOrderEstimateId != undefined && workOrderEstimateId != null && workOrderEstimateId != 0">
                                                                                                        <button style="line-height:12px;margin-right:10px;" v-show=" canUpdateWoComp === true " v-bind:class="[(idx === serviceTaskCompIndex || task.issublet == true || comp.is_issued == 1 ) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('component',idx, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                                    </template>
                                                                                                    <template v-else>
                                                                                                        <button style="line-height:12px;margin-right:10px;" v-show=" canUpdateWoComp === true " class="disable-btn" v-on:click="editServiceTask('component',idx, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                                    </template>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <button style="line-height:12px;margin-right:10px;" v-show=" canUpdateWoComp === true " v-bind:class="[(idx === serviceTaskCompIndex || task.issublet == true || comp.is_issued == 1) ? 'disable-btn' : 'p-2']" v-on:click="editServiceTask('component',idx, index)"> <i class="fp-edit-icon color-blue" style="font-size:15px"> </i></button>
                                                                                                </template>
                                                                                                <template v-if="index === currentTaskIndex && serviceTaskCompIndex != 'create'">
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoComp === true " class="disable-btn" v-on:click="removeLine('component',idx)"> <i class="fp-close color-red" style="font-size:12px"> </i></button>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <button style="line-height:12px" v-show=" canDeleteWoComp === true " v-bind:class="[(idx === serviceTaskCompIndex || task.issublet == true ) ? 'disable-btn' : 'p-2']" v-on:click="removeLine('component',idx)"> <i class="fp-close color-red" style="font-size:12px"> </i></button>
                                                                                                </template>
                                                                                            </template>
                                                                                        </td>
                                                                                    </template>
                                                                                </tr>
                                                                            </template>
                                                                            <template v-else>
                                                                                <tr>
                                                                                    <td colspan="6" class="text-center">
                                                                                        No parts available
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                    <!-- Fully Issue Part and Reset Button for Component-->
                                                                    <template>
                                                                        <div class="order-link-text text-right" v-if="selectedCompArr.length != undefined && selectedCompArr.length > 0">
                                                                            <button class="btn btn-primary" v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index,'issue_part')"><i class="fp-save"></i> Fully Issue Part </button>
                                                                            <!-- <button class="btn btn-primary" v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index,'store_part')" v-if="serviceTaskIssued == 0 || serviceTaskIssued == undefined"><i class="fp-save"></i> Submit </button> -->
                                                                            <!-- <button class="btn btn-secondary" v-on:click="clearServiceTaskComp(index)"><i class="fp-refresh"></i> Reset </button> -->
                                                                        </div>
                                                                        <div class="order-link-text text-right" v-else-if="showActiveTaskLabor == 'addComponent'+index || (task.isItemModal != undefined && task.isItemModal == 1)">
                                                                            <button class="btn btn-primary" v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index,'issue_part')"><i class="fp-save"></i> Fully Issue Part </button>
                                                                            <button class="btn btn-primary" v-on:click="saveServiceTaskComp(serviceTaskComp, task.taskid, index,'store_part')" v-if="serviceTaskIssued == 0 || serviceTaskIssued == undefined"><i class="fp-save"></i> Submit </button>
                                                                            <button class="btn btn-secondary" v-on:click="clearServiceTaskComp(index)"><i class="fp-refresh"></i> Reset </button>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="tabcontent p-0" :id="'addComment'+index" v-if="showTab==='comment'">
                                                            <div class="hiddenRow">
                                                            <div class="order-link-text text-right" v-show=" canAddWoComment === true ">
                                                                <template v-if="role == 'technician'">
                                                                    <template v-if="!task.disable_task">
                                                                        <a v-on:click="taskValidations('comment',index); clearComment(); showActiveTaskLabor = (showActiveTaskLabor == 'addComment'+index)?'':'addComment'+index" href="javascript:void(0)" class="color-blue d-inline-block mt-2 mb-2"> <i class="fp-add font-weight-bold add-icon"></i> Add Comment </a>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <a v-on:click="taskValidations('comment',index); clearComment(); showActiveTaskLabor = (showActiveTaskLabor == 'addComment'+index)?'':'addComment'+index" href="javascript:void(0)" class="color-blue d-inline-block mt-2 mb-2"> <i class="fp-add font-weight-bold add-icon"></i> Add Comment </a>
                                                                </template>
                                                            </div>
                                                            <div v-if="showActiveTaskLabor == 'addComment'+index">
                                                            <!-- <template v-if="showActiveTaskLabor == 'addComment'+index">     -->
                                                            <!-- <div>     -->
                                                                <div class="row clear">
                                                                    <div class="col-md-6 form-group">
                                                                        <label class="control-label require" for="comment_type_id">Select Type:</label>
                                                                        <v-select v-model="comment_type_id" name="comment_type_id" placeholder="Select Comment Type" label="text" :options="commentTypeArr">
                                                                        </v-select>
                                                                        <div class="field-error">{{ comment_type_error_msg }}</div>
                                                                    </div>
                                                                    <div class="col-md-6 form-group">
                                                                        <label class="require" for="exampleFormControlTextarea2">Description:</label>
                                                                        <textarea class="form-control rounded-0" v-model="comment" ref="textarea" id="exampleFormControlTextarea2" rows="3" v-on:keyup="process($event)"></textarea>
                                                                        <div class="field-error">{{ comment_error_msg }}</div>
                                                                    </div>
                                                                </div>
                                                                <div class="btn-groups text-right">
                                                                    <button v-on:click="addComment(comment, comment_type_id, task.taskid, index)" class="btn btn-primary mt-4"> <i class="fp-save"> </i>{{submitBtn}}</button>
                                                                </div>
                                                            </div>
                                                            <!-- </template> -->
                                                            <template v-else>
                                                                <div class="comment-box">
                                                                    <div class="comment-list-btm">
                                                                    <template v-if="task.hasComment=== true">
                                                                        <div class="mb-4"><h4> All Comments </h4></div>
                                                                        <ul>
                                                                            <template v-for="(comment,ind) in commentArr">
                                                                                <template v-if="comment.service_task_id.index == index">
                                                                                    <li :key="ind" class="work-order-list">
                                                                                        <span class="labor-icon"> {{ comment.wocBy.substring(0,2).toUpperCase() }} </span>
                                                                                        <div class="comment-details">
                                                                                            <div class="comment-dec"><span class="user">{{comment.wocBy}}</span>({{comment.wocType.text}}) <span>{{comment.wocAt}}</span> </div>
                                                                                            <p>{{comment.woc}}</p>
                                                                                        </div>
                                                                                        <div class="action-btns">
                                                                                            <template v-if="role == 'technician'">
                                                                                                <template v-if="!task.disable_task || (comment.comment_created_by != undefined && comment.comment_created_by === loggedInUser.value)">
                                                                                                    <button v-show=" canUpdateWoComment === true " v-bind:class="[(ind === workOrderCommentIndex) ? 'btn disable-btn' : 'btn']" v-on:click="editComment(comment.wocId, comment.wocType, comment.estimatedwocId, comment.woc, ind, index)"><i class="fp-edit-icons color-blue"   style="font-size:15px" /></button>
                                                                                                    <button v-show=" canDeleteWoComment === true " v-bind:class="[(ind === workOrderCommentIndex) ? 'btn disable-btn' : 'btn']" v-on:click.prevent="removeComment(comment.wocId)"><i class="fp-close color-red" style="font-size:15px" /></button>
                                                                                                </template>
                                                                                            </template>
                                                                                            <template v-else>
                                                                                                <button v-show=" canUpdateWoComment === true " v-bind:class="[(ind === workOrderCommentIndex) ? 'btn disable-btn' : 'btn']" v-on:click="editComment(comment.wocId, comment.wocType, comment.estimatedwocId, comment.woc, ind, index)"><i class="fp-edit-icon color-blue" style="font-size:15px" /></button>
                                                                                                <button v-show=" canDeleteWoComment === true " v-bind:class="[(ind === workOrderCommentIndex) ? 'btn disable-btn' : 'btn']" v-on:click.prevent="removeComment(comment.wocId)"><i class="fp-close color-red" style="font-size:15px" /></button>
                                                                                            </template>
                                                                                        </div>
                                                                                    </li>
                                                                                </template>
                                                                            </template>
                                                                        </ul>
                                                                    </template>
                                                                    <template v-else>
                                                                        <div class="text-center"> No comment available </div>
                                                                    </template>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            </div>
                                                        </div>
                                                        <div class="tabcontent p-0" :id="'activity'+index" v-if="showTab==='activity'">
                                                            <ul class="comment-box activity-list-btm">
                                                                <template v-if="showActivity == 'activity'">
                                                                    <li class="mb-4"><h4> Activity </h4></li>
                                                                    <template v-for="(activity,ind) in activityArr">
                                                                        <template v-if="activity.service_task_index == index">
                                                                            <li :key="ind" class="work-order-list">
                                                                                <span class="labor-icon"> {{ activity.activityBy.substring(0,2).toUpperCase() }} </span>
                                                                                <div class="comment-details">
                                                                                    <div class="comment-dec"><span class="user">{{ activity.activityBy }}</span>({{ activity.activity_type }}) <span>{{ activity.activityAt }}</span> </div>
                                                                                    <template v-for="(notes,notekey) in activity.notes">
                                                                                        <p class="subject-line" :key="notekey" v-if="notes.key=='add'"><span class='updated-value'>{{ notes.val1 }}</span> {{ notes.val2 }}  <span class='updated-value'>{{ notes.val3 }}</span></p>
                                                                                        <p class="subject-line" :key="notekey" v-if="notes.key=='is_added'"><span class='updated-value'>{{ notes.val1 }} </span><span class='updated-value'>{{ notes.val2 }}</span> {{ notes.val3 }}</p>
                                                                                        <p class="subject-line" :key="notekey" v-if="notes.key=='update'"><span class='updated-value'>{{ notes.val1 }}</span> {{ notes.val2 }} <span class='updated-value'>{{ notes.val3 }}</span> {{ notes.val4 }} <span class='updated-value'>{{ notes.val5 }}</span></p>
                                                                                        <p class="subject-line" :key="notekey" v-if="notes.key=='removed'"><span class='updated-value'>{{ notes.val1 }}</span><span class='updated-value'> {{ notes.val2 }}</span> {{ notes.val3 }}</p>
                                                                                        <p class="subject-line" :key="notekey" v-if="notes.key=='delete'"><span class='updated-value'> {{ notes.val1 }}</span> {{ notes.val2 }} <span class='updated-value'>{{ notes.val3 }}</span></p>
                                                                                    </template>
                                                                                </div>
                                                                            </li>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <li class="text-center"> No activity available </li>
                                                                </template>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <!-- Special PO Items Modal -->
                                                    <div class="modal fade select-special-item" :id="'select-special-item'+index" :ref="'select-special-item'+index" data-backdrop="static" data-keyboard="false" aria-labelledby="selectSpecialItem" aria-hidden="true">
                                                        <div class="modal-dialog modal-lg" role="document">
                                                            <div class="modal-content">
                                                                <div class="modal-header">
                                                                    <h5 class="modal-title">Select Special Order Item</h5>
                                                                    <button type="button" class="close" :id="'btnPOModalClose' + index" v-on:click="hideSpecialItemsModal(index)">&times;</button>
                                                                </div>
                                                                <div class="modal-body">
                                                                    <div class="form-row" v-if="task.specialUnitNo != undefined && task.specialUnitNo != ''">
                                                                        <div class="col-sm-6 form-group">
                                                                            <label class="control-label"  for="specialUnitDetail">Unit:</label>
                                                                            <span class="col">{{task.specialUnitNo}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <template v-if="task.specialItemsArr != undefined">
                                                                        <div class="table-responsive-sm">
                                                                            <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                                                <thead>
                                                                                    <tr class="table-primary">
                                                                                        <th style="width:10px;"></th>
                                                                                        <th> PO# </th>
                                                                                        <th> Location </th>
                                                                                        <th> Item </th>
                                                                                        <th> Description </th>
                                                                                        <th> Order Qty </th>
                                                                                        <th> Received Qty </th>
                                                                                        <th> Available Qty </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <template v-if="task.specialItemsArr.length > 0">
                                                                                        <tr v-for="(spItem, spIndex) in task.specialItemsArr" :key="spIndex">
                                                                                            <td scope="col" style="width:10px;">
                                                                                                <input type="checkbox" :id="'itemSpSelect' + spIndex" @input="clickRows($event,spItem,spIndex,index)"/>
                                                                                            </td>
                                                                                            <td> {{spItem.po_no}} </td>
                                                                                            <td> {{spItem.loc_code}} </td>
                                                                                            <td> {{spItem.item_code}} </td>
                                                                                            <td> {{spItem.item_name}} </td>
                                                                                            <td> {{spItem.po_quantity}} </td>
                                                                                            <td> {{spItem.received_quantity}} </td>
                                                                                            <td> {{spItem.available_qty}} </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <tr>
                                                                                            <td colspan="7" class="no-data-field"> No Part Available </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div class="field-error ml-0">{{ task.isItemErrorMsg }}</div>
                                                                    </template>
                                                                </div>
                                                                <div class="modal-footer">
                                                                    <button class="btn btn-primary" :id="'btnPOModalAdd' + index" v-on:click="addSpecialPOItem(index)"> Add </button>
                                                                    <button class="btn btn-tertiary" :id="'btnPOModalCancel' + index" v-on:click="hideSpecialItemsModal(index)"> Cancel </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="field-error">{{ error_msg_part_missing }}</div>
                        </div>
                        <hr class="light-hr">
                        <div class="btn-groups" v-if="displayLineItem==true">
                            <button id="add_wo_line_item" v-show=" canAddWoLineItem === true " type="submit" @click="taskchange($event)" class="btn btn-primary">
                                <i class="fp-add"> </i> Add Line Item
                            </button>
                        </div>
                        <template v-if="( canViewWoSummary == true && displayLineItem == true )">
                            <hr class="light-hr"/>
                            <div class="order-summary mt-4">
                                <div class="row">
                                    <div class="col-md-5 offset-md-7">
                                        <label class="font-bold"> SUMMARY </label>
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <tr class="table-secondary">
                                                <td>Labor:</td>
                                                <td class="text-right">{{amountFormat(labor_total)}}</td>
                                            </tr>
                                            <tr>
                                                <td>Parts:</td>
                                                <td class="text-right">{{amountFormat(parts_total)}}</td>
                                            </tr>
                                            <tr>
                                                <td>Shop Supplies:</td>
                                                <td class="text-right">{{amountFormat(shop_supplies)}}</td>
                                            </tr>
                                            <tr>
                                                <td>Other Charges:</td>
                                                <td class="text-right">{{amountFormat(other_charges)}}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                  <div class="row">
                                                    <div class="col-4">
                                                      Sales Tax:
                                                    </div>
                                                    <!-- <div class="col-5">
                                                      <input type="number" v-model="tax" class="form-control" v-on:input="percentageValidation('btnCalculateTax')">
                                                      <strong style="font-size: 9px; color: #cb3131">{{percentageErr}}</strong>
                                                    </div>
                                                    <div class="col-3">
                                                      <button type="submit" id = "btnCalculateTax" class="btn btn-primary" style="height: 32px; width: 67px; font-size: 10px" @click="calculateTotalAmount()">
                                                        Update tax
                                                      </button>
                                                    </div> -->
                                                  </div>
                                                </td>
                                                <td class="text-right">{{amountFormat(total_tax)}}</td>
                                            </tr>
                                            <tr>
                                                <td>Total:</td>
                                                <td class="order-total text-right">{{amountFormat(total)}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="form-group">
                            <div class="alert alert-warning hide col-sm-6" id="alertError">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <strong id="errorMsg" class="field-error"></strong>
                            </div>
                        </div>
                        <div class="form-group" v-if="comment != null && comment != undefined">
                            {{ comment_type }}
                            <div class="pre-formatted">{{ comment }}</div>
                        </div>
                        <div class="btn-groups mt-4" v-show="displaySchedule == false">
                            <button type="submit" id="createWorkOrderBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="checkStatus(flag='final','workorder')">
                                <i class="fp-reload"> </i> Update
                            </button>
                            <button type="submit" id="createWorkOrderBtn" v-if="($route.params.id == undefined ) && (displaySaveButton || displayLineItem == true)" class="btn btn-primary" v-on:click.prevent="CreateWorkOrder(flag='final','workorder')">
                                <i class="fp-save"> </i> Save
                            </button>
                            <button type="submit" id="createAndContinueWorkOrderBtn" v-if="($route.params.id == undefined ) && displayLineItem == false" class="btn btn-tertiary" v-on:click.prevent="CreateWorkOrder(flag='Save and Continue','workorder')">
                                    <template><i class="fp-save-continue"> </i> Save and Continue</template>
                                    <!-- <template>Next <i class="fp-right-arrow right-icon"> </i></template> -->
                                </button>
                            <button type="submit" id="cancelWorkOrderBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                <i class="fp-close"> </i> Cancel
                            </button>
                        </div>
                        <div class="modal fade select-date" :id="'select-date'" :ref="'select-date'" data-backdrop="static" data-keyboard="false" aria-labelledby="selectDate" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Are you sure that you want to Close WO Items?</h5>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row" >
                                            <div class="col-sm-6 form-group">
                                                <label class="control-label"  for="specialUnitDetail">WO Close Date:</label>
                                                <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="open_date" name="open_date" v-model="close_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon' :disabled="disableWOFields"></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" :id="'btnPOModalAdd'" v-on:click="CreateWorkOrder(flag='final','workorder')"> Yes </button>
                                        <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn" data-dismiss="modal"> No </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="modal fade policy-modal" id="wo-item-modal" ref="wo-item-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="wo-item-modal" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Select File</h5>
                                </div>
                                <div class="modal-body">
                                    <form id="importFile" class="addinspectionForm">
                                        <div class="form-row">
                                            <div class="col form-group">
                                                <label class="control-label require mb-2" for="name">File:</label><br/>
                                                <input id="dnFile" type="file" @change="onFileChanged">
                                                <div class="field-error">{{import_error}}</div>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col form-group" v-if="fileName != ''">
                                                <label class="control-label"> Download Sample file </label>
                                                <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                            </div>
                                        </div>

                                        <template v-if="importIssue.asset && importIssue.asset.length > 0">
                                            <label class="d-block"> Work order items Not Imported For These Unit as unit not found in system:</label>
                                            <template v-for="(dba,perAKey) in importIssue.asset">
                                                <a :key="perAKey" v-if="perAKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perAKey">{{dba.asset_number}}</span>
                                            </template>
                                            <p>&nbsp;</p>
                                        </template>
                                        <template v-if="importIssue.task && importIssue.task.length > 0">
                                            <label class="d-block"> Work order items Not Imported Cause vmrs or task not found:</label>
                                            <template v-for="(dbat,pertAKey) in importIssue.task">
                                                <a :key="pertAKey" v-if="pertAKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="pertAKey">{{dbat.task}}</span>
                                            </template>
                                            <p>&nbsp;</p>
                                        </template>
                                    </form>

                                    <div class="modal-footer">
                                        <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal" v-on:click="loadWorkOrder();"> <i class="fp-close"> </i>Cancel</button>
                                        <button class="btn btn-primary" id="importButton" v-on:click="importWoItem()"> <i class="fp-import"> </i> Import</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {
    commonMixins
} from '../mixins/commonMixins';
import {
    contractMixins
} from '../mixins/contractMixins';

import moment from 'moment';

export default {
    name: "WorkOrderCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Work Order | " +process.env.COPYRIGHT_NAME : "Create Work Order | " +process.env.COPYRIGHT_NAME
        }
    },

    mixins: [commonMixins, contractMixins],
    data: () => ({
        assetUnitNo: "",
        error_msg_part_missing: "",
        requestInProgress:false,
        //new permission added ... 21th Nov 2019
        canUpdateWoComment: false,
        canDeleteWoComment: false,
        canAddWoLineItem: false,
        canDeleteWoLineItem: false,
        serviceTaskLaborHourRate_error_msg: "",
        workOrderEstimateId: 0,
        canCloseWo: false,
        woiStatusArr: [{
                value: "open",
                text: "Open"
            },
            {
                value: "in progress",
                text: "In Progress"
            },
            {
                value: "review",
                text: "Review"
            },
            {
                value: "closed",
                text: "Close"
            }],

        canAddLaborActivityLog: false,
        activeLineItemIdx: '',
        displayLineItem: false,
        woId: 0,
        itemClass:'',
        //new permission added ... 24th Oct 2019
        listWoLabor: false,
        canUpdateWoLabor: false,
        canDeleteWoLabor: false,
        canAddWoComp: false,
        canUpdateWoComp: false,
        canDeleteWoComp: false,
        canViewWoSummary: false,
        disableLineItemLabourRate: false,
        canAddWoComment: false,
        commentArr: [],
        submitBtn: "Save",
        workOrderCommentId: 0,
        workOrderEstimateCommentId: 0,
        workOrderCommentIndex: 'create',
        comment_type_id: null,
        comment_type_error_msg: '',
        comment_error_msg: '',
        commentTypeArr: [],
        woComment: [],
        canSendEstimation: false,
        maintenance_type_id: null,
        maintenanceTypeArr: [],
        maintenance_type_error_msg: '',
        miles_error_msg: '',
        loggedInUser: '',
        laborTimeLogArr: [],
        timeLabel: 'Start Log Time',
        end_time: '',
        start_time: '',
        woStatusArr: [{
                value: "open",
                text: "Open"
            },
            {
                value: "in progress",
                text: "In Progress"
            },
            {
                value: "review",
                text: "Review"
            },
            {
                value: "closed",
                text: "Close"
            }
        ],
        wostatus: {
            value: "open",
            text: "Open"
        },
        woiStatusArrWithP: [{
                value: "open",
                text: "Open"
            },
            {
                value: "in progress",
                text: "In Progress"
            },
            {
                value: "review",
                text: "Review"
            },
            {
                value: "closed",
                text: "Close"
            }
        ],
        woiStatusArrWithoutP: [{
                value: "open",
                text: "Open"
            },
            {
                value: "in progress",
                text: "In Progress"
            },
            {
                value: "review",
                text: "Review"
            }
        ],
        vmrsArr: [],
        labor_description: '',
        comp_description: '',
        wr_location:0,
        vendorArr: [],
        vendor_id: null,
        purchase_order_id: null,
        purchaseOrderArr: [],
        location_id: null,
        locationArr: [],
        isCustomerNotFound: false,
        isAssetNotFound: false,
        searchedAsset: '',
        searchedCustomer: '',
        scheduleMaintenanceArr: [],
        schedule_maintenance_id: null,
        extraLaborComp: false,
        woiDetail: [],
        woLaborDetail: [],
        woCompDetail: [],
        showActiveTaskLabor: '',
        showActiveLaborLog: '',
        serviceTaskComp_error_msg: '',
        serviceTaskCompIndex: 'create',
        serviceTaskCompId: 0,
        serviceTaskEstimateCompId: 0,
        serviceTaskComp: null,
        serviceTaskCompQuantity: 0,
        serviceTaskCompCost: 0,
        serviceTaskCompSubTotal: 0,
        serviceTaskCnt: 0,
        laborCnt: 0,
        componentCnt: 0,
        serviceTaskLabor_error_msg: '',
        serviceTaskLaborIndex: 'create',
        serviceTaskLaborId: 0,
        serviceTaskLabor: null,
        serviceTaskLaborHour: 0,
        serviceTaskLaborHourRate: 0,
        serviceTaskLaborSubTotal: 0,
        serviceTaskArr: [],
        showTab: 'labor',
        serviceTaskActive: "active",
        laborActive: "",
        partActive: "",
        taskArr: [],
        parts_total: 0,
        labor_total: 0,
        sub_total: 0,
        tax: 0,
        total_tax: 0,
        discount: 0,
        total_discount: 0,
        total: 0,
        wonotes: "",
        task_error_msg: "",
        taskid_error_msg: "",
        laboramount_error_msg: "",
        partamount_error_msg: "",
        subtotal_error_msg: "",
        po_error_msg: "",
        //labor tab related
        laborArr: [],
        labor_id: null,

        labor_error_msg: "",
        laborid_error_msg: "",
        laborhours_error_msg: "",
        hourrate_error_msg: "",

        //part tab related
        comp_id: null,
        compArr: [],
        serviceTaskIssued:0,
        permissions: [],
        cantAccessPage: "",
        work_order_no: "",
        work_order_no_temp: "",
        vehicle_id: null,
        customer_id: null,

        open_date: "",

        miles: null,

        optionsDate: {
            format: 'MM/DD/YYYY hh:mm:ss a',
            useCurrent: false,
            showClose: true,
        },
        optionsDateOnly: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
            showClose: true,
        },
        requested_completion: "",
        agreed_date: "",

        user_id: null,

        priority: null,
        cost_code: null,
        crew_number: "",
        roadside_service: "",
        vehicleArr: [],
        customerArr: [],
        shopArr: [],
        userArr: [],
        reasonArr: null,
        priorityArr: [],
        costCodeArr: [],
        loading: false,
        vehicle_error_msg: "",
        customer_error_msg: "",
        customer_po_error_msg: "",
        location_error_msg: "",
        user_error_msg: "",
        reason_error_msg: "",
        itemArr: [],
        componentArr: [],
        component: "",
        component_error_msg: "",
        task_id: "",
        workOrderTaskArr: [],
        component_id: null,
        hours: "",
        hours_error_msg: "",
        wi_user_id: "",
        wi_user_id_error_msg: "",

        standardDefectsArr: [],
        defect_error_msg: "",
        wi_reason_id: "",
        wi_reason_error_msg: "",
        wi_cost_code: "",
        wi_cost_code_error_msg: "",

        billableCodeArr: [],
        billable_code_error_msg: "",
        blockRemoval: true,
        laborHourArr: [],
        role: '',
        assetInfo: '',
        customerInfo: '',
        openDateInfo: '',
        closeDateInfo: '',
        requestCompInfo: '',
        agreedDateInfo: '',
        userInfo: '',
        woStatusInfo: '',
        milesInfo: '',
        locationInfo: '',
        priorityInfo: '',
        woNotesInfo: '',
        maintenanceTypeInfo: '',
        scheduleMaintenanceInfo: '',
        laborIndex: 0,
        serviceTaskLaborHour_error_msg: "",
        // isEditLabor:false,
        currentTaskIndex: 0,
        activityActive: '',
        activityArr: [],
        getExistingWOI : [],
        showActivity: '',
        displayFix: false,
        estimateArr: [],
        custestimateArr:[],
        estimateFlag:false,
        mainArr:[],
        is_miscellaneous:false,
        customer_email:"",
        customer_email_error_msg:"",
        customer_vin_number:"",
        customer_vin_number_error_msg:"",
        customer_unit_no:"",
        customer_unit_no_error_msg:"",
        showMiscellaneousFields:false,
        woIsMiscellaneous:"",
        woCustomerEmailInfo:"",
        woCustomerVinInfo:"",
        woCustomerUnitNoInfo:"",
        disableCustField:false,
        displaySaveButton:true,
        disableMaintenanceTypeField:false,
        disableWoStatusField:true,
        displaySchedule:false,
        scheduleNotFound:false,
        dueNotFound:false,
        defaultPriceBookArr:[],
        customerPurchaseOrderArr:[],
        billArr:[],
        disableTechnicianField:false,
        disableWOFields:false,
        serviceTaskQty_error_msg:'',
        logFlag:"",
        logStartAt:"",
        addMiles:false,
        woMiles:0,
        laborCostArr:[],
        defaultLaborCostArr:[],
        oldLaborUserId:0,
        programArr:[],
        woidForprogram:0,
        selectedProgramArr:[],
        disableHourField:false,
        warrantyTriggerArr:[],
        warArr:[],
        oosCreated:false,
        OutOfService:'',
        fromUrl:"",
        lastSelection: '',
        techArr: [],
        sectionArr:[],
        customerPoNo:'',
        workOrderTypesArr:[{text:'Default',value:'default'},{text:'Multi Unit',value:'multi unit'}],
        work_order_type:{text:'Default',value:'default'},
        assetRequired:true,
        work_order_type_error_msg:'',
        disableSubletCheckbox:false,
        invoiceGenerated:'false',
        chargesArr:[],
        billable_charges:0,
        other_charges:0,
        billable_part_amount:0,
        shop_supplies:0,
        openWoArr:"",
        work_order_no_error_msg:"",
        work_order_duplicate : false,
        seqCheck : 0,
        oos_date : null,
        customerPriceBookArr:[],
        updateLbrProc:0,
        requireEtc:'require',
        percentageErr: "",
        comment:"",
        comment_type:"",
        fileName:'',
        file:'',
        selectedFile:[],
        importIssue:[],
        selectedCompArr:[],
        import_error:'',
        close_date:'',
        assetPoolInfo:'',
        continueCloseItem: false,
        existingReading: [],
        checkSegment:'',
    }),
    watch: {
        activeLineItemIdx:function(){
            var singleTask = this.taskArr[this.activeLineItemIdx];
            if (typeof singleTask !== 'undefined') {
                var vmrs = singleTask.component_category_id;
                this.selectVmrs(vmrs,this.activeLineItemIdx);
            }
        },

        serviceTaskLaborHour: function () {
            var self = this;
            self.calculateSubTotalForLabor();

        },

        discount: function () {
            var self = this;
            self.calculateTaxDiscountAmount();
        },

        workOrderEstimateId: function () {

            var self = this;
            if (self.workOrderEstimateId != 0) {
                //show display line item....
                // self.displayLineItem = true;
                self.displaySaveButton = false;
                self.getEstimateWorkOrderDetail(self.workOrderEstimateId);

            }

        },

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_work_order') {
                        self.cantAccessPage = true;
                    }

                    if (permissions[i].name == 'can_send_work_order_estimation') {
                        self.canSendEstimation = true;
                    }

                    //used
                    if (permissions[i].name == 'can_view_work_order_summary') {
                        self.canViewWoSummary = true;
                    }

                    if (permissions[i].name == 'disable_line_item_labour_rate') {
                        self.disableLineItemLabourRate = true;
                    }

                    //used
                    if (permissions[i].name == 'can_add_labors_activity_log') {
                        self.canAddLaborActivityLog = true;
                    }

                    //used
                    if (permissions[i].name == 'add_work_order_labor') {
                        self.canUpdateWoLabor = true;
                        self.disableTechnicianField = false;
                    }

                    //used
                    if (permissions[i].name == 'can_close_work_order') {
                        self.canCloseWo = true;
                        //self.disableWoStatusField = false;
                        self.woiStatusArr = self.woiStatusArrWithP;
                    }

                    //used
                    if (permissions[i].name == 'delete_work_order_labor') {
                        self.canDeleteWoLabor = true;
                    }

                    //used
                    if (permissions[i].name == 'add_work_order_component') {
                        self.canAddWoComp = true;
                        self.canUpdateWoComp = true;
                    }

                    //used
                    if (permissions[i].name == 'delete_work_order_component') {
                        self.canDeleteWoComp = true;
                    }

                    //used
                    if (permissions[i].name == 'add_comment_work_order') {
                        self.canAddWoComment = true;
                        self.canUpdateWoComment = true;
                    }

                    //used
                    if (permissions[i].name == 'delete_comment_work_order') {
                        self.canDeleteWoComment = true;
                    }

                    //used
                    if (permissions[i].name == 'add_work_order') {
                        self.canAddWoLineItem = true;
                    }

                    //used
                    if (permissions[i].name == 'delete_work_order') {
                        self.canDeleteWoLineItem = true;
                    }


                }
            }

        },
        // Get schedule_maintenance..
        customer_id: function (c_id) {
            var self = this;
            let v_id = self.vehicle_id;
            var path = window.location.pathname;
            var segments = path.split("/");
            // auto fill customer email
            if(!segments[3] && self.showMiscellaneousFields == true){
                if(c_id.email != null){
                    self.customer_email = c_id.email;
                }
            }
            //permission related changes
            if (c_id != null && v_id != null && self.displayLineItem == false) {

                // self.getScheduledMaintenance(c_id, v_id);
                // commented because po is not required when create and also provide input for po so there is no ref required from customer po
                // if(c_id.po_required == 1) {
                //   $("#customer_po").addClass("control-label require");

                // } else {
                //   $("#customer_po").removeClass("require");
                // }
            } else {
              self.customerPurchaseOrderArr = [];
            }

        },

        end_time: function (e_Date) {
            var self = this;

            if (self.start_time != '') {
                self.calculateDays(self.start_time, e_Date)
            }
        },

        vehicle_id: function (newValue, oldValue) {
            var self = this;
            self.openWoArr = [];
            if (newValue != null && self.displayLineItem == false && self.estimateFlag == false ) {
                // self.getAssetReservationDetails(newValue.value);
                // if (self.$route.params.id == undefined){
                //     self.customer_id = {text:newValue.customer,value:newValue.customer_id};
                // }
            }
            if (newValue != null && newValue.value) {
                if (newValue != null && self.displayLineItem == false && newValue.vehicle_type_id) {
                    self.getSectionForReading(newValue.value,newValue.vehicle_type_id,newValue.unit_no);
                }
            }
            if ((!self.$route.params.id || (self.$route.params.from != undefined && self.$route.params.from == "copy")) && self.vehicle_id.value){
                setTimeout(function () {
                    self.checkoosForVehicle(self.vehicle_id.value);
                }, 1500);

            }
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( segments[3] ) {
            } else {
                self.checkOpenWorkOrder(newValue.value);
            }
        },

        itemArr() {
            var self = this;
            self.blockRemoval = self.itemArr.length <= 1
        },

        taskArr: {
            handler: function (newValue) {

                var self = this;
                self.serviceTaskCnt = newValue.length;
                var billablePartAmt = 0;
                var isBillable = 0;
                //calculate shop supplies
                var totalLaborAmt = 0;
                var totalShopSupplies = 0;
                for (var i = 0; i < newValue.length; i++) {

                    if (!newValue[i].issublet) {
                        newValue[i].purchaseorderid = null;
                        newValue[i].po_number = '',
                        newValue[i].vendorid = null;
                        newValue[i].sublet_amount = 0;
                        newValue[i].disable_sublet = false;
                        newValue[i].billId = null;
                        newValue[i].disable_po_sublet = false;
                        newValue[i].disable_amount_sublet = false;
                        newValue[i].disable_vendor_sublet = false;
                    }
                    //check whether line item is billable or not
                    if (newValue[i].billable_code != undefined && newValue[i].billable_code != null && newValue[i].billable_code != "") {
                        if (newValue[i].billable_code.value != null && newValue[i].billable_code.value == "B") {
                            isBillable = 1;
                            if (newValue[i].partamount != undefined && newValue[i].partamount != null && newValue[i].partamount != "") {
                                billablePartAmt += Number(newValue[i].partamount);
                            }
                        }
                    }
                    //non sublet line item labor amount for shop supplies
                    if (!newValue[i].issublet) {
                        if (newValue[i].laboramount != undefined && newValue[i].laboramount != null && newValue[i].laboramount != "") {
                            totalLaborAmt += Number(newValue[i].laboramount);
                        }
                    }
                }
                //if work order have billable line item then apply charges and tax
                if (isBillable == 1) {
                    self.other_charges = self.billable_charges;
                    self.billable_part_amount = billablePartAmt;
                }else{
                    self.other_charges = 0;
                    self.billable_part_amount = 0;
                }
                if (totalLaborAmt != 0) {
                    // var shopSupplies = self.fetchShopSuppliesRate();
                    // totalShopSupplies = (shopSupplies * totalLaborAmt)/100;
                    // self.shop_supplies = totalShopSupplies;
                }else{
                    self.shop_supplies = 0;
                }
                self.calculateTotalAmount();
            },
            deep: true
        },

        commentArr: {
            handler: function (newValue) {
                var self = this;

                for (var i = 0; i < self.serviceTaskArr.length; i++) {

                    var comment = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for (var j = 0; j < newValue.length; j++) {

                        if (newValue[j].service_task_id != null) {

                            var taskIdx = newValue[j].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                comment = true;

                            }

                        }
                    }

                    self.taskArr[serviceTaskIdx].hasComment = comment;

                }
            },
            deep: true
        },

        laborArr: {
            handler: function (newValue) {
                var self = this;
                self.laborCnt = newValue.length;

                for (var k = 0; k < self.serviceTaskArr.length; k++) {

                    var lamount = 0
                    var hasTechnician = false;
                    var serviceTaskIdx = self.serviceTaskArr[k].index;

                    for (var i = 0; i < newValue.length; i++) {

                        if (newValue[i].service_task_id != null) {

                            var taskIdx = newValue[i].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                lamount += parseInt(newValue[i].laborsubtotal);
                                hasTechnician = true

                            }

                        }
                    }

                    if (hasTechnician == true) {

                        if (!$('#laboramount' + serviceTaskIdx).hasClass('disable-field')) {

                            $("#laboramount" + serviceTaskIdx).addClass("disable-field");
                        }

                        self.taskArr[serviceTaskIdx].hasLabor = true;

                    } else {

                        if ($('#laboramount' + serviceTaskIdx).hasClass('disable-field')) {

                            $("#laboramount" + serviceTaskIdx).removeClass("disable-field");

                        }

                    }

                    if (newValue.length > 0) {
                        self.taskArr[serviceTaskIdx].laboramount = lamount;
                    }
                    self.calculateTotalAmount();
                }
            },
            deep: true
        },
        compArr: {
            handler: function (newValue) {
                var self = this;
                self.componentCnt = self.compArr.length;

                for (var i = 0; i < self.serviceTaskArr.length; i++) {

                    var camount = 0
                    var hasPart = false;
                    var serviceTaskIdx = self.serviceTaskArr[i].index;

                    for (var j = 0; j < newValue.length; j++) {

                        if (newValue[j].service_task_id != null) {

                            var taskIdx = newValue[j].service_task_id.index;

                            if (taskIdx == serviceTaskIdx) {

                                camount += parseFloat(newValue[j].compsubtotal);
                                hasPart = true;

                            }

                        }
                    }

                    if (hasPart == true) {

                        if (!$('#partamount' + serviceTaskIdx).hasClass('disable-field')) {

                            $("#partamount" + serviceTaskIdx).addClass("disable-field");

                        }

                        self.taskArr[serviceTaskIdx].hasComp = true;
                        // self.taskArr[serviceTaskIdx].partamount = camount;

                    } else {

                        if ($('#partamount' + serviceTaskIdx).hasClass('disable-field')) {

                            $("#partamount" + serviceTaskIdx).removeClass("disable-field");

                        }

                    }

                    if (newValue.length > 0) {
                        self.taskArr[serviceTaskIdx].partamount = camount;
                    }
                    self.calculateTotalAmount();
                }
            },
            deep: true
        },

        laborHourArr: {
            handler: function (newValue) {
                var self = this;
                var newLaborHourArr = newValue.length;
                var haslaborHour = false;
                for (var i = 0; i < newValue.length; i++) {

                    if (newValue[i] != undefined) {
                        if (newValue[i].labor_index == self.laborIndex) {
                            haslaborHour = true;
                        }
                    }
                }

                if (!haslaborHour) {
                    self.showActiveLaborLog = 'addLaborLog';
                }

            },
            deep: true
        }
    },
    created: function () {
    },
    beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
    },
    mounted: function () {

        var self = this;
        var path = window.location.pathname;
        if(self.$route.params.flag == 'true'){
            self.getScheduledata();
        }
        var segments = path.split("/");
        if(self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined){
          self.fromUrl = atob(self.$route.query.fromUrl);
        }
        self.getPermissions();
        self.close_date = moment().format('MM/DD/YYYY hh:mm:ss a');
        self.loadFieldData(['work_order_comment', 'location', 'reason', 'priority', 'costcode', 'billablecode', 'standarddefects', 'workordertask', 'maintenance_type']);

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            if (userObj.roles.length > 0) {
                for(var i = 0; i < userObj.roles.length; i++){
                    if (userObj.roles[i].name == 'technician') {
                        self.disableHourField = true;
                        self.role = userObj.roles[i].name.toLowerCase();
                    }
                }
            }


            var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
            if (dateTimeFormat != null) {
                console.log(dateTimeFormat);
                //set date time format in optionsDate format of date picker
            }

            // set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                self.location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"])
                };
            }

            // set LoggedIn user as default user....
            if (userObj["last_name"] != null && userObj["last_name"] != '') {
                self.user_id = self.loggedInUser = {
                    value: userObj["id"],
                    text: self.titleCase(userObj["first_name"]) + " " + self.titleCase(userObj["last_name"])
                };
            } else {
                self.user_id = self.loggedInUser = {
                    value: userObj["id"],
                    text: self.titleCase(userObj["first_name"])
                };
            }
        }

        if (!segments[3]) {
            self.getWorkOrderNo();
            self.open_date = moment().format('MM/DD/YYYY hh:mm:ss a');

            //if available set asset value => when user is redirected from Add Customer...
            if (localStorage.getItem("newAsset") != null) {
                self.vehicle_id = JSON.parse(localStorage.getItem("newAsset"));
            }

            //if available set customer value => when user is redirected from Add Asset...
            if (localStorage.getItem("newCustomer") != null) {
                self.customer_id = JSON.parse(localStorage.getItem("newCustomer"));
            }
            //self.fetchTaxRate();
            // self.getWorkOrderNo();
        }

        if (self.$route.params.redirectTo == 'Add Work Order Unit') {

            var vehicleData = self.titleCase(self.$route.params.assetUnitNo);
            if (self.$route.params.assetType != null && self.$route.params.assetType != '') {
                if (self.$route.params.assetType.vtCode != null && self.$route.params.assetType.vtCode != '') {
                    vehicleData += " | " + self.titleCase(self.$route.params.assetType.vtCode);
                }
            }
            if (self.$route.params.assetName != null && self.$route.params.assetName != '') {
                vehicleData += " | " + self.titleCase(self.$route.params.assetName);
            }
            if (self.$route.params.assetLocation != null && self.$route.params.assetLocation != '') {
                if (self.$route.params.assetLocation.location_name != null && self.$route.params.assetLocation.location_name != '') {
                    vehicleData += " | " + self.titleCase(self.$route.params.assetLocation.location_name);
                }
            }
            self.vehicle_id = {
                value: self.$route.params.assetId,
                text: vehicleData
            };

            //set newAsset value to localStorage...when user is redirected from Add Asset..
            localStorage.setItem("newAsset", JSON.stringify({
                value: self.$route.params.assetId,
                text: vehicleData
            }));

        } else if (self.$route.params.redirectTo == 'Add Work Order Customer') {

            self.customer_id = {
                value: self.$route.params.customerId,
                text: self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"
            };

            //set newCustomer value to localStorage... when user is redirected from Add Customer..
            localStorage.setItem("newCustomer", JSON.stringify({
                value: self.$route.params.customerId,
                text: self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"
            }));

        }

        if (self.$route.params.customerId != null && self.$route.params.customerId != '') {

            self.customer_id = {
                value: self.$route.params.customerId,
                text: self.formatString(self.$route.params.customerName) + " (" + self.$route.params.customerCode + ")"
            };

        }

        if (self.$route.params.estimateWoId != null && self.$route.params.estimateWoId != undefined && self.$route.params.estimateWoId != '') {
            self.workOrderEstimateId = self.$route.params.estimateWoId;
            self.estimateFlag = true;
            self.workOrderTypesArr = [{text:'Default',value:'default'}];//if from customer estimate list create work order clicked
        }

        if (self.$route.params.purchaseOrderId != null && self.$route.params.purchaseOrderId != undefined && self.$route.params.purchaseOrderId != '') {

            //self.poId = self.$route.params.purchaseOrderId;

        }

        setTimeout(function () {

            if (self.$route.params.vehicleUnitNo != null && self.$route.params.vehicleUnitNo != '') {

                self.schedule_maintenance_id = {
                    value: self.$route.params.scheduleMaintenanceId,
                    text: self.formatString(self.$route.params.vehicleUnitNo) + " (" + self.$route.params.scheduleDate + ")",
                    vtCode: self.$route.params.vehicleTypeCode,
                    vName: self.$route.params.vehicleName,
                    vUnitNo: self.$route.params.vehicleUnitNo,
                    vehicle_id: self.$route.params.vehicleId.value
                };

            }

            if (segments[3]) {
                self.checkSegment = segments[3];
                //if redirected from work order list and click on copy
                if (self.$route.params.from != undefined && self.$route.params.from != null) {
                    if (self.$route.params.from == "copy") {
                        self.displaySchedule = false;
                        self.displayLineItem = false;
                        self.itemClass = '';
                        self.loadWorkOrder();
                    }else{
                        self.displayLineItem = true;
                        self.itemClass = 'undefined';
                        self.loadWorkOrder();
                    }
                }else{
                    self.displayLineItem = true;
                    self.itemClass = 'undefined';
                    self.loadWorkOrder();
                }

                //one can not change maintenance type while updating...
                // $("#maintenance_type_id").addClass("disable-field");
                self.disableMaintenanceTypeField = true;

                //Join ViewEdit Channel
                self.join_view_edit_channel(segments[1],segments[2],segments[3]);
            }

                //  $('.wo-sidebar-detail').click(function () {
                //     $( "#wo-detail-section" ).animate({
                //     right: "0",
                //     }, 300 );
                // });
                // $('.closebtn').click(function (e) {
                //     e.preventDefault();
                //         $( "#wo-detail-section" ).animate({
                //         right: "-350px",
                //     }, 300 );
                // });
        }, 1500);

        $(window).scroll(function () {
            var scrollDistance = $(window).scrollTop();
            /*$('.PageTop').each(function (i) {
                if (scrollDistance > 190) {
                    $(".PageTop").addClass("PageTopFix");
                    self.displayFix = true;
                } else {
                    $(".PageTop").removeClass("PageTopFix");
                    self.displayFix = false;
                }
            });*/

        });

        // if(self.displayLineItem){
        if (segments[3]) {
            //self.getVendorEstimateDetail();
            //self.getCustomerEstimateItemDetail();
        }

        // }

    },
    methods: {

        //update wo line labor data..
        updateWoLabor(index) {

            var self = this;
            var taskIndex = self.serviceTaskLaborIndex;

            var error = false;
            var taskIndex = self.serviceTaskLaborIndex;

            self.serviceTaskLabor_error_msg = '';
            self.serviceTaskLaborHour_error_msg = '';
            self.serviceTaskLaborHourRate_error_msg = '';

            if ( self.serviceTaskLabor == null && self.taskArr[taskIndex].issublet != true) {
                self.serviceTaskLabor_error_msg = 'Specify Technician';
                error = true;
            }

            if (self.role != 'technician') {
                if (self.serviceTaskLaborHour == 'NaN' || self.serviceTaskLaborHour == null || self.serviceTaskLaborHour == "") {
                    self.serviceTaskLaborHour_error_msg = 'Labor Hours Required';
                    error = true;
                }
            }

            //while update labor if labor is changed same as already added labor in current line item
            if ( self.serviceTaskLabor != null) {
                if ( self.oldLaborUserId > 0 && (self.serviceTaskLabor.value != self.oldLaborUserId)) {
                    var laborIdArr = [];
                    for (var i = 0; i < self.laborArr.length; i++) {

                        if (self.laborArr[i].service_task_id.index == taskIndex) {
                            if (self.laborArr[i].laborid != null) {
                                laborIdArr.push(self.laborArr[i].laborid.value);
                            }
                        }
                    }
                    if (laborIdArr.includes(self.serviceTaskLabor.value)) {
                        self.serviceTaskLabor_error_msg = 'Technician Already Added';
                        error = true;
                    }
                }
            }

            if ( !error ) {

                if ( self.updateLbrProc == 1 ) {
                    return;
                }

                var laborObj = {};
                laborObj.lid = self.laborArr[taskIndex].lid;
                laborObj.labor = self.serviceTaskLabor;
                laborObj.desc = self.labor_description;
                laborObj.laborHr = self.serviceTaskLaborHour;
                laborObj.rate = self.serviceTaskLaborHourRate;
                laborObj.total = self.serviceTaskLaborSubTotal;
                self.updateLbrProc = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/workorder/update-workorder-labor",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data: {
                        laborObj: laborObj
                    },
                    success: function (data) {

                        self.updateLbrProc = 0;
                        if ( data.code == 200 ) {
                            //reload data
                            self.workOrderItemData('');
                            //reset form buttons and hide edit form
                            self.showActiveTaskLabor = '';
                            self.serviceTaskLaborIndex = 'create';
                        } else {
                            self.self.serviceTaskLabor_error_msg = data.message;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.updateLbrProc = 0;
                        self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-item-detail');
                    }
                });

            }
        },

        closeWoSidebar (){

            $(document).ready(function(){

                $('.wo-sidebar-detail').dblclick(function () {

                    $( "#wo-detail-section" ).animate({
                    right: "0",
                    }, 300 );
                });
                $('.closebtn').click(function (e) {
                    e.preventDefault();
                        $( "#wo-detail-section" ).animate({
                        right: "-350px",
                    }, 300 );
                });
            });

        },
        showDetail: function(event) {
         $( "#wo-detail-section" ).animate({
                    right: "0",
                    }, 300 );
        },
        closeWODetail: function(event) {
            event.preventDefault();
            $( "#wo-detail-section" ).animate({
                right: "-350px",
            }, 300 );
        },
        getEstimateWorkOrderDetail(estimate_wo_id) {

            var self = this;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/customer-estimate/" + estimate_wo_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if (data.content.vehicle_id != null) {
                            var vehicleData = self.titleCase(data.content.vUnitNo);
                            if (data.content.vtCode != null) {
                                vehicleData += " | " + self.titleCase(data.content.vtCode);
                            }
                            if (data.content.vName != null) {
                                vehicleData += " | " + self.titleCase(data.content.vName);
                            }
                            self.vehicle_id = {
                                value: data.content.vehicle_id,
                                text: vehicleData
                            };
                            self.assetInfo = vehicleData;
                        } else {
                            self.vehicle_id = null;
                        }
                        if(data.content.is_miscellaneous == 1){
                            $("#is_miscellaneous").prop("checked",true);
                            self.is_miscellaneous = true;
                            self.showMiscellaneousFields = true;
                            self.customer_email = data.content.customer_email;
                            self.customer_vin_number = data.content.customer_vin_number;
                            self.customer_unit_no = data.content.customer_unit_no;

                            self.disableCustField = false;
                        }else{
                            $("#is_miscellaneous").prop("checked",false);
                            self.is_miscellaneous = false;
                            self.showMiscellaneousFields = false;

                            self.disableCustField = false;
                        }

                        self.open_date = data.content.open_date;
                        self.openDateInfo = data.content.open_date;
                        if (data.content.close_date != null) {
                            self.closeDateInfo = data.content.close_date;
                        } else {
                            self.closeDateInfo = "-";
                        }
                        self.requested_completion = data.content.requested_completion;
                        self.requestCompInfo = data.content.requested_completion;
                        self.agreed_date = data.content.agreed_date;
                        self.agreedDateInfo = data.content.agreed_date;
                        self.customer_id = {
                            value: data.content.customer_id,
                            text: self.titleCase(data.content.cusName) + " (" + data.content.cusCode + ")"
                        };
                        self.customerInfo = self.titleCase(data.content.cusCode + " | " + data.content.cusName);
                        if (data.content.uLastName != null) {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName);
                        } else {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName);
                        }

                        self.reason_id = {
                            value: data.content.reason_id,
                            text: self.titleCase(data.content.rName) + " (" + data.content.rCode + ")"
                        };
                        if (data.content.priority) {
                            self.priority = {
                                value: data.content.priority,
                                text: data.content.priorityName + " (" + data.content.priority + ")"
                            };
                            self.priorityInfo = data.content.priorityName + " (" + data.content.priority + ")";
                        } else {
                            self.priority = null;
                        }

                        self.woStatusInfo = self.titleCase(data.content.status);
                        self.milesInfo = data.content.miles;
                        self.scheduleMaintenanceInfo = data.content.vUnitNo + " (" + data.content.schedule_date + ")";
                        self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                        self.wostatus = {
                            value: data.content.status,
                            text: self.formatString(data.content.status)
                        };
                        if (data.content.lState != null) {
                            self.locationInfo = data.content.lName + ", " + data.content.lState + " | " + data.content.lCode;
                        } else {
                            self.locationInfo = data.content.lName + " | " + data.content.lCode;
                        }
                        self.getEstimateWorkOrderItemDetail(estimate_wo_id);

                        self.wonotes = data.content.description;
                        self.woNotesInfo = data.content.description;

                        if (data.content.location_id) {
                            self.location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                            //self.fetchTaxRate();
                        }

                        if (data.content.maintenanceTypeId) {
                            self.maintenance_type_id = {
                                value: data.content.maintenanceTypeId,
                                text: self.titleCase(data.content.maintenanceTypeName)
                            };
                        }

                        //self.tax = data.content.tax;
                        self.total_tax = data.content.tax_amount;

                        self.miles = data.content.miles;

                        self.discount = data.content.discount;
                        self.total_discount = data.content.discount_amount;
                        self.other_charges = data.content.other_charges;
                        self.shop_supplies = data.content.shop_supplies;

                        self.total = data.content.total_amount;

                        // for (var i = 0; i < data.content.length; i++) {
                        //     var task = {};
                        //     task['custestpartamount'] = data.content.item[i].custestpartamount;
                        //     task['custestlaboramount'] = data.content.item[i].custestlaboramount;

                        //     console.info('amount', task);
                        //     self.estimateArr.push(task);
                        // }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-detail');
                }
            });

        },

        getEstimateWorkOrderItemDetail(estimate_wo_id) {

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/customer-estimate/get-customer-estimate-item",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: estimate_wo_id,
                },
                success: function (data) {

                    if (data.code == 200) {

                        self.taskArr = [];
                        self.compArr = [];
                        self.laborArr = [];
                        self.commentArr = [];

                        if (data.content.item != undefined) {
                            self.serviceTaskArr = []

                            for (var i = 0; i < data.content.item.length; i++) {

                                self.taskArr.push({

                                    // wo_id: (data.content[i].wo_id != undefined && data.content[i].wo_id != null && data.content[i].wo_id != '')?data.content[i].wo_id:0,
                                    woiId: 0,
                                    line_number:data.content.item[i].line_number,
                                    taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? {
                                        value: data.content.item[i].task_id,
                                        text: self.titleCase(data.content.item[i].task_name + " (" + data.content.item[i].task_code + ")")
                                    } : null,
                                    laboramount: data.content.item[i].labor_amount,
                                    partamount: data.content.item[i].component_amount,
                                    component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ? {
                                        value: data.content.item[i].component_category_id,
                                        text: self.titleCase(data.content.item[i].component_category_name + " (" + data.content.item[i].component_category_code + ")")
                                    } : null,
                                    wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '') ? {
                                        value: data.content.item[i].wi_reason_id,
                                        text: self.titleCase(data.content.item[i].wi_reason_name + " (" + data.content.item[i].wi_reason_code + ")")
                                    } : null,
                                    defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '') ? {
                                        value: data.content.item[i].standard_defect_id,
                                        text: self.titleCase(data.content.item[i].standard_defect_name + " (" + data.content.item[i].standard_defect_code + ")")
                                    } : null,
                                    woicomplaint: data.content.item[i].complaint,
                                    woicause: data.content.item[i].cause,
                                    woicorrection: data.content.item[i].correction,
                                    issublet: data.content.item[i].issublet,
                                    purchaseorderid: null,
                                    po_number:'',
                                    vendorid: null,
                                    estimatedwoiId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '') ? data.content.item[i].wo_item_id : 0,
                                    estimatedlaboramount: data.content.item[i].labor_amount,
                                    disable_task:false,
                                    // labor_found:data.content.item[i].labor_found,
                                    // task_labor:data.content.item[i].task_labor,
                                    // task_labor_user:data.content.item[i].task_labor_user,
                                    // log_btn_title:data.content.item[i].log_btn_title,
                                    service_task_index:i,
                                    sublet_amount:0,
                                    disable_sublet:false,
                                    // log_found:data.content.item[i].log_found
                                    warrantyArr:[],
                                    warranty_id:(data.content.item[i].warranty_id != undefined && data.content.item[i].warranty_id != null && data.content.item[i].warranty_id != '') ? data.content.item[i].warranty_id : '',
                                    available_warranty_msg:'',
                                    po_error_msg:'',
                                    specialUnitNo:'',
                                    specialItemsArr:[],
                                    selectedSpItemsArr:[],
                                    isItemModal:0,
                                    isItemErrorMsg:'',
                                    disable_task_id:false,
                                    bill_item_id:'',
                                    disable_billable:false,
                                    disable_amount_sublet:false,
                                    disable_po_sublet:false,
                                    disable_vendor_sublet:false,
                                    default_warehouse:true,
                                    isPartAdd:0,
                                    partAddArr:[]
                                });

                                self.serviceTaskArr.push({
                                    value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? data.content.item[i].task_id : null,
                                    text: data.content.item[i].task_name,
                                    index: self.taskArr.length - 1
                                });

                            }
                        }else{
                              self.estimateFlag = false;
                        }

                        if (data.content.comp != undefined) {
                            for (var i = 0; i < data.content.comp.length; i++) {

                                self.compArr.push({
                                    cid: 0,
                                    compid: (data.content.comp[i].compid != null)?{
                                        value: data.content.comp[i].compid,
                                        text: data.content.comp[i].compname,
                                        quantity: data.content.comp[i].quantity
                                    }:null,
                                    service_task_id: {
                                        value: data.content.comp[i].service_task_id,
                                        text: data.content.comp[i].service_task_name,
                                        index: data.content.comp[i].service_task_index
                                    },
                                    compcost: data.content.comp[i].compcost,
                                    compquantity: data.content.comp[i].compquantity,
                                    compsubtotal: data.content.comp[i].compsubtotal,
                                    compdescription: data.content.comp[i].compdescription,
                                    estimatedcid: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '') ? data.content.comp[i].cid : 0,
                                    oldquantity: data.content.comp[i].compquantity,
                                    is_issued:data.content.comp[i].is_issued
                                });

                            }

                        }

                        if (data.content.comment != undefined) {
                            for (var i = 0; i < data.content.comment.length; i++) {

                                self.commentArr.push({
                                    wocId: 0,
                                    service_task_id: {
                                        value: data.content.comment[i].service_task_id,
                                        text: data.content.comment[i].service_task_name,
                                        index: data.content.comment[i].service_task_index
                                    },
                                    wocType: {
                                        value: data.content.comment[i].wocTypeId,
                                        text: self.titleCase(data.content.comment[i].wocTypeName) + ' (' + data.content.comment[i].wocType + ')'
                                    },
                                    woc: data.content.comment[i].woc,
                                    wocBy: data.content.comment[i].wocBy,
                                    wocAt: data.content.comment[i].wocAt,
                                    estimatedwocId: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '') ? data.content.comment[i].wocId : 0
                                });

                            }
                        }

                        if(data.content.labor != undefined){
                            for ( var i=0; i < data.content.labor.length; i++ ) {

                                self.laborArr.push({
                                    lid: 0,
                                    laborid: (data.content.labor[i].laborid != undefined && data.content.labor[i].laborid != null && data.content.labor[i].laborid != '') ? {
                                        value: data.content.labor[i].laborid,
                                        text: data.content.labor[i].laborname
                                    } : null,
                                    service_task_id: {value: data.content.labor[i].service_task_id, text:data.content.labor[i].service_task_name, index: data.content.labor[i].service_task_index},
                                    laborhours: data.content.labor[i].laborhours,
                                    laborhourrate: data.content.labor[i].laborhourrate,
                                    laborsubtotal: data.content.labor[i].laborsubtotal,
                                    labordescription: data.content.labor[i].labordescription
                                });

                            }
                        }
                        self.calculateTotalAmount();
                        // self.estimateFlag = false;
                    } else if (data.code == 201) {
                        self.calculateTotalAmount();
                        if(!self.estimateFlag){
                            self.addSetOfTask();
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-item-detail');
                }
            });
        },

        showComments: function () {

            var self = this;
            self.showTab = 'comment';
            self.laborActive = '';
            self.serviceTaskActive = '';
            self.partActive = 'active';
            self.activityActive = '';
            setTimeout(function () {
                $('.comment-list-btm').jScrollPane();
            }, 200);
        },

        showActivities: function (index) {
            var self = this;
            self.showTab = 'activity';
            self.activityActive = 'active';
            self.laborActive = '';
            self.serviceTaskActive = '';
            self.partActive = '';
            setTimeout(function () {
                $('.activity-list-btm').jScrollPane();
            }, 200);

            var hasActivity = false;

            for (var i = 0; i < self.activityArr.length; i++) {

                if (self.activityArr[i].service_task_index == index) {
                    hasActivity = true;
                }
            }

            if (hasActivity) {
                self.showActivity = 'activity';
            } else {
                self.showActivity = '';
            }
        },

        //add comment with enter key press
        process: function (e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13) { //Enter keycode
                this.submitComment();
            }
        },

        addComment(comment, commentType, task, taskIndex) {

            var self = this;
            var error = false;
            self.comment_error_msg = '';
            self.comment_type_error_msg = '';

            var index = self.workOrderCommentIndex;

            if (comment == '') {

                self.comment_error_msg = 'Comment is required';
                error = true;

            }

            if (commentType == null) {

                self.comment_type_error_msg = 'Comment Type is required';
                error = true;

            }

            if (!error) {

                if (index == 'create') {

                    self.commentArr.push({
                        //if one is adding new comment wocId => 0 or wocId => comment id..
                        wocId: 0,
                        service_task_id: {
                            value: task.value,
                            text: task.text,
                            index: taskIndex
                        },
                        wocType: commentType,
                        woc: comment,
                        wocBy: self.loggedInUser.text,
                        wocAt: moment(self.getCurrentDateTime()).format("MM/DD/YYYY h:mm"),
                        estimatedwocId: 0
                    });

                } else {

                    self.commentArr[index].wocId = (self.workOrderCommentId != 0) ? self.workOrderCommentId : 0;
                    self.commentArr[index].service_task_id = {
                        value: task.value,
                        text: task.text,
                        index: taskIndex
                    };
                    self.commentArr[index].wocType = commentType;
                    self.commentArr[index].woc = comment;
                    self.commentArr[index].wocBy = self.loggedInUser.text;
                    self.commentArr[index].wocAt = moment(self.getCurrentDateTime()).format("MM/DD/YYYY h:mm");
                    self.commentArr[index].estimatedwocId = (self.workOrderEstimateCommentId != 0) ? self.workOrderEstimateCommentId : 0;

                }

                self.comment = '';
                self.comment_type_id = null;
                self.workOrderCommentId = 0;
                self.workOrderEstimateCommentId = 0;
                self.workOrderCommentIndex = 'create';

                self.showActiveTaskLabor = '';
                self.currentTaskIndex = taskIndex;
                var validateTasks = 'validateTask';
                var taskFlag = 'comment';
                setTimeout(function () {

                    self.CreateWorkOrder(validateTasks,taskFlag);

                }, 500);

            }

        },

        editComment: function (c_id, c_type, estimate_c_id, comment, c_index, serviceTaskIndex) {

            var self = this;
            self.showActiveTaskLabor = 'addComment' + serviceTaskIndex;
            self.comment_error_msg = "";
            self.comment_type_error_msg = "";
            self.workOrderCommentId = c_id;
            self.workOrderEstimateCommentId = estimate_c_id;
            self.workOrderCommentIndex = c_index;
            self.comment_type_id = {
                value: c_type.value,
                text: c_type.text
            };
            self.comment = comment;
            // self.$refs.textarea.focus();
        },

        removeComment: function (c_id) {
            var self = this;
            self.comment_error_msg = "";
            self.comment_type_error_msg = "";

            if (confirm('Are you sure that you want to remove this comment? ')) {

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/workorder/remove-workorder-comment",
                    type: "POST",
                    data: {
                        'id': c_id
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (data.code == '200') {
                            self.loadWorkOrder();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'remove-wo-comment');
                    }
                });
            }

        },

        getAssetReservationDetails(v_id) {
            var self = this;

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/reservation/getCurrentReservation",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    vehicle_id: v_id,
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        // self.showDetailInfo = 'show';
                        self.schedule_maintenance_id = null;
                        self.scheduleMaintenanceArr = [];

                        if (data.content.custId != undefined) {
                            self.customer_id = {
                                value: data.content.custId,
                                text: self.formatString(data.content.custCode) + " (" + data.content.custName + ")"
                            };
                            self.customer_error_msg = '';
                        } else {

                            // self.customer_id = null;
                            if (!localStorage.getItem('newCustomer')){

                                self.customer_id = {text:"000-00000000-000 | VTRL",value:0, stage:'existing'};

                            }
                            // self.customer_error_msg = 'There is no current reservation available';
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-current-asset-reservation');
                }
            });

        },

        addSetOfTask() {
            var self = this;
            return;

            // self.loading = true;

            // $.ajax({
            //     url: process.env.ROOT_API + "/workorder/get-workorder-template",
            //     type: "GET",
            //     headers: this.ajxHeaders,
            //     crossDomain: true,
            //     dataType: "json",
            //     data: {
            //         maintenance_id: self.maintenance_type_id.value
            //     },
            //     success: function (data) {
            //         self.loading = false;
            //         //PR
            //         self.taskArr = [];
            //         self.laborArr = [];
            //         self.compArr = [];
            //         self.laborHourArr = [];

            //         if (data.code == 200) {

            //             for (var i = 0; i < data.content.length; i++) {

            //                 self.taskArr.push({

            //                     woiId: 0,
            //                     taskid: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '') ? {
            //                         value: data.content[i].task_id,
            //                         text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code + ")")
            //                     } : null,
            //                     laboramount: 0,
            //                     partamount: 0,
            //                     component_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '') ? {
            //                         value: data.content[i].component_category_id,
            //                         text: self.titleCase(data.content[i].component_category_name + " (" + data.content[i].component_category_code + ")")
            //                     } : null,
            //                     wi_reason_id: null,
            //                     billable_code: null,
            //                     defect_id: null,
            //                     woistatus: {
            //                         value: "open",
            //                         text: "Open"
            //                     },
            //                     issublet: 0,
            //                     purchaseorderid: null,
            //                     vendorid: null,
            //                     woicomplaint: '',
            //                     woicause: '',
            //                     woicorrection: '',
            //                     woinotes: '',
            //                     subtotal: 0,
            //                     hasLabor: false,
            //                     hasComp: false,
            //                     hasComment: false,
            //                     estimatedwoiId: 0,
            //                     estimatedlaboramount: 0,
            //                     disable_task:false,
            //                     labor_found:0,
            //                     task_labor:0,
            //                     log_btn_title:"Start Log Time",
            //                     task_labor_user:0,
            //                     service_task_index:i,
            //                     log_found:0,
            //                     sublet_amount:0,
            //                     disable_sublet:false,
            //                     disable_amount_sublet:false,
            //                     disable_po_sublet:false,
            //                     disable_vendor_sublet:false,
            //                     default_warehouse:true,
            //                     isPartAdd:0,
            //                     partAddArr:[]

            //                 });
            //             }

            //             self.activeLineItemIdx = 0;
            //             self.currentTaskIndex = self.activeLineItemIdx;

            //         }
            //     },
            //     error: function (jqXHR, exception) {
            //         self.loading = false;
            //         self.Registerbtn = "Register";
            //         self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-template');
            //     }
            // });
        },

        addMaintenanceTask(proFlag = '') {
            var self = this;
            var field = [];
            var path = window.location.pathname;
            var segments = path.split("/");

            field.push({name:'programArr',value:JSON.stringify(self.mainArr)})
            field.push({name:'warrantyArr',value:JSON.stringify(self.warArr)})
            if (segments[3]){
                field.push({name:'wo_id',value:segments[3]})
            }else{

                field.push({name:'wo_id',value:self.woidForprogram})
            }
            field.push({name:'proFlag',value:proFlag})
            // self.mainArr;
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/program-wo/store",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: field,
                success: function (data) {
                    self.loading = false;

                    self.taskArr = [];
                    self.laborArr = [];
                    self.compArr = [];
                    self.laborHourArr = [];

                    if (data.code == 200) {

                        self.displayLineItem = true;
                        self.itemClass = 'undefined';
                        // $("#myModal").modal('hide');

                        setTimeout(function(){
                            for (var i = 0; i < data.content.length; i++) {

                                self.taskArr.push({

                                    woiId: 0,
                                    line_number:data.content[i].line_number,
                                    taskid: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '') ? {
                                        value: data.content[i].task_id,
                                        text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code + ")")
                                    } : null,
                                    laboramount: 0,
                                    partamount: 0,
                                    component_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '') ? {
                                        value: data.content[i].component_category_id,
                                        text: self.titleCase(data.content[i].component_category_name + " (" + data.content[i].component_category_code + ")")
                                    } : null,
                                    wi_reason_id: null,
                                    billable_code: null,
                                    defect_id: null,
                                    woistatus: {
                                        value: "open",
                                        text: "Open"
                                    },
                                    issublet: 0,
                                    purchaseorderid: null,
                                    po_number:'',
                                    vendorid: null,
                                    woicomplaint: '',
                                    woicause: '',
                                    woicorrection: '',
                                    woinotes: '',
                                    subtotal: 0,
                                    hasLabor: false,
                                    hasComp: false,
                                    hasComment: false,
                                    estimatedwoiId: 0,
                                    estimatedlaboramount: 0,
                                    disable_task:false,
                                    labor_found:0,
                                    task_labor:0,
                                    log_btn_title:"Start Log Time",
                                    task_labor_user:0,
                                    service_task_index:i,
                                    log_found:0,
                                    sublet_amount:0,
                                    disable_sublet:false,
                                    program_id:(data.content[i].program_id != undefined && data.content[i].program_id != null && data.content[i].program_id != '') ? {
                                        value: data.content[i].program_id,
                                        text: data.content[i].program
                                    } : null,
                                    warrantyArr:[],
                                    warranty_id:(data.content[i].warranty_id != undefined && data.content[i].warranty_id != null && data.content[i].warranty_id != '') ? {
                                        value: data.content[i].warranty_id,
                                        text: data.content[i].warranty
                                    } : null,
                                    available_warranty_msg:'',
                                    po_error_msg:'',
                                    specialUnitNo:'',
                                    specialItemsArr:[],
                                    selectedSpItemsArr:[],
                                    isItemModal:0,
                                    isItemErrorMsg:'',
                                    disable_task_id:false,
                                    bill_item_id:'',
                                    disable_billable:false,
                                    disable_amount_sublet:false,
                                    disable_po_sublet:false,
                                    disable_vendor_sublet:false,
                                    default_warehouse:true,
                                    isPartAdd:0,
                                    partAddArr:[]
                                });
                            }
                        },500);

                        self.activeLineItemIdx = 0;
                        self.currentTaskIndex = self.activeLineItemIdx;
                        self.displaySchedule = false;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'store-program-wo');
                }
            });
        },
        startStopTimeClick(flag,time_label,taskIndex) {
            var self = this;
            let parsedCurrentDate = moment(self.getCurrentDateTime()).format("MM/DD/YYYY HH:mm:ss");

            self.taskArr[taskIndex].add_time = 1;
            self.taskArr[taskIndex].log_time = parsedCurrentDate;
            self.logFlag = "log-new";
            self.logStartAt = parsedCurrentDate;
            //work order api call
            var validateTasks = 'validateTask';
            var taskFlag = 'labor';
            setTimeout(function () {

                self.CreateWorkOrder(validateTasks,taskFlag);

            }, 500);
        },
        startStopTimeNew(serviceTaskLaborId,time_label,taskIndex) {

            var self = this;

            for(var i = 0;i < self.laborArr.length;i++) {
                if (self.laborArr[i] != undefined && self.laborArr[i] != null) {
                    if (self.laborArr[i].service_task_id != null) {
                        if (self.laborArr[i].service_task_id.index == taskIndex) {
                            if (self.laborArr[i].service_task_id.index == taskIndex) {
                                if (self.laborArr[i].lid != 0 || self.laborArr[i].lid != null) {
                                    if (self.taskArr[taskIndex].task_labor != 0 || self.taskArr[taskIndex].task_labor != null) {
                                        if (self.laborArr[i].lid == self.taskArr[taskIndex].task_labor) {
                                            self.laborIndex = i;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            let parsedCurrentDate = moment(self.getCurrentDateTime()).format("MM/DD/YYYY HH:mm:ss");
            self.showActiveLaborLog = '';

            if (time_label.toLowerCase() == 'start log time') {

                //push element at 0 index
                self.laborHourArr.splice(0, 0, {
                    timelog_id: 0,
                    labor_id: serviceTaskLaborId,
                    start_time: parsedCurrentDate,
                    end_time: '-',
                    duration: '-',
                    labor_index: self.laborIndex,
                    labor_name:self.laborArr[self.laborIndex].laborid.text,
                    service_task_index:taskIndex
                });

                self.timeLabel = 'End Log Time';
                self.logFlag = "log-start";
                self.logStartAt = parsedCurrentDate;

            } else {

                //latest end time index of labor hour on basis of labor
                var index = self.laborHourArr.findIndex(x => (x.labor_index === self.laborIndex && x.end_time === "-" && x.duration_decimal === 0));

                self.laborHourArr[index]['end_time'] = parsedCurrentDate;
                self.checkDuration('no date', index);

                self.timeLabel = 'Start Log Time';
                self.logFlag = "log-end";
                self.logStartAt = parsedCurrentDate;

            }
            //work order api call
            var validateTasks = 'validateTask';
            var taskFlag = 'labor';
            setTimeout(function () {
                self.CreateWorkOrder(validateTasks,taskFlag);

            }, 500);
        },

        // startStopTime(serviceTaskLaborId, time_label) {

        //     var self = this;

        //     let parsedCurrentDate = moment(self.getCurrentDateTime()).format("MM/DD/YYYY H:mm");
        //     self.showActiveLaborLog = '';

        //     if (time_label.toLowerCase() == 'start log time') {
        //         //push element at 0 index
        //         self.laborHourArr.splice(0, 0, {
        //             timelog_id: 0,
        //             labor_id: serviceTaskLaborId,
        //             start_time: parsedCurrentDate,
        //             end_time: '-',
        //             duration: '-',
        //             labor_index: self.laborIndex
        //         });

        //         self.timeLabel = 'End Log Time'

        //     } else {

        //         //latest end time index of labor hour on basis of labor
        //         var index = self.laborHourArr.findIndex(x => (x.labor_index === self.laborIndex && x.end_time === "-" && x.duration === "-"));

        //         self.laborHourArr[index]['end_time'] = parsedCurrentDate;

        //         self.checkDuration('no date', index);

        //         self.timeLabel = 'Start Log Time';

        //     }

        // },

        addLine(index) {

            var self = this;
            var error = false;
            var index = self.laborHourArr.length;

            if (!error) {
                self.laborHourArr.push({
                    start_time: '',
                    end_time: '',
                    duration: ''
                })

                // this.updateListColumn(self.columnFilterArr[index - 1 ].columnId,'remove');

            }

        },
        removeLaborLine(evt, index) {
            var self = this;

            if (self.laborHourArr.length > 1) {

                self.laborHourArr.splice(index, 1);
            }
        },
        checkDuration(date, index) {
            var self = this;
            console.info('this', date);

            if (self.laborHourArr[index].start_time != '') {

                // self.laborHourArr[index].duration = self.calculateDays(self.laborHourArr[index].start_time, self.laborHourArr[index].end_time);
                var end_duration = self.calculateDays(self.laborHourArr[index].start_time, self.laborHourArr[index].end_time);
                self.laborHourArr[index].duration = self.durationToDecimal(end_duration);
            }

            if (self.laborHourArr.length > 0) {

                var totalHour = 0;
                var hour = 0;
                var minutes = 0;
                var durationArr = [];
                self.laborHourArr.forEach(element => {

                    /*hour += parseInt(time[0]);
                    minutes += parseInt(time[1]);
                    console.log(hour);
                    console.log(minutes);*/
                    if (element.labor_index == self.laborIndex) {
                        // hour += parseInt(time[0]);
                        // minutes += parseInt(time[1]);
                        // durationArr.push(element.duration);
                        totalHour += element.duration;
                    }

                });

                // totalHour = self.getTotalTime(durationArr);
                //append 0 in hour and minutes for serviceTaskLaborHour
                /*if(hour < 10){
                    hour = "0" + hour.toString();
                }

                if(minutes < 10){
                    minutes = "0" + minutes.toString();
                }*/
                // totalHour = self.getTotalTime(durationArr);

                // totalHour = hour+ ':'+minutes;

                self.serviceTaskLaborHour = parseFloat(totalHour).toFixed(2);
                //add time difference
                // self.serviceTaskLaborHour = self.getDifference(totalHour,self.serviceTaskLaborHour,"add");
            }
        },
        //to da - temp
        calculateDays(startDate, endDate) {

            var start = new Date(startDate);
            var end = new Date(endDate);
            var diff = end.getTime() - start.getTime();
            var time_difference = new Object();

            time_difference.hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= time_difference.hours * 1000 * 60 * 60;
            if (time_difference.hours < 10) time_difference.hours = "0" + time_difference.hours;

            time_difference.minutes = Math.floor(diff / 1000 / 60);
            diff -= time_difference.minutes * 1000 * 60;
            if (time_difference.minutes < 10) time_difference.minutes = "0" + time_difference.minutes;

            // return time_difference;
            return time_difference.hours + ':' + time_difference.minutes;

        },

        onCustomerChange() {
            var self = this;
            localStorage.removeItem('newCustomer');
            if (self.customer_id != null && self.customer_id.value != null) {
                self.getLaborCostValue();
                //self.getPriceBookValue();
                //self.fetchTaxRate();
            }
        },

        onAssetChange() {
            var self = this;
            localStorage.removeItem('newAsset');
            if (self.vehicle_id.value != null){
                if (self.vehicle_id.customer_id != undefined){
                    self.customer_id = {text:self.vehicle_id.customer,value:self.vehicle_id.customer_id};
                }else{
                    self.customer_id = {text:"000-00000000-000 | VTRL",value:0, stage:'existing'};
                }
                self.comment = self.vehicle_id.comment;
                self.comment_type = self.vehicle_id.commenttype;
                self.getLaborCostValue();
                //self.getPriceBookValue();
            }
        },
        checkoosForVehicle:function(veh_id){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/oos-by-vehicle/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    vehicle_id: veh_id,
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success'){
                        if (data.content.id){
                            self.oosCreated = true;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-oos');
                }
            });
        },

        getScheduledMaintenance(c_id, v_id) {
            var self = this;

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/get-scheduled-maintenance",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    customer_id: c_id,
                    vehicle_id: v_id,
                    flag:'wo'
                },
                success: function (data) {
                    self.loading = false;

                    // if(self.scheduleMaintenanceArr.length > 0){

                    self.schedule_maintenance_id = null;
                    self.scheduleMaintenanceArr = [];

                    // }

                    if (data.code == 200) {

                        if ( data.content.length > 0){

                            self.scheduleMaintenanceArr = data.content;

                            if ( self.scheduleMaintenanceArr){
                                var schArr = [];
                                var dueArr = [];
                                for(var i = 0; i < self.scheduleMaintenanceArr.length; i++){

                                    if (self.scheduleMaintenanceArr[i].status == 'due'){

                                        dueArr.push(self.scheduleMaintenanceArr[i].status);
                                    }

                                    if (self.scheduleMaintenanceArr[i].status == 'schedule'){

                                        schArr.push(self.scheduleMaintenanceArr[i].status);
                                    }
                                }

                                if ( !schArr.length ){

                                    self.scheduleNotFound = true;
                                }

                                if ( !dueArr.length){

                                    self.dueNotFound = true;
                                }
                            }
                            self.displaySchedule = true;
                        }else{
                            self.displaySchedule = false;
                            self.displayLineItem = true;
                            self.itemClass = 'undefined';
                            self.loadWorkOrder();
                        }

                        // $("#myModal").modal('show');

                    }else{
                        self.displaySchedule = false;
                        self.displayLineItem = true;
                        self.itemClass = 'undefined';
                        self.loadWorkOrder();
                        // $("#myModal").modal('hide');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-scheduled-maintenance');
                }
            });

        },
        getMappedProgram(v_id,woid) {
            var self = this;

            self.loading = true;
            var miles = 0;
            if (self.sectionArr.length){
                for(var i = 0;i<self.sectionArr.length;i++){
                    if(self.sectionArr[i].sectionName.trim() == 'Distance'){
                        miles = self.sectionArr[i].reading;
                    }
                }
            }

            $.ajax({
                url: process.env.ROOT_API + "/mapped-program/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    vehicle_id: v_id,
                    flag:'wo',
                    miles:miles,
                    open_date:self.open_date
                },
                success: function (data) {
                    self.loading = false;
                    self.scheduleMaintenanceArr = [];
                    if (data.code == 200) {

                        if ( data.content.program.length > 0 || data.content.warranty.length > 0){

                            self.scheduleMaintenanceArr = data.content.program;
                            self.warrantyTriggerArr = data.content.warranty;
                            self.woidForprogram = woid;

                            // if ( self.scheduleMaintenanceArr){
                            //     var schArr = [];
                            //     var dueArr = [];
                            //     for(var i = 0; i < self.scheduleMaintenanceArr.length; i++){

                            //         if (self.scheduleMaintenanceArr[i].status == 'due'){

                            //             dueArr.push(self.scheduleMaintenanceArr[i].status);
                            //         }

                            //         if (self.scheduleMaintenanceArr[i].status == 'schedule'){

                            //             schArr.push(self.scheduleMaintenanceArr[i].status);
                            //         }
                            //     }

                            //     if ( !schArr.length ){

                            //         self.scheduleNotFound = true;
                            //     }

                            //     if ( !dueArr.length){

                            //         self.dueNotFound = true;
                            //     }
                            // }
                            self.displaySchedule = true;
                        }else{
                            self.displaySchedule = false;
                            self.displayLineItem = true;
                            self.itemClass = 'undefined';
                            self.loadWorkOrder();
                        }

                        // $("#myModal").modal('show');

                    }else{
                        self.displaySchedule = false;
                        self.displayLineItem = true;
                        self.itemClass = 'undefined';
                        self.loadWorkOrder();
                        // $("#myModal").modal('hide');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-scheduled-maintenance');
                }
            });

        },

        saveServiceTaskLabor(serviceTaskLabor, task, taskIndex) {

            var self = this;
            var error = false;
            //add labor to laborArr if added new..
            var common_error = false;
            var index = self.serviceTaskLaborIndex;

            self.serviceTaskLabor_error_msg = '';
            self.serviceTaskLaborHour_error_msg = '';
            self.serviceTaskLaborHourRate_error_msg = '';

            if (serviceTaskLabor == null && self.taskArr[taskIndex].issublet != true) {
                self.serviceTaskLabor_error_msg = 'Specify Technician';
                error = true;
            }
            if(self.role != 'technician'){
                if (!self.serviceTaskLaborHour || self.serviceTaskLaborHour == null || self.serviceTaskLaborHour == "") {
                    self.serviceTaskLaborHour_error_msg = 'Labor Hours Required';
                    common_error = true;
                }
            }
            if( self.taskArr[taskIndex].issublet != true){
                /*if(self.role.toLowerCase() != 'technician'){
                    if (!self.serviceTaskLaborHourRate || self.serviceTaskLaborHourRate == null || self.serviceTaskLaborHourRate == "" ||  self.serviceTaskLaborHourRate <= 0) {

                        self.serviceTaskLaborHourRate_error_msg = 'Rate Required';
                        common_error = true;
                    }
                }
                if(self.role.toLowerCase() != 'technician'){
                    if ( self.serviceTaskLaborHour < 0 || self.serviceTaskLaborHour == null){

                        self.serviceTaskLaborHour_error_msg = 'Labor Hours Required';
                        common_error = true;
                    }
                }*/

                /*if ( self.serviceTaskLaborHourRate != "" && self.serviceTaskLaborHourRate == 0){

                    self.serviceTaskLaborHourRate_error_msg = 'Rate cannot be 0';
                    common_error = true;
                }*/

                // if ( !self.validateTime(self.serviceTaskLaborHour)){

                //     self.serviceTaskLaborHour_error_msg = 'Labor Hours should be in proper format';
                //     common_error = true;
                // }
            }


        if(!common_error){
            if (index == 'create') {

                for (var i = 0; i < self.laborArr.length; i++) {

                    if (self.laborArr[i].service_task_id.index == taskIndex) {
                        if (serviceTaskLabor != null && self.laborArr[i].laborid != null) {
                            if (self.laborArr[i].laborid.value == self.serviceTaskLabor.value && self.taskArr[taskIndex].issublet != true) {
                                self.serviceTaskLabor_error_msg = 'Technician Already Added';
                                error = true;
                            }
                        }
                    }
                }
            } else {
                //while update labor if labor is changed same as already added labor in current line item
                if (serviceTaskLabor != null) {
                    if (self.oldLaborUserId > 0 && (serviceTaskLabor.value != self.oldLaborUserId)) {
                        var laborIdArr = [];
                        for (var i = 0; i < self.laborArr.length; i++) {

                            if (self.laborArr[i].service_task_id.index == taskIndex) {
                                if (self.laborArr[i].laborid != null) {
                                    laborIdArr.push(self.laborArr[i].laborid.value);
                                }
                            }
                        }
                        if (laborIdArr.includes(serviceTaskLabor.value)) {
                            self.serviceTaskLabor_error_msg = 'Technician Already Added';
                            error = true;
                        }
                    }
                }
                var durationArr = [];

                for (var i = 0; i < self.laborHourArr.length; i++) {

                    if (self.laborHourArr[i].labor_index == self.laborIndex) {

                        if (self.laborHourArr[i].duration != '-') {
                            durationArr.push(self.laborHourArr[i].duration);
                        }
                    }
                }

                for (var i = 0; i < self.laborArr.length; i++) {

                    if (self.laborArr[i].service_task_id.index == taskIndex) {
                        if (serviceTaskLabor != null && self.laborArr[i].laborid != null) {
                            if (self.laborArr[i].laborid.value == self.serviceTaskLabor.value) {
                                if(self.toSeconds(self.serviceTaskLaborHour) < self.toSeconds(self.getTotalTime(durationArr))){
                                    self.serviceTaskLaborHour_error_msg = 'Labor Hours cannot be less.';
                                    error = true;
                                }
                            }
                        }
                    }
                }

            }

            if (!error) {

                if (index == 'create') {
                    var laborid = null;
                    if( serviceTaskLabor != null && serviceTaskLabor.value){
                        laborid = {value: serviceTaskLabor.value,text: serviceTaskLabor.text}
                    }
                    self.laborArr.push({
                        lid: 0,
                        laborid: laborid,
                        service_task_id: {
                            value: task.value,
                            text: task.text,
                            index: taskIndex
                        },
                        laborhours: self.serviceTaskLaborHour,
                        laborhourrate: self.serviceTaskLaborHourRate,
                        laborsubtotal: self.serviceTaskLaborSubTotal,
                        labordescription: self.labor_description
                    });

                    var laborIdx = self.laborArr.length - 1;

                    //Add extra hours if one has not permission to access add activity log...
                    if (!self.canAddLaborActivityLog) {

                        if (self.laborHourArr.length < 1) {
                            self.laborHourArr.push({
                                timelog_id: 0,
                                labor_id: self.serviceTaskLaborId,
                                start_time: '-',
                                end_time: '-',
                                duration: self.serviceTaskLaborHour,
                                labor_index: laborIdx,
                                labor_name:laborid.text,
                                service_task_index:taskIndex
                            });
                        } else {
                            self.laborHourArr.splice(0, 0, {
                                timelog_id: 0,
                                labor_id: self.serviceTaskLaborId,
                                start_time: '-',
                                end_time: '-',
                                duration: self.serviceTaskLaborHour,
                                labor_index: laborIdx,
                                labor_name:laborid.text,
                                service_task_index:taskIndex
                            });
                        }

                    }

                } else {

                    var laborid = null;
                    if( serviceTaskLabor != null && serviceTaskLabor.value){
                        laborid = {value: serviceTaskLabor.value,text: serviceTaskLabor.text}
                    }
                    self.laborArr[index].lid = (self.serviceTaskLaborId != 0) ? self.serviceTaskLaborId : 0;
                    self.laborArr[index].laborid = laborid,
                    self.laborArr[index].service_task_id = {
                        value: task.value,
                        text: task.text,
                        index: taskIndex
                    };
                    self.laborArr[index].laborhours = self.serviceTaskLaborHour;
                    self.laborArr[index].laborhourrate = self.serviceTaskLaborHourRate;
                    self.laborArr[index].laborsubtotal = self.serviceTaskLaborSubTotal;
                    self.laborArr[index].labordescription = self.labor_description;

                    if (!self.canAddLaborActivityLog) {

                        if (self.laborHourArr.length < 1) {

                            self.laborHourArr.splice(0, 0, {
                                timelog_id: 0,
                                labor_id: self.serviceTaskLaborId,
                                start_time: '-',
                                end_time: '-',
                                duration: self.getDifference(self.serviceTaskLaborHour, self.getTotalTime(durationArr), "diff"),
                                labor_index: self.laborIndex,
                                labor_name:laborid.text,
                                service_task_index:taskIndex
                            });

                        }else{

                            // if(self.serviceTaskLaborHour > self.getTotalTime(durationArr)){
                            if(self.toSeconds(self.serviceTaskLaborHour) > self.toSeconds(self.getTotalTime(durationArr))){
                                self.laborHourArr.splice(0,0,{
                                    timelog_id: 0,
                                    labor_id: self.serviceTaskLaborId,
                                    start_time: '-',
                                    end_time:'-',
                                    duration: self.getDifference(self.serviceTaskLaborHour,self.getTotalTime(durationArr),"diff"),
                                    labor_index: self.laborIndex,
                                    labor_name:laborid.text,
                                    service_task_index:taskIndex
                                });
                            }
                        }

                    }

                }

                // do not allow Technician to create new labor...
                // permission related changes
                self.serviceTaskLaborId = 0;
                self.serviceTaskLaborIndex = 'create';

                self.calculateTotalAmount();

                self.clearLabor();
                self.showActiveTaskLabor = '';
                self.currentTaskIndex = taskIndex;
                var validateTasks = 'validateTask';
                var taskFlag = 'labor';
                setTimeout(function () {

                    self.CreateWorkOrder(validateTasks,taskFlag);

                }, 500);

            }
        }
        },

        saveServiceTaskComp(serviceTaskComp, task, taskIndex,compFlag) {

            var self = this;
            var error = false;

            if (compFlag == 'issue_part' && self.selectedCompArr.length != undefined && self.selectedCompArr.length > 0){
                self.issueMultiple();
                return;
            }
            //for selected special order items as changes on 06/09/2021
            if (self.taskArr[taskIndex].isItemModal == 1) {
                var partArr = [];
                if (self.taskArr[taskIndex].selectedSpItemsArr != undefined) {
                    if (self.taskArr[taskIndex].selectedSpItemsArr.length > 0) {
                        for(var i = 0;i < self.taskArr[taskIndex].selectedSpItemsArr.length;i++) {
                            self.taskArr[taskIndex].selectedSpItemsArr[i].item_error_msg = "";
                            self.taskArr[taskIndex].selectedSpItemsArr[i].quantity_error_msg = "";
                            if (self.taskArr[taskIndex].selectedSpItemsArr[i].task_index == taskIndex) {
                                if (self.taskArr[taskIndex].selectedSpItemsArr[i].item == null || self.taskArr[taskIndex].selectedSpItemsArr[i].item == "") {
                                    self.taskArr[taskIndex].selectedSpItemsArr[i].item_error_msg = "Specify Component";
                                    error = true;
                                }
                                if (self.taskArr[taskIndex].selectedSpItemsArr[i].quantity == null || self.taskArr[taskIndex].selectedSpItemsArr[i].quantity == ""
                                    || !self.taskArr[taskIndex].selectedSpItemsArr[i].quantity || self.taskArr[taskIndex].selectedSpItemsArr[i].quantity == undefined) {
                                    self.taskArr[taskIndex].selectedSpItemsArr[i].quantity_error_msg = "Quantity is Required";
                                    error = true;
                                } else if (self.taskArr[taskIndex].selectedSpItemsArr[i].quantity == 0) {
                                    self.taskArr[taskIndex].selectedSpItemsArr[i].quantity_error_msg = "Quantity can not be 0";
                                    error = true;
                                }
                                //generate array with part and quantity entered
                                if (self.taskArr[taskIndex].selectedSpItemsArr[i].item != null) {
                                    var enteredQty = self.taskArr[taskIndex].selectedSpItemsArr[i].quantity;
                                    var itemCode = self.taskArr[taskIndex].selectedSpItemsArr[i].item_code;
                                    partArr.push({
                                        item_id:self.taskArr[taskIndex].selectedSpItemsArr[i].item.value,
                                        item_code:(itemCode != null && itemCode != "")?itemCode:"",
                                        item_qty:self.taskArr[taskIndex].selectedSpItemsArr[i].item.quantity,
                                        is_non_inv_item:self.taskArr[taskIndex].selectedSpItemsArr[i].item.is_non_inv_item,
                                        qty:(enteredQty != null && enteredQty != "")?parseInt(enteredQty):0,
                                        comp_index:i,
                                        bin_id:self.taskArr[taskIndex].selectedSpItemsArr[i].item.bin_id,
                                        category_code:self.taskArr[taskIndex].selectedSpItemsArr[i].item.category_code
                                    })
                                }
                            }
                        }
                        if (partArr.length > 0) {
                            var uniquePartArr = [];
                            for (var i = 0;i < partArr.length;i++) {
                                if (partArr[i].item_id != undefined && partArr[i].item_id != null) {
                                    let itemIdx = uniquePartArr.findIndex( ip => ip.item_id === partArr[i].item_id );
                                    if (itemIdx == -1) {
                                        uniquePartArr.push({
                                            item_id:partArr[i].item_id,
                                            item_code:partArr[i].item_code,
                                            item_qty:partArr[i].item_qty,
                                            is_non_inv_item:partArr[i].is_non_inv_item,
                                            entered_qty:partArr[i].qty,
                                            comp_index:partArr[i].comp_index,
                                            part_count:1,
                                            bin_id:partArr[i].bin_id,
                                            category_code:partArr[i].category_code
                                        })
                                    }else{
                                        if (uniquePartArr[itemIdx] != undefined && uniquePartArr[itemIdx] != null) {
                                            var oldQty = uniquePartArr[itemIdx].entered_qty;
                                            var newQty = oldQty;
                                            newQty += partArr[i].qty;
                                            uniquePartArr[itemIdx].entered_qty = newQty;
                                            var oldPartCnt = uniquePartArr[itemIdx].part_count;
                                            uniquePartArr[itemIdx].part_count = oldPartCnt + 1;
                                        }
                                    }

                                }
                            }
                            //check total qty entered and item inventory qty
                            if (uniquePartArr.length > 0) {
                                for (var i = 0;i < uniquePartArr.length;i++) {
                                    if (uniquePartArr[i].category_code != undefined && uniquePartArr[i].category_code != null) {
                                        if (uniquePartArr[i].category_code != "SHOP") {
                                            if (uniquePartArr[i].entered_qty > uniquePartArr[i].item_qty) {
                                                var spItemIndex = uniquePartArr[i].comp_index;
                                                var errorMsg = "Quantity not available in inventory";
                                                if (uniquePartArr[i].part_count > 1) {
                                                    errorMsg = "Total entered quantity not available in inventory for part " + uniquePartArr[i].item_code;
                                                }
                                                if (spItemIndex != undefined && spItemIndex != null) {
                                                    self.taskArr[taskIndex].selectedSpItemsArr[spItemIndex].quantity_error_msg = "";
                                                    self.taskArr[taskIndex].selectedSpItemsArr[spItemIndex].quantity_error_msg = errorMsg;
                                                    error = true;
                                                }else{
                                                    self.$swal('',errorMsg,'info');
                                                    error = true;
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (!error) {
                    var selectedItems = self.taskArr[taskIndex].selectedSpItemsArr;

                    for(var i = 0;i < selectedItems.length;i++) {
                        self.compArr.push({
                            cid: 0,
                            compid: {
                                value: selectedItems[i].item.value,
                                text: selectedItems[i].item.text,
                                bin_id:selectedItems[i].item.bin_id,
                                category_code:selectedItems[i].item.category_code
                            },
                            service_task_id: {
                                value: task.value,
                                text: task.text,
                                index: taskIndex
                            },
                            compcost: self.removeFormat(selectedItems[i].comp_cost),
                            compquantity: selectedItems[i].quantity,
                            compsubtotal: selectedItems[i].comp_subtotal,
                            compdescription: selectedItems[i].description,
                            estimatedcid: 0,
                            oldquantity: selectedItems[i].quantity,
                            comp_flag:compFlag,
                            is_issued:1,
                            wr_location:selectedItems[i].item.po_location,
                        });
                    }
                    self.calculateTotalAmount();

                    self.clearServiceTaskComp(taskIndex);
                    self.showActiveTaskLabor = '';
                    self.currentTaskIndex = taskIndex;
                    var validateTasks = 'validateTask';
                    var taskFlag = 'component';
                    setTimeout(function () {

                        self.CreateWorkOrder(validateTasks,taskFlag);

                    }, 500);
                }
                return;
            }
            //multiple part issue changes on 22/08/2022
            if (self.taskArr[taskIndex].isPartAdd == 1) {
                if (self.taskArr[taskIndex].partAddArr != undefined) {
                    if (self.taskArr[taskIndex].partAddArr.length > 0) {
                        for(var i = 0;i < self.taskArr[taskIndex].partAddArr.length;i++) {
                            self.taskArr[taskIndex].partAddArr[i].item_error_msg = "";
                            self.taskArr[taskIndex].partAddArr[i].quantity_error_msg = "";
                            if (self.taskArr[taskIndex].partAddArr[i].task_index == taskIndex) {
                                if (self.taskArr[taskIndex].partAddArr[i].item == null || self.taskArr[taskIndex].partAddArr[i].item == "") {
                                    self.taskArr[taskIndex].partAddArr[i].item_error_msg = "Specify Component";
                                    error = true;
                                }
                                if (self.taskArr[taskIndex].partAddArr[i].quantity == null || self.taskArr[taskIndex].partAddArr[i].quantity == ""
                                    || !self.taskArr[taskIndex].partAddArr[i].quantity || self.taskArr[taskIndex].partAddArr[i].quantity == undefined) {
                                    self.taskArr[taskIndex].partAddArr[i].quantity_error_msg = "Quantity is Required";
                                    error = true;
                                } else if (self.taskArr[taskIndex].partAddArr[i].quantity == 0) {
                                    self.taskArr[taskIndex].partAddArr[i].quantity_error_msg = "Quantity can not be 0";
                                    error = true;
                                }
                                //generate array with part and quantity entered
                                // if (self.taskArr[taskIndex].partAddArr[i].item != null) {
                                //     var enteredQty = self.taskArr[taskIndex].partAddArr[i].quantity;
                                //     var itemCode = self.taskArr[taskIndex].partAddArr[i].item.category_code;
                                //     var avlQty = self.taskArr[taskIndex].partAddArr[i].item.quantity;
                                //     if (itemCode != undefined && itemCode != null && itemCode != "") {
                                //         if (itemCode != "SHOP") {
                                //             if (avlQty != undefined && avlQty != null && avlQty != "") {
                                //                 if (enteredQty != null && enteredQty != ""){
                                //                     if (enteredQty > avlQty){
                                //                         self.taskArr[taskIndex].partAddArr[i].quantity_error_msg = 'Quantity not available in inventory';
                                //                         error = true;
                                //                     }
                                //                 }
                                //             }
                                //         }
                                //     }
                                // }
                            }
                        }
                    }
                }
                if (!error) {
                    var addItems = self.taskArr[taskIndex].partAddArr;
                    for(var i = 0;i < addItems.length;i++) {
                        self.compArr.push({
                            cid: 0,
                            compid: {
                                value: addItems[i].item.value,
                                text: addItems[i].item.text,
                                bin_id:addItems[i].item.bin_id,
                                is_non_inv_item:addItems[i].item.is_non_inv_item,
                                category_code:addItems[i].item.category_code
                            },
                            service_task_id: {
                                value: task.value,
                                text: task.text,
                                index: taskIndex
                            },
                            compcost: self.removeFormat(addItems[i].comp_cost),
                            compquantity: addItems[i].quantity,
                            compsubtotal: addItems[i].comp_subtotal,
                            compdescription: addItems[i].description,
                            estimatedcid: 0,
                            oldquantity: addItems[i].quantity,
                            comp_flag:compFlag,
                            is_issued:addItems[i].is_issued,
                            wr_location:addItems[i].item.wr_location,
                            warehouse_id:addItems[i].warehouse_id != undefined ? addItems[i].warehouse_id : null
                        });
                    }
                    self.calculateTotalAmount();

                    self.clearServiceTaskComp(taskIndex);
                    self.showActiveTaskLabor = '';
                    self.currentTaskIndex = taskIndex;
                    var validateTasks = 'validateTask';
                    var taskFlag = 'component';
                    self.taskArr[taskIndex].hasComp = true;
                    setTimeout(function () {

                        self.CreateWorkOrder(validateTasks,taskFlag);

                    }, 500);
                }
                return;
            }
            //add comp to compArr if added new..

            var index = self.serviceTaskCompIndex;

            self.serviceTaskComp_error_msg = '';
            self.serviceTaskQty_error_msg = '';

            if (serviceTaskComp == null) {
                self.serviceTaskComp_error_msg = 'Specify Component';
                error = true;
            }
            if (self.serviceTaskCompQuantity == null || self.serviceTaskCompQuantity == "" || !self.serviceTaskCompQuantity || self.serviceTaskCompQuantity == undefined) {
                self.serviceTaskQty_error_msg = "Quantity is Required";
                error = true;
            } else if (self.serviceTaskCompQuantity == 0) {
                self.serviceTaskQty_error_msg = "Quantity can not be 0";
                error = true;
            }
            if (index == 'create') {
                // if (serviceTaskComp != null && serviceTaskComp.category_code != null) {
                //     //Prevent validation for Shop Supplies SS01 Part
                //     if (serviceTaskComp.category_code != "SHOP") {
                //         if (serviceTaskComp.quantity && self.serviceTaskCompQuantity > serviceTaskComp.quantity){
                //             self.serviceTaskQty_error_msg = 'Quantity not available in inventory';
                //             error = true;
                //         }
                //     }
                // }
            }else{
                //update part quantity
                if (serviceTaskComp != null && serviceTaskComp.category_code != null) {
                    //Prevent validation for Shop Supplies SS01 Part
                    // if (serviceTaskComp.category_code != "SHOP") {
                    //     if (serviceTaskComp.quantity != undefined && serviceTaskComp.quantity != null) {
                    //         var checkQty = 0;
                    //         var oldQty = self.compArr[index].oldquantity;
                    //         var inventoryQty = serviceTaskComp.quantity;
                    //         checkQty = oldQty + inventoryQty;
                    //         if (self.serviceTaskCompQuantity > checkQty) {
                    //             self.serviceTaskQty_error_msg = 'Quantity not available in inventory';
                    //             error = true;
                    //         }
                    //     }
                    // }
                }
            }

            if (!error) {

                if (index == 'create') {

                    self.compArr.push({
                        cid: 0,
                        compid: {
                            value: serviceTaskComp.value,
                            text: serviceTaskComp.text,
                            bin_id: serviceTaskComp.bin_id != undefined ? serviceTaskComp.bin_id : null
                        },
                        service_task_id: {
                            value: task.value,
                            text: task.text,
                            index: taskIndex
                        },
                        compcost: self.removeFormat(self.serviceTaskCompCost),
                        compquantity: self.serviceTaskCompQuantity,
                        compsubtotal: self.serviceTaskCompSubTotal,
                        compdescription: self.comp_description,
                        estimatedcid: 0,
                        oldquantity: self.serviceTaskCompQuantity,
                        comp_flag:compFlag,
                        is_issued:self.serviceTaskIssued,
                        wr_location:self.wr_location,
                        warehouse_id:serviceTaskComp.warehouse_id != undefined ? serviceTaskComp.warehouse_id : null
                    });

                } else {

                    self.compArr[index].cid = (self.serviceTaskCompId != 0) ? self.serviceTaskCompId : 0;
                    self.compArr[index].compid = {
                        value: serviceTaskComp.value,
                        text: serviceTaskComp.text,
                        bin_id: serviceTaskComp.bin_id != undefined ? serviceTaskComp.bin_id : null
                    };
                    self.compArr[index].service_task_id = {
                        value: task.value,
                        text: task.text,
                        index: taskIndex
                    };
                    self.compArr[index].compcost = self.removeFormat(self.serviceTaskCompCost);
                    self.compArr[index].compquantity = self.serviceTaskCompQuantity;
                    self.compArr[index].compsubtotal = self.serviceTaskCompSubTotal;
                    self.compArr[index].compdescription = self.comp_description;
                    self.compArr[index].estimatedcid = (self.serviceTaskEstimateCompId != 0) ? self.serviceTaskEstimateCompId : 0;
                    self.compArr[index].oldquantity = self.serviceTaskCompQuantity;
                    self.compArr[index].comp_flag = compFlag,
                    self.compArr[index].is_issued = self.serviceTaskIssued,
                    self.compArr[index].wr_location = self.wr_location,
                    self.compArr[index].warehouse_id = serviceTaskComp.warehouse_id != undefined ? serviceTaskComp.warehouse_id : null

                }

                self.serviceTaskCompId = 0;
                self.serviceTaskEstimateCompId = 0;
                self.serviceTaskCompIndex = 'create';

                self.calculateTotalAmount();

                self.clearServiceTaskComp(taskIndex);
                self.showActiveTaskLabor = '';
                // self.isEditLabor = false;
                self.currentTaskIndex = taskIndex;
                var validateTasks = 'validateTask';
                var taskFlag = 'component';
                setTimeout(function () {

                    self.CreateWorkOrder(validateTasks,taskFlag);

                }, 500);

            }
        },
        issueMultiple:function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/issue-multiple/part",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    components: self.selectedCompArr,
                },
                success: function (data) {
                    self.loading = false;
                    if (data.code == 201) {
                        self.$swal('',data.content,'info');
                    }else{
                        self.$swal('','Part issued succesfully','info');
                        if (self.selectedCompArr && self.selectedCompArr.length){
                            for(var i=0;i<self.selectedCompArr.length;i++){
                                $("#workorderpart"+self.selectedCompArr[i].id).prop('checked',false);
                            }
                        }
                        self.selectedCompArr = [];
                        self.workOrderItemData('');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'issue-multiple-part');
                }
            });
        },

        editServiceTask(edit, index, serviceTaskIndex) {
            var self = this;
            self.currentTaskIndex = serviceTaskIndex;
            if (edit == 'labor') {
                self.serviceTaskLabor_error_msg = "";
                self.serviceTaskLaborHour_error_msg = "";
                self.showActiveTaskLabor = 'addLabor' + serviceTaskIndex;
                // self.showActiveLaborLog = '';

                // to do - remove labor from the laborArray.... already saved or not...
                self.serviceTaskLabor = self.laborArr[index].laborid;
                self.serviceTaskLaborHour = self.laborArr[index].laborhours;
                self.serviceTaskLaborHourRate = self.laborArr[index].laborhourrate;
                self.serviceTaskLaborSubTotal = self.laborArr[index].laborsubtotal;

                self.labor_description = self.laborArr[index].labordescription;

                //to edit service task labor...
                self.serviceTaskLaborId = self.laborArr[index].lid;
                self.serviceTaskLaborIndex = index;
                self.laborIndex = index;
                if (self.serviceTaskLabor != null) {
                    self.oldLaborUserId = self.serviceTaskLabor.value;
                }

                //permission related changes
                // $("#serviceTaskLabor").addClass("disable-field");
                //disable in case of technician and service manager
                /*if (self.canAddLaborActivityLog && (self.role.toLowerCase() == "technician" || self.role.toLowerCase() == "service manager")) {
                    $("#serviceTaskLaborHour" + serviceTaskIndex).addClass("disable-field");
                }*/
                if (self.serviceTaskLabor != null) {
                    // if (self.role == 'technician') {
                    //     self.disableTechnicianField = true; //Role is Technician then disable search
                    // }else{
                    //     self.disableTechnicianField = true;
                    // }

                }

                //FOr labor log time
                var haslaborHour = false;
                var hasDuration = false; //labor time log has duration
                for (var i = 0; i < self.laborHourArr.length; i++) {

                    if (self.laborHourArr[i].labor_index == self.serviceTaskLaborIndex) {

                        if (self.laborHourArr[i].duration == '-') {
                            self.timeLabel = 'End Log Time';
                            hasDuration = true;
                            self.taskArr[serviceTaskIndex].log_btn_title = 'End Log Time';
                        }
                    }

                    //check whether labor hour present or not
                    if (self.laborHourArr[i].labor_index == self.laborIndex) {
                        haslaborHour = true;
                    }
                }

                if (!hasDuration) {
                    self.timeLabel = 'Start Log Time';
                    self.taskArr[serviceTaskIndex].log_btn_title = 'Start Log Time';
                } else {
                    self.timeLabel = 'End Log Time';
                    self.taskArr[serviceTaskIndex].log_btn_title = 'End Log Time';
                }

                if (!haslaborHour) {
                    self.showActiveLaborLog = 'addLaborLog';
                } else {
                    self.showActiveLaborLog = '';
                }

            } else {

                self.showActiveTaskLabor = 'addComponent' + serviceTaskIndex;

                // to do - remove comp from the compArray.... already saved or not...

                self.serviceTaskComp = self.compArr[index].compid;
                self.serviceTaskCompCost = self.compArr[index].compcost;
                self.serviceTaskCompQuantity = self.compArr[index].compquantity;
                self.serviceTaskCompSubTotal = self.compArr[index].compsubtotal;

                self.comp_description = self.compArr[index].compdescription;

                //to edit service task labor...
                self.serviceTaskCompId = self.compArr[index].cid;
                self.serviceTaskEstimateCompId = self.compArr[index].estimatedcid;
                self.serviceTaskCompIndex = index;
                self.serviceTaskIssued = self.compArr[index].is_issued

            }

        },

        clearComment() {

            var self = this;
            self.workOrderCommentId = 0;
            self.workOrderCId = 0;
            self.workOrderCommentIndex = 'create';
            self.comment_type_id = null;
            self.comment = '';
            self.comment_type_error_msg = "";
            self.comment_error_msg = "";

        },

        clearLabor() {

            var self = this;
            self.serviceTaskLaborSubTotal = 0;
            self.serviceTaskLaborHour = '0';
            self.serviceTaskLaborHourRate = 0;
            self.serviceTaskLabor_error_msg = "";
            self.serviceTaskLaborHourRate_error_msg = "";

            self.labor_description = '';

            self.serviceTaskLaborIndex = 'create';
            self.serviceTaskLaborId = 0;
            self.serviceTaskLabor = null;
            self.oldLaborUserId = 0;
            // self.isEditLabor = false;

            //permission related changes
            // $("#serviceTaskLabor").addClass("disable-field");
            // $("#serviceTaskLaborHour").addClass("disable-field");

            // PR - self.canViewWoSummary => false => one can not edit labor hours...
            // if (self.canAddLaborActivityLog) {
                if (self.role != 'admin'){

                    self.serviceTaskLabor = self.loggedInUser;
                    if (self.role == 'technician') {
                        //disable according to permission of techinician add
                        // self.disableTechnicianField = true; //Role is Technician then disable search
                    }else{
                        self.disableTechnicianField = false;
                    }
                }else{
                    self.disableTechnicianField = false;
                }
                // $("#serviceTaskLaborHour").addClass("disable-field");

            // }

        },
        clearService(taskIndex){
            var self = this;
            self.taskArr[taskIndex].isPartAdd = 0;
            self.taskArr[taskIndex].partAddArr = [];
            self.showActiveLaborLog = '';
            self.showTab = 'labor';
            self.serviceTaskActive = 'active';
            self.laborActive = '';
            self.partActive = '';
            self.activityActive = '';
            self.showActivity = '';
            self.showActiveTaskLabor = '';
        },

        clearServiceTaskComp(taskIndex) {

            var self = this;
            self.serviceTaskCompSubTotal = 0;
            self.serviceTaskCompQuantity = 0;
            self.serviceTaskCompCost = 0;

            self.comp_description = '';

            self.serviceTaskCompIndex = 'create';
            self.serviceTaskCompId = 0;
            self.serviceTaskEstimateCompId = 0;

            self.serviceTaskComp = null;
            self.serviceTaskQty_error_msg = "";
            self.serviceTaskComp_error_msg = "";
            self.uncheckSpItem(taskIndex);
            self.taskArr[taskIndex].selectedSpItemsArr = [];
            self.taskArr[taskIndex].isItemModal = 0;
            self.taskArr[taskIndex].isPartAdd = 0;
            self.taskArr[taskIndex].partAddArr = [];

        },

        calculateTaxDiscountAmount() {
            var self = this;
            var partAmt = parseFloat(self.tax * self.billable_part_amount);
            var partTaxAmt = partAmt/100;
            var shopSupplyAmt = (self.tax * self.shop_supplies)/100;
            var totalTaxAmt = partTaxAmt + shopSupplyAmt;
            self.total_tax = Math.round(totalTaxAmt);
            self.total_discount = parseFloat((self.discount / 100) * self.sub_total);
            self.total = self.total_tax + parseFloat(self.sub_total) - self.total_discount + self.other_charges + self.shop_supplies;
        },

        calculateSubTotalForLabor() {

            var self = this;

            self.serviceTaskLaborSubTotal = 0;

            if (self.serviceTaskLaborHour || self.serviceTaskLaborHourRate) {

                if(self.serviceTaskLaborHour=='NaN:NaN'){
                    self.serviceTaskLaborHour=0;
                }
                 self.serviceTaskLaborSubTotal = self.getNum(parseFloat(self.serviceTaskLaborHour * self.removeFormat(self.serviceTaskLaborHourRate)));

                // var hourTotal = self.serviceTaskLaborHour.split(':');

                // //labor per minute rate...

                // var perMinuteRate = self.serviceTaskLaborHourRate / 60;

                // var lHourRate = parseFloat(hourTotal[0] * self.serviceTaskLaborHourRate);

                // var lMinuteRate = 0;
                // if (hourTotal[1]) {

                //     lMinuteRate = parseFloat(hourTotal[1] * perMinuteRate);

                // }

                // self.serviceTaskLaborSubTotal = parseFloat(lHourRate + lMinuteRate);

                // var hourTotal = self.serviceTaskLaborHour.split(':');

                // self.serviceTaskLaborSubTotal = parseFloat(self.serviceTaskLaborHourRate * hourTotal[0]);

            }

        },

        calculateSubTotalForComp() {

            var self = this;

            self.serviceTaskCompSubTotal = 0;

            if (self.serviceTaskCompCost || self.serviceTaskCompQuantity) {

                //to handle NaN scenario while input part quantity and rate
                if (self.serviceTaskCompQuantity != "" && self.serviceTaskCompQuantity != "-" && self.serviceTaskCompQuantity != "."
                    && self.serviceTaskCompCost != "" && self.serviceTaskCompCost != "-" && self.serviceTaskCompCost != ".") {
                    self.serviceTaskCompSubTotal = parseFloat(self.removeFormat(self.serviceTaskCompCost) * self.serviceTaskCompQuantity);
                }

            }
        },

        calculateTotalAmount() {
            var self = this;
            self.labor_total = 0;
            self.parts_total = 0;
            self.sub_total = 0;

            // For Service Tasks
            var labor_charge = 0,
                parts_charge = 0,
                charge_amount = 0,
                subtotal_val = 0;

            for (var i = 0; i < self.taskArr.length; i++) {
                if (self.taskArr[i].laboramount || self.taskArr[i].partamount) {

                    //if labor and component does not have perticular task's index...

                    subtotal_val = parseInt(self.taskArr[i].laboramount) + parseInt(self.taskArr[i].partamount);

                    self.taskArr[i].subtotal = subtotal_val;

                    if (self.taskArr[i].hasLabor != true) {

                        labor_charge += (parseInt(self.taskArr[i].laboramount));

                    }

                    if (self.taskArr[i].hasComp != true) {

                        parts_charge += (parseInt(self.taskArr[i].partamount));

                    }

                    if (self.taskArr[i].hasComp != true && self.taskArr[i].hasLabor != true) {

                        charge_amount += subtotal_val;

                    } else if (self.taskArr[i].hasComp == false && self.taskArr[i].hasLabor == true) {

                        charge_amount += parts_charge;

                    } else if (self.taskArr[i].hasComp == true && self.taskArr[i].hasLabor == false) {

                        charge_amount += labor_charge;

                    }

                }
            }

            //For Labor
            var labor_subtotal = 0;
            for (var i = 0; i < self.laborArr.length; i++) {
                if (self.laborArr[i].laborhours || self.laborArr[i].laborhourrate) {

                    labor_charge += parseFloat(self.laborArr[i].laborhours * self.laborArr[i].laborhourrate);
                    labor_subtotal = parseFloat(self.laborArr[i].laborhours * self.laborArr[i].laborhourrate);
                    self.laborArr[i].laborsubtotal = labor_subtotal;
                    charge_amount += labor_subtotal;

                }
            }

            //For Component
            var comp_subtotal = 0;

            for (var i = 0; i < self.compArr.length; i++) {
                if (self.compArr[i].compquantity || self.compArr[i].compcost) {

                    parts_charge += parseFloat(self.compArr[i].compquantity * self.compArr[i].compcost);

                    comp_subtotal = parseFloat(self.compArr[i].compquantity * self.compArr[i].compcost);

                    self.compArr[i].compsubtotal = comp_subtotal;

                    charge_amount += comp_subtotal;

                }
            }

            self.labor_total += labor_charge;
            self.parts_total += parts_charge;
            self.sub_total += charge_amount;
            self.calculateTaxDiscountAmount();

        },

        taskchange(evt) {
            var self = this;
            if(self.showTab == 'activity') {
              self.activityActive = 'active';
            } else {
              self.activityActive = '';
            }

            var index = self.taskArr.length - 1;

            var issubVal = 0;
            if (!self.assetRequired){
                issubVal = 1;
            }
            var l_no = 1;
            if (self.taskArr[index] != undefined
                && self.taskArr[index].line_number != undefined
                && self.taskArr[index].line_number > 0
            ){
                l_no = parseInt(self.taskArr[index].line_number) + 1;
            }

            if (evt != null) {

                if (self.taskArr.length < 1) {

                    self.taskArr.push({
                        woiId: 0,
                        line_number:l_no,
                        unit_id:null,
                        taskid: null,
                        component_category_id: null,
                        wi_reason_id: null,
                        billable_code: null,
                        defect_id: null,
                        woistatus: {
                            value: "open",
                            text: "Open"
                        },
                        issublet: issubVal,
                        purchaseorderid: null,
                        po_number:'',
                        vendorid: null,
                        woinotes: '',
                        woicomplaint: '',
                        woicause: '',
                        woicorrection: '',
                        laboramount: 0,
                        partamount: 0,
                        subtotal: 0,
                        hasLabor: false,
                        hasComp: false,
                        hasComment: false,
                        estimatedwoiId: 0,
                        estimatedlaboramount: 0,
                        disable_task:false,
                        labor_found:0,
                        log_btn_title:"Start Log Time",
                        task_labor_user:0,
                        service_task_index:0,
                        log_found:0,
                        sublet_amount:0,
                        disable_sublet:false,
                        warrantyArr:[],
                        warranty_id:'',
                        specialUnitNo:'',
                        specialItemsArr:[],
                        selectedSpItemsArr:[],
                        isItemModal:0,
                        isItemErrorMsg:'',
                        disable_task_id:false,
                        bill_item_id:'',
                        disable_billable:false,
                        disable_amount_sublet:false,
                        disable_po_sublet:false,
                        disable_vendor_sublet:false,
                        default_warehouse:true,
                        isPartAdd:0,
                        partAddArr:[],
                        etc_reason:'',
                        etcExtend:false
                    });

                    //in order to show entire line item on add line item button click...
                    self.activeLineItemIdx = self.taskArr.length - 1;
                    self.currentTaskIndex = self.activeLineItemIdx;

                    if (!self.assetRequired){
                        self.$set(self.taskArr[self.activeLineItemIdx],'issublet',true);

                        // billableCodeArr
                        if (self.billableCodeArr && self.billableCodeArr.length > 0) {
                            for (var j = 0; j < self.billableCodeArr.length;j++) {
                                if (self.billableCodeArr[j].value == 'S'){
                                    self.taskArr[self.activeLineItemIdx].billable_code = self.billableCodeArr[j];
                                }
                            }
                        }
                    }

                } else {

                    //work order line items validations
                    $("#unit_id" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#component_category_id" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#taskid" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#billable_code" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#woistatus" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#woicomplaint" + index).removeClass('border-red');
                    $("#woicause" + index).removeClass('border-red');
                    $("#woicorrection" + index).removeClass('border-red');
                    $("#common_error_msg" + index).html('');    //remove common error message
                    $("#vendorid" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#sublet_amount" + index).removeClass('border-red');
                    $("#etc_reason" + index).removeClass('border-red');
                   // $("#po_number" + index).removeClass('border-red');
                    $("#line_number" + index).removeClass('border-red');
                    var isBillOptional = true;
                    if (self.taskArr[index].woistatus.value == "closed") {
                      if (self.taskArr[index].billable_code == null || !self.taskArr[index].billable_code.value) {
                          isBillOptional = false;
                      }
                    }

                    if (self.taskArr[index].taskid != null && self.taskArr[index].component_category_id != null && isBillOptional == true ) {

                        var validateTasks = 'validateTask';
                        var taskFlag = 'loadAfterSave';

                        self.CreateWorkOrder(validateTasks,taskFlag);

                    } else {
                        //validation for tasks
                        for (var i = 0; i < self.taskArr.length; i++) {

                            if (!self.assetRequired){
                                if (self.taskArr[i].unit_id == null || !self.taskArr[i].unit_id.value) {
                                    $("#unit_id" + i + " .dropdown-toggle").addClass('border-red');
                                }
                            }
                            if (self.taskArr[i].component_category_id == null || !self.taskArr[i].component_category_id.value) {
                                $("#component_category_id" + i + " .dropdown-toggle").addClass('border-red');
                            }
                            if (self.taskArr[i].line_number == null || self.taskArr[i].line_number == '') {
                                $("#line_number" + i).addClass('border-red');
                            }

                            if (self.taskArr[i].taskid == null || !self.taskArr[i].taskid.value) {
                                $("#taskid" + i + " .dropdown-toggle").addClass('border-red');
                            }

                            if (self.taskArr[index].woistatus.value == "closed") {
                              if (self.taskArr[i].billable_code == null || !self.taskArr[i].billable_code.value) {
                                  $("#billable_code" + i + " .dropdown-toggle").addClass('border-red');
                              }
                            }

                            if (self.taskArr[i].woistatus == null || !self.taskArr[i].woistatus.value) {
                                $("#woistatus" + i + " .dropdown-toggle").addClass('border-red');
                            }
                            if (self.taskArr[i].issublet == true) {
                                if (self.taskArr[i].purchaseorderid == null || !self.taskArr[i].purchaseorderid.value) {
                                    if (self.taskArr[i].vendorid == null || !self.taskArr[i].vendorid.value) {
                                        $("#vendorid" + i + " .dropdown-toggle").addClass('border-red');
                                    }
                                }
                                if (self.taskArr[i].sublet_amount == null || !self.taskArr[i].sublet_amount) {
                                    $("#sublet_amount" + i).addClass('border-red');
                                }
                                //  if (self.taskArr[i].po_number == null || self.taskArr[i].po_number == '') {
                                //     $("#po_number" + i).addClass('border-red');
                                // }
                            }
                            if (self.taskArr[i].etcExtend != undefined && self.taskArr[i].etcExtend == true){
                                if (self.taskArr[i].etc_reason == null || self.taskArr[i].etc_reason == '' ) {
                                    $("#etc_reason" + i).addClass('border-red');
                                }
                            }
                            if (self.assetRequired && self.taskArr[index] && (self.taskArr[index].woistatus.value == 'closed' || self.taskArr[index].woistatus.value == 'review')){

                                if (self.taskArr[i].woicomplaint == "" || self.taskArr[i].woicomplaint == '') {
                                $("#woicomplaint" + i).addClass('border-red');
                                }
                                if (self.taskArr[i].woicause == "" || self.taskArr[i].woicause == '') {
                                    $("#woicause" + i).addClass('border-red');
                                }
                                if (self.taskArr[i].woicorrection == "" || self.taskArr[i].woicorrection == '') {
                                    $("#woicorrection" + i).addClass('border-red');
                                }
                            }
                        }
                    }
                }

                // In order to map labor/component with task..
                self.serviceTaskArr.push({
                    value: evt.value,
                    text: evt.text,
                    index: self.taskArr.length - 1
                });
            }

            self.task_id = {};
        },

        laborchange(evt) {
            var self = this;

            if (evt != null) {

                self.laborArr.push({
                    lid: 0,
                    laborid: {
                        value: evt.value,
                        text: evt.text
                    },
                    service_task_id: null,
                    laborhours: 0,
                    laborhourrate: 0,
                    laborsubtotal: 0
                });
            }

            self.labor_id = {};
        },

        BackWorkOrderList() {
            var self = this;

            // remove localStorage value
            localStorage.removeItem('newAsset');
            localStorage.removeItem('newCustomer');

            if (self.$route.params.redirectFrom != undefined && self.$route.params.redirectFrom == 'CustomerEstimateList'){
                self.$router.push("/estimate?active=customer");
                return;
            }
            self.$router.push("/workorder/list");
        },

        onSearchPurchaseOrder(search, loading) {
            var self = this;
            /*if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'purchase_order', '');
            }*/
            // if (search.length > 0 && self.customer_id != null && self.customer_id.value && self.customer_id.value != '') {
                // loading(true);
            if (search.length > 0 ){
                // self.searchPo(search, self.customer_id.value);
                self.searchPo(search);
            }
        },
        //purchase order for customer with status open
        searchPo(searchValue) {

            var self = this;
            var woId = self.woId;

            // self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/po/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {
                    // customer_id: custId,
                    search: searchValue,
                    flag: "work_order",
                    woid:  woId,

                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.purchaseOrderArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'search-po');
                }
            });
        },

        onSearchVendor(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vendor', '');
            }
        },
        onSearchProgram(search, loading) {
            var self = this;
            if (search.length > 1) {
                if (self.vehicle_id != null && self.vehicle_id.value){
                    loading(true);
                    self.searchField(loading, search, 'program', self.vehicle_id.value);
                }else{
                    self.$swal('','No vehicle selected','info');
                }

            }
        },

        onSearchAsset(search, loading) {
            var self = this;

            // use this in order to create new asset...
            self.searchedAsset = search;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'vehicle');
            } else {
                self.isAssetNotFound = false;
            }

        },
        onSearchCustomer(search, loading) {
            var self = this;

            // use this in order to create new customer...
            self.searchedCustomer = search;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'work_order_customer', '');
            } else {
                self.isCustomerNotFound = false;
            }
        },
        onSearchBill(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'bill');
            }

        },

        onSearchUser(search, loading) {
            var self = this;
            if (search.length > 0) {

                loading(true);
                self.searchField(loading, search, 'user', '');
            }
        },
        onSearchTechnician(search, loading) {
            var self = this;
            if (search.length > 0) {

                loading(true);
                if (self.location_id != null && self.location_id.value) {
                    self.searchField(loading, search, 'technician', self.location_id.value);
                }else{
                    self.searchField(loading, search, 'technician', '');
                }
            }
        },

        callCreateWorkOrderAPI(fields, segments, flag,oos, date1 = "") {

            var self = this;
            self.checkSectionReading().then((result) => {
              if(result){
                self.loading = true;
                if ( self.requestInProgress == true ) {
                    return;
                }
                self.requestInProgress = true;

                $.ajax({
                    url: process.env.ROOT_API + "/workorder/create" ,
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.requestInProgress = false;
                        self.loading = false;

                        // remove localStorage value
                        localStorage.removeItem('newAsset');
                        localStorage.removeItem('newCustomer');

                        if (segments[3]) {
                            $("#createWorkOrderBtn").val("Update");
                            $("#createWorkOrderBtn").prop("disabled", false);
                            $("#cancelWorkOrderBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                                $("#createWorkOrderBtn").prop("disabled", false);
                                $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                $("#cancelWorkOrderBtn").prop("disabled", false);

                            } else {

                                $("#createWorkOrderBtn").val("Save");
                                $("#createWorkOrderBtn").prop("disabled", false);
                                $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                $("#cancelWorkOrderBtn").prop("disabled", false);

                            }
                        }
                        if (data.status == "success") {

                            if(data.code == 201) {
                                self.$swal('',data.message,'info');
                            } else {
                                self.work_order_duplicate = false;
                                if (!segments[3]) {
                                    if (data.content.id && oos == 'true' && data.content.vehicle_id){
                                        self.callOutofServiceApi(data.content.id,data.content.vehicle_id,date1);
                                    }
                                }
                                if (flag == "Save and Continue"){
                                    //self.getPriceBookValue();
                                    self.getLaborCostValue();
                                }

                                //   if ((flag == "Save and Continue" && self.workOrderEstimateId == 0) || segments[3]) {//comment as it caused issue while update work order header details
                                if ((flag == "Save and Continue" && self.workOrderEstimateId == 0)) {

                                    if(self.vehicle_id != null) {
                                        // self.getScheduledMaintenance(self.customer_id.value, self.vehicle_id.value);
                                        self.getMappedProgram(self.vehicle_id.value,data.content.id)
                                    }

                                    $("#WorkOrderForm").trigger("reset");
                                    self.vehicle_id = null;
                                    self.customer_id = null;
                                    self.open_date = moment().format('MM/DD/YYYY hh:mm:ss a');
                                    self.requested_completion = "";
                                    self.agreed_date = "";
                                    self.user_id = self.loggedInUser;
                                    self.reason_id = null;
                                    self.priority = null;
                                    self.cost_code = null;
                                    self.crew_number = "";
                                    self.maintenance_type_id = null;
                                    self.miles = null;
                                    self.roadside_service = "";
                                    self.showMiscellaneousFields = false;
                                    self.is_miscellaneous = false;
                                    self.customer_email = "";
                                    self.customer_vin_number = "";
                                    self.customer_unit_no = "";
                                    self.disableCustField = false;
                                    //self.getWorkOrderNo();
                                    self.itemArr = [];
                                    self.laborHourArr = [];
                                    //For Work Order Line Item
                                    self.extraLaborComp = false;
                                    self.woiDetail = [];
                                    self.woLaborDetail = [];
                                    self.woCompDetail = [];
                                    self.woComment = [];
                                    self.showActiveTaskLabor = '';
                                    self.serviceTaskComp_error_msg = '';
                                    self.serviceTaskCompIndex = 'create';
                                    self.serviceTaskCompId = 0;
                                    self.serviceTaskEstimateCompId = 0;
                                    self.serviceTaskComp = null;
                                    self.serviceTaskCompQuantity = 0;
                                    self.serviceTaskCompCost = 0;
                                    self.serviceTaskCompSubTotal = 0;
                                    self.serviceTaskQty_error_msg = "";
                                    self.serviceTaskCnt = 0;
                                    self.laborCnt = 0;
                                    self.componentCnt = 0;
                                    self.serviceTaskLabor_error_msg = '';
                                    self.serviceTaskLaborIndex = 'create';
                                    self.serviceTaskLaborId = 0;
                                    self.serviceTaskLabor = null;
                                    self.serviceTaskLaborHour = 0;
                                    self.serviceTaskLaborHourRate = 0;
                                    self.serviceTaskLaborSubTotal = 0;
                                    self.serviceTaskArr = [];

                                    self.showTab = 'labor';
                                    self.serviceTaskActive = "active";
                                    self.laborActive = "";
                                    self.partActive = "";
                                    self.activityActive = "";
                                    self.showActivity = '';

                                    self.taskArr = [];
                                    self.parts_total = 0;
                                    self.labor_total = 0;
                                    self.sub_total = 0;
                                    self.tax = 0;
                                    self.total_tax = 0;
                                    self.discount = 0;
                                    self.total_discount = 0;
                                    self.total = 0;
                                    self.wonotes = "";
                                    self.wostatus = {value: "open",text: "Open"},

                                        //labor tab related
                                    self.laborArr = [];
                                    self.labor_id = null;

                                    //part tab related
                                    self.comp_id = null;
                                    self.compArr = [];

                                    self.scheduleMaintenanceArr = [];
                                    self.schedule_maintenance_id = null;

                                    //show display line item....

                                    //save work order id to save work order line item and more
                                    self.woId = data.content.id;
                                    self.work_order_no = data.content.work_order_no;
                                    if (!self.assetRequired){
                                    self.displayLineItem = true;
                                    self.loadWorkOrder();
                                    }
                                    return;

                                } else if (flag == "final") {
                                    //if work order add then redirect to view else to list page
                                    var urlPath = self.$route.path;
                                    if (urlPath != undefined && urlPath != null) {
                                        if (urlPath.indexOf("create") !== -1) {
                                            self.$router.push("/workorder/view/"+data.content.id);
                                        }else{
                                            self.$router.push("/workorder/list");
                                        }
                                    }else{
                                        self.$router.push("/workorder/view/"+data.content.id);
                                    }

                                } else {

                                    if (self.workOrderEstimateId != 0) {
                                        self.woId = data.content.id;
                                    }
                                    self.displayLineItem = true;
                                    self.itemClass = 'undefined';
                                    self.loadWorkOrder();
                                    setTimeout(function(){

                                        self.getEstimateWorkOrderItemDetail(data.content.estimate_work_order_id);

                                    },500);
                                    // self.workOrderItemData();
                                }
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.requestInProgress = false;
                        if (segments[3]) {
                            $("#createWorkOrderBtn").val("Update");
                            $("#createWorkOrderBtn").prop("disabled", false);
                            $("#cancelWorkOrderBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#WorkOrderForm").trigger("reset");

                                $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                                $("#createWorkOrderBtn").prop("disabled", false);
                                $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                $("#cancelWorkOrderBtn").prop("disabled", false);

                            } else {

                                $("#createWorkOrderBtn").val("Save");
                                $("#createWorkOrderBtn").prop("disabled", false);
                                $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                $("#cancelWorkOrderBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR, false, 'create-workorder');
                    }
                });
              }
            });
        },

        callOutofServiceApi:function(woid,vehicle_id,date1 = ""){
            var self = this;
            if (vehicle_id != null && vehicle_id){

                $.ajax({
                    url: process.env.ROOT_API + "/out-of-service/add",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        vehicle_id:vehicle_id,
                        work_order_id:woid,
                        flag:'wo',
                        start_date : date1,
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            // self.customerPriceBookArr = data.content.customer;
                            // self.defaultPriceBookArr = data.content.default;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-number');
                    }
                });
            }
        },
        checkStatus(flag,taskFlag){
            var self = this;
            var closeStatusCount = 0;
            if (self.displayLineItem) {
                for ( var i = 0; i < self.taskArr.length; i++) {
                    if ( self.taskArr[i].woistatus != null && self.taskArr[i].woistatus.value && self.taskArr[i].woistatus.value == 'closed'){
                        closeStatusCount++;
                    }
                    if(self.taskArr[i].taskid.code == '03' || self.taskArr[i].taskid.code == '10' ) {

                    if (self.taskArr[i].woistatus.value == 'closed'){ //|| self.taskArr[i].woistatus.value != 'review'
                        if(self.compArr.length == 0 && self.taskArr[i].issublet != true) {
                        self.error_msg_part_missing = 'Part is Required before ' + self.taskArr[i].woistatus.value + " work order";
                        alert('Part is Required before ' + self.taskArr[i].woistatus.value + " the work order");
                        error = true;
                        return;
                        } else {
                        if (self.taskArr[i].issublet != true){
                            var idx = self.compArr.findIndex(obj => obj.service_task_id.index == i);
                            if(idx === -1) {
                                self.error_msg_part_missing = 'Part is Required before ' + self.taskArr[i].woistatus.value + " work order";
                                alert('Part is Required before ' + self.taskArr[i].woistatus.value + " the work order");
                                error = true;
                                return;
                            }
                        }
                        }
                    }
                    }
              }
            }
            if (self.taskArr.length != 0 && self.taskArr.length == closeStatusCount) {
                $("#select-date").modal("show");
            }else{
                self.CreateWorkOrder(flag,taskFlag);
            }
        },

        CreateWorkOrder(flag,taskFlag) {

            var self = this;
            var error = false;
            var fields_err = [];
            var workOrderError = "";
            var path = window.location.pathname;
            var segments = path.split("/");

            self.vehicle_error_msg = "";
            self.work_order_no_error_msg = "";
            self.miles_error_msg = "";
            self.maintenance_type_error_msg = "";
            self.customer_error_msg = "";
            self.location_error_msg = "";
            self.user_error_msg = "";
            self.reason_error_msg = "";
            self.customer_email_error_msg = "";
            self.customer_vin_number_error_msg = "";
            self.customer_unit_no_error_msg = "";

            var currentDate = new Date();
            if ( self.work_order_duplicate == true) {
                self.work_order_no_error_msg = "This Work Order No already exist!!";
                error = true;
            }


            var lastLineItem = true;

            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
            var wostatus=self.checkWoAmount();
            if(wostatus==1){
                error = true;
            }
            //if work order is not for multi unit
            if(!self.showMiscellaneousFields && self.assetRequired){

                if (self.vehicle_id == null || !self.vehicle_id.value) {
                    self.vehicle_error_msg = "Unit Required.";
                    error = true;
                }

                if ( self.customer_id == null) {

                    self.customer_error_msg = "Customer Required.";
                    error = true;

                }

            }else{
                //if work order is not for multi unit
                if (self.assetRequired){
                    // if is miscellaneous customer
                    if (self.customer_email == null || self.customer_email == "") {
                        self.customer_email_error_msg = "Email Required.";
                        self.$swal('','Please Enter Email','error');
                        return;
                        // error = true;
                    }else{

                        if(!self.validEmail(self.customer_email)){
                            self.customer_email_error_msg = "Email Must Be In Proper Format.";
                            error = true;
                        }
                    }

                    if (self.customer_vin_number == null || self.customer_vin_number == "") {
                        self.customer_vin_number_error_msg = "Vin Number Required.";
                        error = true;
                    }
                }

            }

            if (self.sectionArr.length && self.assetRequired){
                for(var k = 0; k < self.sectionArr.length; k++ ){
                    if (self.sectionArr[k].reading == null || self.sectionArr[k].reading == "") {
                        // self.miles_error_msg = "Miles Required.";
                        // error = true;
                    } else {

                        //check amount is valid or not
                        if (!String(self.sectionArr[k].reading).match(checkNumber)) {
                            self.sectionArr[k].reading_error = "Miles is not valid.";
                            error = true;
                        }
                    }
                }
            }

            // if (self.maintenance_type_id == null || !self.maintenance_type_id.value) {
            //     self.maintenance_type_error_msg = "Maintenance Type Required.";
            //     error = true;
            // }

            workOrderError = self.validateLength(self.work_order_no, 8, 12);
            if (workOrderError) {
              self.work_order_no_error_msg = workOrderError;
              error = true;
            }

            // if (self.work_order_no == null || !self.work_order_no) {
            //     self.work_order_no_error_msg = "Work Order Required.";
            //     error = true;
            // }else{
            //   if (isNaN(self.work_order_no)){
            //     self.work_order_no_error_msg = "Only Numeric Values Allowed";
            //     self.$swal('','Only Numeric Values Allowed For The Work Order Number ','error');
            //     return;
            //     // error = true;
            //   }
            // }
            // else if ( self.work_order_no.length != 8 ) {
            //     self.work_order_no_error_msg = "Work Order number must be 8 characters long.";
            //     error = true;
            // }

            if (self.location_id == null || !self.location_id.value) {
                self.location_error_msg = "Location Required.";
                error = true;
            }

            if (self.user_id == null || !self.user_id.value) {
                self.user_error_msg = "User Required.";
                error = true;
            }
            //work order line items validations
            if (self.displayLineItem) {

                //validation for single line item
                if (flag == 'validateTask') {

                    if(taskFlag == 'loadAfterSave'){
                        var index = self.taskArr.length - 1;
                    }else{
                        var index = self.currentTaskIndex;
                    }

                    $("#unit_id" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#component_category_id" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#line_number" + index).removeClass('border-red');
                    $("#taskid" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#billable_code" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#woistatus" + index + " .dropdown-toggle").removeClass('border-red');
                    $("#woicomplaint" + index).removeClass('border-red');
                    $("#woicause" + index).removeClass('border-red');
                    $("#woicorrection" + index).removeClass('border-red');
                    $("#common_error_msg" + index).html('');
                    $("#vendorpo"+ index +" .dropdown-toggle").removeClass('border-red');
                    $("#vendorid"+ index +" .dropdown-toggle").removeClass('border-red');
                    $("#sublet_amount" + index).removeClass('border-red');
                    $("#std_repair_time" + index).removeClass('border-red');
                    $("#est_repair_time" + index).removeClass('border-red');
                    $("#etc_reason" + index).removeClass('border-red');
                    //$("#po_number" + index).removeClass('border-red');

                    if (!self.assetRequired){
                        if (self.taskArr[index].unit_id == null || !self.taskArr[index].unit_id.value) {
                            $("#unit_id" + index + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }
                    }
                    if(self.taskArr[index].po_error_msg == null || self.taskArr[index].po_error_msg == "" || !self.taskArr[index].po_error_msg){

                    }else{
                        error = true;
                    }
                    if (self.taskArr[index].component_category_id == null || !self.taskArr[index].component_category_id.value) {
                        $("#component_category_id" + index + " .dropdown-toggle").addClass('border-red');
                        error = true;
                    }
                    if (self.taskArr[index].line_number == null || self.taskArr[index].line_number == '') {
                        $("#line_number" + index).addClass('border-red');
                        error = true;
                    }
                    if (self.taskArr[index].taskid == null || !self.taskArr[index].taskid.value) {
                        $("#taskid" + index + " .dropdown-toggle").addClass('border-red');
                        error = true;
                    }
                    if (self.taskArr[index].issublet != true) {
                        if (self.taskArr[index].std_repair_time == null || self.taskArr[index].std_repair_time == 0 ) {
                            $("#std_repair_time" + index).addClass('border-red');
                            fields_err.push( "Please Enter SRT in line" + (index + 1));
                            error = true;
                        }
                    }
                    if (self.taskArr[index].etcExtend != undefined && self.taskArr[index].etcExtend == true){
                        if (self.taskArr[index].etc_reason == null || self.taskArr[index].etc_reason == '' ) {
                            $("#etc_reason" + index).addClass('border-red');
                            error = true;
                        }
                    }
                    var populateDetail = 'false';
                    if (self.taskArr[index] != undefined && self.taskArr[index].component_category_id != undefined && self.taskArr[index].component_category_id.text != undefined && self.taskArr[index].component_category_id.text.includes('WA000000')
                        && self.taskArr[index].taskid != undefined && self.taskArr[index].taskid.text != undefined && self.taskArr[index].taskid.text.includes('52')){
                        populateDetail = 'true';
                    }

                    if ((self.taskArr[index].est_repair_time == null || self.taskArr[index].est_repair_time == 0) && populateDetail == 'false') {
                        $("#est_repair_time" + index).addClass('border-red');
                        fields_err.push( "Please Enter ETC in line" + (index + 1));
                        error = true;
                    }
                    if ((self.taskArr[index].line_number != '' && self.taskArr[index].line_number > 0)) {
                        // $("#est_repair_time" + index).addClass('border-red');
                        if (self.taskArr.length){
                            for(var i=0;i<self.taskArr.length;i++){
                                if (index != i && self.taskArr[i].line_number == self.taskArr[index].line_number){
                                    // fields_err.push( "Line number is duplicate in" + (index + 1));
                                    if (!fields_err.includes("Line number "+(self.taskArr[i].line_number)+" is duplicate")){
                                        fields_err.push( "Line number "+(self.taskArr[i].line_number)+" is duplicate");
                                    }
                                    error = true;
                                }
                            }
                        }
                    }
                    if (self.taskArr[index].woistatus == null || !self.taskArr[index].woistatus.value) {
                        $("#woistatus" + index + " .dropdown-toggle").addClass('border-red');
                        error = true;
                    } else {
                      if (self.taskArr[index].woistatus.value == "closed") {
                        if (self.taskArr[index].billable_code == null || !self.taskArr[index].billable_code.value) {
                            $("#billable_code" + index + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }
                      }

                    }
                    if (self.taskArr[index].issublet == true) {
                        if (self.taskArr[index].purchaseorderid == null || !self.taskArr[index].purchaseorderid.value) {
                            if (self.taskArr[index].vendorid == null || !self.taskArr[index].vendorid.value) {
                                $("#vendorid" + index + " .dropdown-toggle").addClass('border-red');
                                error = true;
                            }
                        }
                        if (self.taskArr[index].sublet_amount == null || !self.taskArr[index].sublet_amount) {
                            $("#sublet_amount" + index).addClass('border-red');
                            error = true;
                        }
                        // if (self.taskArr[index].po_number == null || self.taskArr[index].po_number == '') {
                        //     $("#po_number" + index).addClass('border-red');
                        //     error = true;
                        // }

                    }
                    if(self.assetRequired && self.taskArr[index] && (self.taskArr[index].woistatus.value == 'closed' || self.taskArr[index].woistatus.value == 'review')){

                        if (self.taskArr[index].woicomplaint == "" || self.taskArr[index].woicomplaint == '') {
                            $("#woicomplaint" + index).addClass('border-red');
                            fields_err.push( "Please Enter Complaint in line " + (i + 1));
                            error = true;
                        }
                        if (self.taskArr[index].woicause == "" || self.taskArr[index].woicause == '') {
                            $("#woicause" + index).addClass('border-red');
                            fields_err.push( "Please Enter Cause in line " + (i + 1));
                            error = true;
                        }
                        if (self.taskArr[index].woicorrection == "" || self.taskArr[index].woicorrection == '') {
                            $("#woicorrection" + index).addClass('border-red');
                            fields_err.push( "Please Enter Correction in line " + (i + 1));
                            error = true;
                        }
                    }
                    if(self.taskArr[index].woistatus != null && self.taskArr[index].woistatus.value == 'closed'){
                        if ((self.taskArr[index].purchaseorderid == null || !self.taskArr[index].purchaseorderid.value) && self.taskArr[index].issublet == true) {
                            $("#vendorpo"+ index +" .dropdown-toggle").addClass('border-red');
                            error = true;
                        }else{
                            if ((self.taskArr[index].billId == null || !self.taskArr[index].billId.value) && self.taskArr[index].issublet == true) {
                                alert('Purchase Order does not have vendor invoice');
                                error = true;
                            }else{
                                if (!self.assetRequired) {
                                    if ((self.taskArr[index].bill_item_id == null || self.taskArr[index].bill_item_id == "") && self.taskArr[index].issublet == true) {
                                        alert('Vendor Invoice does not have work order line item');
                                        error = true;
                                    }
                                }
                            }
                        }
                    }

                    if (error) {
                         $([document.documentElement, document.body]).animate({
                                scrollTop: $("#common_error_msg" + index).offset().top-300
                         }, 500);
                        $("#common_error_msg" + index).html('Please fill all fields.');
                    }
                    var fielderror = "";
                    for(var i = 0; i < fields_err.length; i++){
                        fielderror += fields_err[i] + "<br/>";
                    }
                    $("#error_msg").html(fielderror);
                    $('.admin-page-content .border-top-table-fl').css('margin-top',10);
                    if(fielderror != ""){
                        setTimeout(function(){
                            var maxhigh = $(".page-name").height();
                            $("#select-date").modal("hide");
                            $('.admin-page-content .border-top-table-fl').css('margin-top',maxhigh);
                        },200);

                    }
                } else {

                    for (var i = 0; i < self.taskArr.length; i++) {

                        $("#unit_id" + i + " .dropdown-toggle").removeClass('border-red');
                        $("#component_category_id" + i + " .dropdown-toggle").removeClass('border-red');

                        $("#taskid" + i + " .dropdown-toggle").removeClass('border-red');
                        $("#billable_code" + i + " .dropdown-toggle").removeClass('border-red');
                        $("#woistatus" + i + " .dropdown-toggle").removeClass('border-red');
                        $("#woicomplaint" + i).removeClass('border-red');
                        $("#woicause" + i).removeClass('border-red');
                        $("#woicorrection" + i).removeClass('border-red');
                        $("#common_error_msg" + i).html('');
                        $("#vendorpo" + i +" .dropdown-toggle").removeClass('border-red');
                        $("#vendorid" + i +" .dropdown-toggle").removeClass('border-red');
                        $("#sublet_amount" + i).removeClass('border-red');
                        $("#std_repair_time" + i).removeClass('border-red');
                        $("#est_repair_time" + i).removeClass('border-red');
                        $("#etc_reason" + i).removeClass('border-red');
                        //$("#po_number" + i).removeClass('border-red');
                        $("#line_number" + i).removeClass('border-red');

                        if (self.taskArr[i].issublet != true) {
                            if (self.taskArr[i].std_repair_time == null || self.taskArr[i].std_repair_time == 0 ) {
                                $("#std_repair_time" + i).addClass('border-red');
                                fields_err.push( "Please Enter SRT in line " + (i + 1));
                                error = true;
                            }
                        }
                        if(self.taskArr[i].po_error_msg != undefined && self.taskArr[i].po_error_msg == null || self.taskArr[i].po_error_msg == "" || !self.taskArr[i].po_error_msg){

                        }else{
                            error = true;
                        }
                        var populateDetail = 'false';
                        if (self.taskArr[i] != undefined && self.taskArr[i].component_category_id != undefined && self.taskArr[i].component_category_id.text != undefined && self.taskArr[i].component_category_id.text.includes('WA000000')
                            && self.taskArr[i].taskid != undefined && self.taskArr[i].taskid.text != undefined && self.taskArr[i].taskid.text.includes('52')){
                            populateDetail = 'true';
                        }
                        if ((self.taskArr[i].est_repair_time == null || self.taskArr[i].est_repair_time == 0) && populateDetail == 'false') {
                            $("#est_repair_time" + i).addClass('border-red');
                            fields_err.push( "Please Enter ETC in line " + (i + 1));
                            error = true;
                        }

                        if (!self.assetRequired){
                            if (self.taskArr[i].unit_id == null || !self.taskArr[i].unit_id.value) {
                                $("#unit_id" + i + " .dropdown-toggle").addClass('border-red');
                                error = true;
                            }
                        }
                        if (self.taskArr[i].component_category_id == null || !self.taskArr[i].component_category_id.value) {
                            $("#component_category_id" + i + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }
                        if (self.taskArr[i].line_number == null || self.taskArr[i].line_number == '') {
                            $("#line_number" + i).addClass('border-red');
                            error = true;
                        }
                        if ((self.taskArr[i].line_number != '' && self.taskArr[i].line_number > 0)) {
                            // $("#est_repair_time" + index).addClass('border-red');
                            if (self.taskArr.length){
                                for(var j=0;j<self.taskArr.length;j++){
                                    if (j != i && self.taskArr[j].line_number == self.taskArr[i].line_number){
                                        // if (!fields_err.includes("Line number is duplicate in" + (i + 1))){
                                        //     fields_err.push( "Line number is duplicate in" + (i + 1));
                                        // }
                                        if (!fields_err.includes("Line number "+(self.taskArr[j].line_number)+" is duplicate")){
                                            fields_err.push( "Line number "+(self.taskArr[j].line_number)+" is duplicate");
                                        }
                                        error = true;
                                    }
                                }
                            }
                        }
                        if (self.taskArr[i].taskid == null || !self.taskArr[i].taskid.value) {
                            $("#taskid" + i + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }

                        if (self.taskArr[i].woistatus == null || !self.taskArr[i].woistatus.value) {
                            $("#woistatus" + i + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        } else {
                          if(self.taskArr[i].woistatus.value == "closed") {

                            if (self.taskArr[i].billable_code == null || !self.taskArr[i].billable_code.value) {
                                $("#billable_code" + i + " .dropdown-toggle").addClass('border-red');
                                error = true;
                            }

                          }
                        }
                        if (self.taskArr[i].issublet == true) {
                            if (self.taskArr[i].purchaseorderid == null || !self.taskArr[i].purchaseorderid.value) {
                                if (self.taskArr[i].vendorid == null || !self.taskArr[i].vendorid.value) {
                                    $("#vendorid" + i + " .dropdown-toggle").addClass('border-red');
                                    error = true;
                                }
                            }
                            if (self.taskArr[i].sublet_amount == null || !self.taskArr[i].sublet_amount) {
                                $("#sublet_amount" + i).addClass('border-red');
                                error = true;
                            }
                            // if (self.taskArr[i].po_number == null || self.taskArr[i].po_number == '') {
                            //     $("#po_number" + i).addClass('border-red');
                            //     error = true;
                            // }

                        }
                        if (self.taskArr[i].etcExtend != undefined && self.taskArr[i].etcExtend == true){
                            if (self.taskArr[i].etc_reason == null || self.taskArr[i].etc_reason == '' ) {
                                $("#etc_reason" + i).addClass('border-red');
                                error = true;
                            }
                        }
                        if(self.assetRequired && self.taskArr[i].woistatus != null && (self.taskArr[i].woistatus.value == 'closed' || self.taskArr[i].woistatus.value == 'review')){

                            if (self.taskArr[i].woicomplaint == "" || self.taskArr[i].woicomplaint == '') {
                                $("#woicomplaint" + i).addClass('border-red');
                                fields_err.push( "Please Enter Complaint in line " + (i + 1));
                                error = true;
                            }
                            if (self.taskArr[i].woicause == "" || self.taskArr[i].woicause == '') {
                                $("#woicause" + i).addClass('border-red');
                                fields_err.push( "Please Enter Cause in line " + (i + 1));
                                error = true;
                            }
                            if (self.taskArr[i].woicorrection == "" || self.taskArr[i].woicorrection == '') {
                                $("#woicorrection" + i).addClass('border-red');
                                fields_err.push( "Please Enter Correction in line " + (i + 1));
                                error = true;
                            }
                        }

                        var msg = "Please fill all fields.";
                        if(self.taskArr[i].woistatus != null && self.taskArr[i].woistatus.value == 'closed'){
                            if ((self.taskArr[i].purchaseorderid == null || !self.taskArr[i].purchaseorderid.value) && self.taskArr[i].issublet == true) {
                                $("#vendorpo"+ i +" .dropdown-toggle").addClass('border-red');
                                error = true;

                                msg = "Line Item does not have Vendor Purchase Order."
                            }else{
                                if ((self.taskArr[i].billId == null || !self.taskArr[i].billId.value) && self.taskArr[i].issublet == true) {
                                    alert('Purchase Order does not have vendor invoice');
                                    return;
                                }else{
                                    if (!self.assetRequired) {
                                        if ((self.taskArr[i].bill_item_id == null || self.taskArr[i].bill_item_id == "") && self.taskArr[i].issublet == true) {
                                            alert('Vendor Invoice does not have work order line item');
                                            return;
                                        }
                                    }
                                }
                            }
                        }

                        if (error) {
                             $([document.documentElement, document.body]).animate({
                                scrollTop: $("#common_error_msg" + i).offset().top-300
                                }, 500);
                            $("#common_error_msg" + i).html(msg);
                        }
                    }
                    var fielderror = "";
                    for(var i = 0; i < fields_err.length; i++){
                        fielderror += fields_err[i] + "<br/>";
                    }
                    $("#error_msg").html(fielderror);
                    $('.admin-page-content .border-top-table-fl').css('margin-top',10);
                    if(fielderror != ""){
                        setTimeout(function(){
                            var maxhigh = $(".page-name").height();
                            $("#select-date").modal("hide");
                            $('.admin-page-content .border-top-table-fl').css('margin-top',maxhigh);
                        },200);
                    }
                    for (var i = 0; i < self.serviceTaskArr.length; i++) {

                        var serviceTaskIdx = self.serviceTaskArr[i].index;

                        for (var k = 0; k < self.laborArr.length; k++) {

                            if (self.laborArr[k].service_task_id != null) {

                                var taskIdx = self.laborArr[k].service_task_id.index;

                                if (taskIdx == serviceTaskIdx) {

                                    $("#serviceTaskLabor" + k + " .dropdown-toggle").removeClass('border-red');
                                    if (self.laborArr[k].laborid == null || self.laborArr[k].laborid == '') {

                                        if (self.taskArr[i].issublet != true){
                                            self.editServiceTask('labor', k, i);
                                            $("#serviceTaskLabor" + k + " .dropdown-toggle").addClass('border-red');

                                            error = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            self.error_msg_part_missing = "";

            var closeStatusCount = 0;
            if (self.displayLineItem) {
                for ( var i = 0; i < self.taskArr.length; i++) {
                    if ( self.taskArr[i].woistatus != null && self.taskArr[i].woistatus.value && self.taskArr[i].woistatus.value == 'closed'){
                        closeStatusCount++;
                    }
                    if(self.taskArr[i].taskid.code == '03' || self.taskArr[i].taskid.code == '10' ) {

                    if (self.taskArr[i].woistatus.value == 'closed'){ //|| self.taskArr[i].woistatus.value != 'review'
                        if(self.compArr.length == 0 && self.taskArr[i].issublet != true) {
                        self.error_msg_part_missing = 'Part is Required before ' + self.taskArr[i].woistatus.value + " work order";
                        alert('Part is Required before ' + self.taskArr[i].woistatus.value + " the work order");
                        error = true;
                        return;
                        } else {
                        if (self.taskArr[i].issublet != true){
                            var idx = self.compArr.findIndex(obj => obj.service_task_id.index == i);
                            if(idx === -1) {
                                self.error_msg_part_missing = 'Part is Required before ' + self.taskArr[i].woistatus.value + " work order";
                                alert('Part is Required before ' + self.taskArr[i].woistatus.value + " the work order");
                                error = true;
                                return;
                            }
                        }
                        }
                    }
                    }
              }
            }
            //invoice already generated and work order is closed then show warning
            if (self.displayLineItem && self.invoiceGenerated == 'true' && flag == 'final') {
                if (self.taskArr.length == closeStatusCount) {
                    error = true;
                    if (confirm('Any modifications done will reflect in Customer Invoice.')) {
                        error = false;
                    }
                }
            }

            if (!error) {


                // self.loading = true;

                var workOrderItemIdArr = [];
                var taskIdArr = [];
                var laborAmountArr = [];
                var partAmountArr = [];

                self.woiDetail = [];
                self.woLaborDetail = [];
                self.woCompDetail = [];
                self.woComment = [];

                if (self.displayLineItem) {
                    for (var i = 0; i < self.taskArr.length; i++) {
                        self.woiDetail.push({

                            wo_id: segments[3],
                            wo_item_id: self.taskArr[i].woiId,
                            line_number:self.taskArr[i].line_number,
                            vehicle_id: (self.taskArr[i].unit_id != null) ? self.taskArr[i].unit_id.value : null,
                            task_id: (self.taskArr[i].taskid != null) ? self.taskArr[i].taskid.value : null,
                            labor_amount: (self.taskArr[i].laboramount != undefined) ? self.taskArr[i].laboramount : 0,
                            component_amount: (self.taskArr[i].partamount != undefined) ? self.taskArr[i].partamount : 0,
                            component_category_id: (self.taskArr[i].component_category_id != null) ? self.taskArr[i].component_category_id.value : null,
                            wi_reason_id: (self.taskArr[i].wi_reason_id != undefined) ? self.taskArr[i].wi_reason_id.value : null,
                            billable_code: (self.taskArr[i].billable_code != null) ? self.taskArr[i].billable_code.value : null,
                            standard_defect_id: (self.taskArr[i].defect_id != undefined) ? self.taskArr[i].defect_id.value : null,
                            woistatus: self.taskArr[i].woistatus.value,
                            complaint: self.taskArr[i].woicomplaint,
                            cause: self.taskArr[i].woicause,
                            correction: self.taskArr[i].woicorrection,
                            est_repair_time: self.taskArr[i].est_repair_time,
                            etcExtend:self.taskArr[i].etcExtend,
                            std_repair_time: self.taskArr[i].std_repair_time,
                            is_sublet: self.taskArr[i].issublet,
                            purchaseorder_id: (self.taskArr[i].purchaseorderid != null) ? self.taskArr[i].purchaseorderid.value : null,
                            po_number:self.taskArr[i].po_number,
                            bill_id: (self.taskArr[i].billId != null) ? self.taskArr[i].billId.value : null,
                            vendor_id: (self.taskArr[i].vendorid != null) ? self.taskArr[i].vendorid.value : null,
                            notes: self.taskArr[i].woinotes,
                            estimate_wo_item_id: self.taskArr[i].estimatedwoiId,
                            add_time:(self.taskArr[i].add_time != undefined)?self.taskArr[i].add_time:null,
                            log_time:(self.taskArr[i].log_time != undefined && self.taskArr[i].log_time != null)?self.taskArr[i].log_time:null,
                            sublet_amount:self.taskArr[i].sublet_amount,
                            program_id:self.taskArr[i].program_id,
                            warrantyArr:[],
                            available_warranty_msg:'',
                            po_error_msg:'',
                            warranty_id:self.taskArr[i].warranty_id,
                            labor_rate:self.laborRateValue(i),
                            etc_reason:self.taskArr[i].etc_reason

                        });
                        if (self.taskArr[i].woistatus.value != 'closed'){
                            lastLineItem = false;
                        }
                    }
                }
                // self.woLaborDetail[] = [];
                for (var i = 0; i < self.laborArr.length; i++) {

                    var sTaskId = (self.laborArr[i].service_task_id != null) ? self.laborArr[i].service_task_id.value : 0;
                    //to do
                    //if labor is not assigned with any task then ... assigned it to last wo task index
                    var sTaskIndex = (self.laborArr[i].service_task_id != null) ? self.laborArr[i].service_task_id.index : self.woiDetail.length;

                    self.woLaborDetail.push({

                        work_order_labor_id: self.laborArr[i].lid,
                        service_task_id: sTaskId,
                        service_task_index: sTaskIndex,
                        user_id: (self.laborArr[i].laborid != null) ? self.laborArr[i].laborid.value : null,
                        labor_hours: parseFloat(self.laborArr[i].laborhours).toFixed(2),
                        labor_hourly_rate: self.laborArr[i].laborhourrate,
                        sub_total: self.laborArr[i].laborsubtotal,
                        notes: self.laborArr[i].labordescription

                    });

                    self.woLaborDetail[i]['laborHour'] = [];

                    for (var j = 0; j < self.laborHourArr.length; j++) {
                        if (self.laborHourArr[j].labor_index == i) {

                            self.woLaborDetail[i]['laborHour'].push({
                                timelog_id: self.laborHourArr[j].timelog_id,
                                labor_id: self.laborHourArr[j].labor_id,
                                start_time: (self.laborHourArr[j].start_time != '-') ? self.laborHourArr[j].start_time : '',
                                end_time: (self.laborHourArr[j].end_time != '-') ? self.laborHourArr[j].end_time : '',
                                duration: (self.laborHourArr[j].duration != '-') ? self.laborHourArr[j].duration : ''
                            });
                        }
                    }

                    if (sTaskId == 0) {
                        self.extraLaborComp = true;
                    }

                }

                for (var i = 0; i < self.compArr.length; i++) {

                    var sTaskId = (self.compArr[i].service_task_id != null) ? self.compArr[i].service_task_id.value : 0;
                    var sTaskIndex = (self.compArr[i].service_task_id != null) ? self.compArr[i].service_task_id.index : self.woiDetail.length;

                    self.woCompDetail.push({

                        work_order_comp_id: self.compArr[i].cid,
                        service_task_id: sTaskId,
                        service_task_index: sTaskIndex,
                        component_id: (self.compArr[i].compid != null)?self.compArr[i].compid.value:null,
                        bin_id: self.compArr[i].compid.bin_id,
                        is_non_inv_item: self.compArr[i].compid.is_non_inv_item,
                        quantity: self.compArr[i].compquantity,
                        unit_cost: self.compArr[i].compcost,
                        sub_total: self.compArr[i].compsubtotal,
                        notes: self.compArr[i].compdescription,
                        estimate_work_order_comp_id: self.compArr[i].estimatedcid,
                        comp_flag:self.compArr[i].comp_flag,
                        wr_location:self.compArr[i].wr_location,
                        warehouse_id:self.compArr[i].warehouse_id != undefined ? self.compArr[i].warehouse_id : null,

                    });

                    if (sTaskId == 0) {
                        self.extraLaborComp = true;
                    }

                }

                for (var i = 0; i < self.commentArr.length; i++) {

                    var sTaskId = (self.commentArr[i].service_task_id != null) ? self.commentArr[i].service_task_id.value : 0;
                    var sTaskIndex = (self.commentArr[i].service_task_id != null) ? self.commentArr[i].service_task_id.index : self.woiDetail.length;

                    self.woComment.push({

                        work_order_comment_id: self.commentArr[i].wocId,
                        service_task_id: sTaskId,
                        service_task_index: sTaskIndex,
                        comment: self.commentArr[i].woc,
                        comment_type_id: (self.commentArr[i].wocType != null) ? self.commentArr[i].wocType.value : null,
                        //we are not using below to property backend side...
                        comment_by: (self.commentArr[i].wocBy != null) ? self.commentArr[i].wocBy.value : null,
                        comment_at: self.commentArr[i].wocAt,
                        estimate_work_order_comment_id: self.commentArr[i].estimatedwocId

                    });

                }

                if (self.extraLaborComp) {
                    //to do
                    self.woiDetail.push({

                        wo_id: segments[3],
                        wo_item_id: 0,
                        task_id: null,
                        standard_defect_id: null,
                        labor_amount: 0,
                        component_amount: 0,
                        notes: ''
                    });

                }

                // if ( segments[3] ) {

                //     $("#createWorkOrderBtn").val("Updating ...");
                //     $("#createWorkOrderBtn").prop("disabled", true);
                //     $("#cancelWorkOrderBtn").prop("disabled", true);

                // } else {

                //     if ( flag == "Save and Continue" ) {

                //         $("#createAndContinueWorkOrderBtn").val("Saving ...");
                //         $("#createWorkOrderBtn").prop("disabled", true);
                //         $("#createAndContinueWorkOrderBtn").prop("disabled", true);
                //         $("#cancelWorkOrderBtn").prop("disabled", true);

                //     } else {

                //         $("#createWorkOrderBtn").val("Saving ...");
                //         $("#createWorkOrderBtn").prop("disabled", true);
                //         $("#createAndContinueWorkOrderBtn").prop("disabled", true);
                //         $("#cancelWorkOrderBtn").prop("disabled", true);
                //     }

                // }

                var fields = $("#WorkOrderForm").serializeArray();
                fields.push({name: "work_order_no",value: self.work_order_no});
                fields.push({name: "work_order_type",value: self.work_order_type.value});
                if(self.vehicle_id == null){

                    fields.push({name: "vehicle_id",value: ''});
                }else{
                    fields.push({name: "vehicle_id",value: self.vehicle_id.value});
                }

                if(self.customer_id == null){
                    fields.push({name: "customer_id",value: ''});
                }else{
                    fields.push({name: "customer_id",value: self.customer_id.value});
                }

                fields.push({name: "location_id",value: self.location_id.value});
                fields.push({name: "maintenance_type_id",value: 1});
                fields.push({name: "user_id",value: self.user_id.value});
                if (self.priority == null) {
                    fields.push({name: "priority",value: ""});
                } else {
                    fields.push({name: "priority",value: self.priority.value});
                }
                fields.push({name: "wo_estimate_id",value: self.workOrderEstimateId});
                // var poId = 0;
                // if ( !self.showMiscellaneousFields ) {
                //     if ( self.poInputId != null && self.poInputId.value){
                //         poId = self.poInputId.value;
                //     }else{
                //         poId = self.poId;
                //     }
                // }

                // fields.push({
                //     name: "wo_po_id",
                //     value: poId
                // });

                fields.push({name: "id",value: (segments[3] != undefined) ? segments[3] : self.woId});

                // PR - Work Order Table

                fields.push({name: "wo_labor_total",value: self.labor_total});
                fields.push({name: "wo_comp_total",value: self.parts_total});
                fields.push({name: "wo_sub_total",value: self.sub_total});
                fields.push({name: "wo_discount",value: self.discount});
                fields.push({name: "wo_total_discount",value: self.total_discount});
                fields.push({name: "wo_tax",value: self.tax});
                fields.push({name: "wo_total_tax",value: self.total_tax});
                fields.push({name: "other_charges",value: self.other_charges});
                fields.push({name: "shop_supplies",value: self.shop_supplies});
                fields.push({name: "wo_total",value: self.total});
                fields.push({name: "wo_status",value: self.wostatus.value});
                fields.push({name: "wo_description",value: self.wonotes});
                if(self.taskArr.length == closeStatusCount){
                    fields.push({name: "closedate",value: self.close_date});
                }else{
                    fields.push({name: "closedate",value: ''});
                }

                // fields.push({
                //     name: "wo_schedule_maintenance_id",
                //     value: (self.schedule_maintenance_id != null & self.schedule_maintenance_id != '') ? self.schedule_maintenance_id.value : null
                // });
                fields.push({name: "wo_schedule_maintenance_id",value: JSON.stringify(self.mainArr)});


                // PR - Work Order Item Changes
                fields.push({name: "work_order_item_details",value: JSON.stringify(self.woiDetail)});
                fields.push({name: "labor_details",value: JSON.stringify(self.woLaborDetail)});
                fields.push({name: "component_details",value: JSON.stringify(self.woCompDetail)});
                // fields.push({name: "multipleItems",value: JSON.stringify(self.selectedCompArr)});
                fields.push({name: "comment_details",value: JSON.stringify(self.woComment)});
                fields.push({name: "final_flag",value: flag});
                fields.push({name: "task_flag",value: taskFlag});
                fields.push({name: "log_flag",value: self.logFlag});
                fields.push({name: "current_index",value: self.activeLineItemIdx});
                fields.push({name: "log_at",value: self.logStartAt});
                fields.push({name: "labor_rate",value: self.serviceTaskLaborHourRate});
                fields.push({name: "comp_cost",value: self.serviceTaskCompCost});
                fields.push({name: "log_at",value: self.logStartAt});
                fields.push({name: "reading",value: JSON.stringify(self.sectionArr)});
                if(self.is_miscellaneous == true){
                    fields.push({name: "is_miscellaneous",value: 1});
                }else{
                    fields.push({name: "is_miscellaneous",value: 0});
                }
                // if is miscellaneous customer
                if(self.showMiscellaneousFields) {
                    fields.push({name: "customer_email",value: self.customer_email});
                    fields.push({name: "customer_vin_number",value: self.customer_vin_number});
                    fields.push({name: "customer_unit_no",value: self.customer_unit_no});
                }

                if (self.disableWOFields) {

                    fields.push({name: "open_date",value: self.open_date});
                    fields.push({name: "requested_completion",value: self.requested_completion});
                    fields.push({name: "agreed_date",value: self.agreed_date});
                    if(self.showMiscellaneousFields){
                        fields.push({name: "customer_email",value: self.customer_email});
                        fields.push({name: "customer_vin_number",value: self.customer_vin_number});
                        fields.push({name: "customer_unit_no",value: self.customer_unit_no});
                    }
                }

                if ((self.displayLineItem && self.woId && flag != 'Save and Continue') || flag == 'validateTask') {

                    if ( taskFlag == 'loadAfterSave'){
                        flag = 'loadAfterSave';
                    }
                    if (lastLineItem && self.OutOfService != '' && self.OutOfService == 'yes' && flag != "final"){
                        $("#select-date").modal("hide");
                        self.$swal({
                            title: "This Unit is currently Out Of Service",
                            text: "Please select to place in service",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: "Place In Service",
                            cancelButtonText: "Leave Out Of Service",
                            showCloseButton: true,
                            showLoaderOnConfirm: false,
                            allowOutsideClick:false,
                            html:'Selected Date : <input id="datepickerEnd" class="form-control">',
                            customClass: 'swal2-overflow',
                            onOpen:function(){
                              setTimeout(function () {
                              $('#datepickerEnd').datepicker({
                                dateFormat: 'mm/dd/yy',
                                autoclose: true
                              }).datepicker("setDate",  new Date());
                            },400);
                            },

                        }).then(result => {
                            if (result.value) {
                                // oos = 'true';
                                fields.push({
                                    name: "oos",
                                    value: 'end'
                                });
                                fields.push({
                                    name: "end_date",
                                    value: $("#datepickerEnd").val()
                                });
                                // self.callCreateWorkOrderAPI(fields, segments, flag,'true');
                                self.callCreateWorkOrderItemAPI(fields, segments, flag,'in');
                                // self.callOutofServiceApi('oos')
                            } else if (result.dismiss == 'cancel') {
                                self.loading = false;
                                // self.callOutofServiceApi('skip')
                                oos = 'false';
                                self.callCreateWorkOrderItemAPI(fields, segments, flag,oos);

                            }else {
                                if (segments[3]) {
                                    $("#createWorkOrderBtn").val("Update");
                                    $("#createWorkOrderBtn").prop("disabled", false);
                                    $("#cancelWorkOrderBtn").prop("disabled", false);
                                } else {
                                    if (flag == "Save and Continue") {

                                        $("#createAndContinueWorkOrderBtn").val("Save");
                                        $("#createWorkOrderBtn").prop("disabled", false);
                                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                        $("#cancelWorkOrderBtn").prop("disabled", false);

                                    } else {

                                        $("#createWorkOrderBtn").val("Save");
                                        $("#createWorkOrderBtn").prop("disabled", false);
                                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                        $("#cancelWorkOrderBtn").prop("disabled", false);
                                    }

                                }
                                self.loading = false;
                                return;
                            }
                        });
                    }else{
                        self.callCreateWorkOrderItemAPI(fields, segments, flag,'');
                    }
                } else {
                    if (!segments[3] && !self.oosCreated && !self.is_miscellaneous && self.assetRequired) {
                        var oos = 'false';

                        if(self.lastSelection == '') {
                          self.$swal({
                              title: "This Unit is currently in service",
                              text: "Please select one of the following",
                              type: "warning",
                              confirmButtonText: "Place Out Of Service",
                              cancelButtonText: "Leave In Service",
                              showCloseButton: true,
                              showLoaderOnConfirm: false,
                              showCancelButton:true,
                              allowOutsideClick:false,
                              html:'Selected Date : <input id="datepicker" readonly class="form-control">',
                              customClass: 'swal2-overflow',
                              onOpen:function(){
                                $('#datepicker').datepicker({
                                  dateFormat: 'mm/dd/yy',
                                  autoclose: true
                                }).datepicker("setDate",  new Date());
                              },
                            }).then(result => {
                                if (result.value) {
                                  self.lastSelection = "place_service";
                                  self.oos_date = $("#datepicker").val();
                                    self.callCreateWorkOrderAPI(fields, segments, flag,'true', self.oos_date);
                                    // self.callOutofServiceApi('oos')
                                } else if (result.dismiss == 'cancel') {
                                    // self.callOutofServiceApi('skip')
                                    oos = 'false';
                                    self.lastSelection = "leave_service";
                                    self.callCreateWorkOrderAPI(fields, segments, flag,oos);
                                } else {
                                    self.lastSelection = "";
                                    if (segments[3]) {
                                        $("#createWorkOrderBtn").val("Update");
                                        $("#createWorkOrderBtn").prop("disabled", false);
                                        $("#cancelWorkOrderBtn").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {

                                            $("#createAndContinueWorkOrderBtn").val("Save");
                                            $("#createWorkOrderBtn").prop("disabled", false);
                                            $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                            $("#cancelWorkOrderBtn").prop("disabled", false);

                                        } else {

                                            $("#createWorkOrderBtn").val("Save");
                                            $("#createWorkOrderBtn").prop("disabled", false);
                                            $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                                            $("#cancelWorkOrderBtn").prop("disabled", false);
                                        }

                                    }
                                    self.loading = false;
                                    return;
                                }
                            });
                        } else if (self.lastSelection == "place_service") {
                          self.lastSelection = "place_service";
                          self.callCreateWorkOrderAPI(fields, segments, flag,'true');
                        } else if (self.lastSelection == "leave_service") {
                          oos = 'false';
                          self.lastSelection = "leave_service";
                          self.callCreateWorkOrderAPI(fields, segments, flag,oos);
                        }
                    } else {
                        self.callCreateWorkOrderAPI(fields, segments, flag,'false');
                    }
                }
            }
        },

        checkSectionReading(){
          return new Promise((resolve, reject) => {
            var self = this;
            var fields_err = [];
            if (self.sectionArr.length != undefined){
                for(var j=0;j<self.sectionArr.length;j++){
                    self.sectionArr[j].reading_error = '';
                    if(self.sectionArr[j].reading != '' && (self.sectionArr[j].reading < self.sectionArr[j].lastreading)){
                        var read_error = self.sectionArr[j].section +' : '+'Reading ' +  self.sectionArr[j].reading + ' is less than previous reading ' + self.sectionArr[j].lastreading;
                        fields_err.push(read_error);
                    }
                }
                if(fields_err.length != 0){
                    var fielderror = "";
                    for(var i = 0; i < fields_err.length; i++){
                        fielderror += "<span style='display: contents;font-size: 15px;font-weight: 300;'>" + fields_err[i] +"</span>" + "<br/>";
                    }
                    self.$swal({
                        title: fielderror + "Do you want to continue?",
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showCloseButton: false,
                        customClass: 'swal2-overflow',
                    }).then((result) => {
                        if (result.value) {
                          resolve(true);
                        } else {
                          resolve(false);
                        }
                    });
                }else{
                  resolve(true);
                }
            }else{
              resolve(true);
            }
          });
        },

        checkOpenWorkOrder(vehicleId) {

            var self = this;
            self.loading = true;
            self.openWoArr = [];

            $.ajax({
                url: process.env.ROOT_API + "/workorder/check-open-workorder",
                type: "GET",
                async: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data: {
                    vehicleId: vehicleId
                },
                success: function (data) {
                    self.loading = false;
                    if ( data.status == "success" ) {
                        if ( data.content.length > 0 ) {
                            self.openWoArr = data.content;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'check-open-workorder');
                }
            });

        },
        arrayColumn(array, type) {

            if (array.length){
                for(var i =0;i<array.length;i++){
                    if (array[i].cost_type == type){
                        return array[i];
                    }
                }
            }
        },
        // getPriceBookValue:function(){

        //     var self = this;
        //     var vehicleId = "";
        //     if ( self.vehicle_id !== null ) {
        //         vehicleId = self.vehicle_id.value;
        //     }

        //     var customerId = "";
        //     if ( self.customer_id !== null ) {
        //         customerId = self.customer_id.value;
        //     }

        //     var locId = '';
        //     if (self.location_id != null && self.location_id.value){
        //         locId = self.location_id.value;
        //     }

        //     $.ajax({
        //         url: process.env.ROOT_API + "/price-book/fetch",
        //         type: "GET",
        //         headers: this.ajxHeaders
        //         dataType: "json",
        //         data:{
        //             customer_id:customerId,
        //             location_id:locId,
        //             vehicle_id: vehicleId
        //         },
        //         success: function (data) {
        //             self.loading = false;
        //             if (data.status == "success") {
        //                 self.customerPriceBookArr = data.content.customer;
        //                 self.defaultPriceBookArr = data.content.default;
        //                 self.chargesArr = data.content.charges;
        //                 self.billable_charges = data.content.charges_total;

        //             }else{
        //                 self.chargesArr = [];
        //                 self.billable_charges = 0;
        //             }
        //         },
        //         error: function (jqXHR, exception) {
        //             self.loading = false;
        //             self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-number');
        //         }
        //     });
        // },

        loadWorkOrder(from = '') {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;

            if (from == 'program'){
                // if (!self.mainArr.length && !self.warArr.length){
                if (!self.mainArr.length){
                    self.$swal('','Please select atlease one item or skip to work order item','info');
                    return;
                }
                // if (self.warArr.length && self.warArr.length > 1){
                //     self.$swal('','Please select only one warranty at a time','info');
                //     return;
                // }

            }
            self.loading = true;
            let wo_id = (segments[3] != undefined) ? segments[3] : self.woId;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/" + wo_id,
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    action_flag : 'edit', // pass action for notify: view, edit
                    is_notify_flag : true // notify if user viewing or editing
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                      if(data.code == 201) {
                          self.$swal('',data.message,'info');
                      } else {
                        self.assetUnitNo = data.content.vUnitNo;
                        self.work_order_no = data.content.work_order_no;
                        // if (self.$route.params.from == "copy") {
                        //   self.work_order_no = "";
                        // }else{
                        //   self.work_order_no = data.content.work_order_no;
                        // }

                       self.seqCheck = data.content.work_order_no;
                       self.work_order_type = {text:self.titleCase(data.content.wo_type),value:data.content.wo_type};
                       if (data.content.wo_type == 'multi unit'){
                           self.assetRequired = false;
                           self.disableSubletCheckbox = true;
                       }else{
                           self.assetRequired = true;
                           self.disableSubletCheckbox = false;
                       }
                        self.woId = data.content.id;
                        if (data.content.vehicle_id != null) {
                            var vehicleData = self.titleCase(data.content.vUnitNo);
                            if (data.content.vtCode != null) {
                                vehicleData += " | " + self.titleCase(data.content.vtCode);
                            }
                            if (data.content.vName != null) {
                                vehicleData += " | " + self.titleCase(data.content.vName);
                            }
                            self.vehicle_id = {
                                value: data.content.vehicle_id,
                                text: vehicleData
                            };
                            self.assetInfo = vehicleData;
                        } else {
                            self.vehicle_id = null;
                        }
                        if (data.content.vehicle_pool_id != null){
                          self.assetPoolInfo = data.content.vehicle_pool_code + " | " + data.content.vehicle_pool_description;
                        }

                        self.open_date = data.content.open_date;
                        self.openDateInfo = data.content.open_date;
                        if (data.content.close_date != null) {
                            self.closeDateInfo = data.content.close_date;
                        } else {
                            self.closeDateInfo = "-";
                        }
                        self.requested_completion = data.content.requested_completion;
                        self.requestCompInfo = data.content.requested_completion;
                        self.agreed_date = data.content.agreed_date;
                        self.agreedDateInfo = data.content.agreed_date;
                        self.customer_id = {
                            value: data.content.customer_id,
                            text: self.titleCase(data.content.cusCode + " | " + data.content.cusName)
                        };
                        self.customerInfo = self.titleCase(data.content.cusCode + " | " + data.content.cusName);
                        if (data.content.uLastName != null && data.content.uLastName != '') {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName) + " " + self.titleCase(data.content.uLastName);
                        } else {
                            self.user_id = {
                                value: data.content.user_id,
                                text: self.titleCase(data.content.uFirstName)
                            };
                            self.userInfo = self.titleCase(data.content.uFirstName);
                        }

                        self.reason_id = {
                            value: data.content.reason_id,
                            text: self.titleCase(data.content.rName) + " (" + data.content.rCode + ")"
                        };
                        if (data.content.priority) {
                            self.priority = {
                                value: data.content.priority,
                                text: data.content.priorityName + " (" + data.content.priority + ")"
                            };
                            self.priorityInfo = data.content.priorityName + " (" + data.content.priority + ")";
                        } else {
                            self.priority = null;
                        }
                        if (data.content.cost_code) {
                            self.cost_code = {
                                value: data.content.cost_code,
                                text: data.content.costCodeName + " (" + data.content.cost_code + ")"
                            };
                        }

                        self.crew_number = data.content.crew_number;
                        self.roadside_service = data.content.roadside_service;
                        self.woStatusInfo = self.titleCase(data.content.status);
                        self.milesInfo = data.content.miles;
                        if (data.content.schedule_date != null) {
                            self.scheduleMaintenanceInfo = data.content.vUnitNo + " (" + data.content.schedule_date + ")";
                        } else {
                            self.scheduleMaintenanceInfo = data.content.vUnitNo + " ()";
                        }
                        self.maintenanceTypeInfo = self.titleCase(data.content.maintenanceTypeName);
                        self.wostatus = {
                            value: data.content.status,
                            text: self.formatString(data.content.status)
                        };
                        if (data.content.lState != null) {
                            self.locationInfo = data.content.lCode + " | " + data.content.lName + ", " + data.content.lState;
                        } else {
                            self.locationInfo = data.content.lName + " | " + data.content.lCode;
                        }
                        // if (data.content.price_book != undefined && data.content.price_book != null) {
                        //     if (data.content.price_book.customer != undefined && data.content.price_book.customer != null) {
                        //         self.customerPriceBookArr = data.content.price_book.customer;
                        //     }
                        //     if (data.content.price_book.default != undefined && data.content.price_book.default != null) {
                        //         self.defaultPriceBookArr = data.content.price_book.default;
                        //     }
                        // }
                        self.invoiceGenerated = data.content.invoice_generated;
                        self.workOrderItemData('');

                        self.wonotes = data.content.description;
                        self.woNotesInfo = data.content.description;

                        if (data.content.location_id) {
                            self.location_id = {
                                value: data.content.location_id,
                                text: self.titleCase(data.content.lName) + ' | ' + data.content.lCode
                            };
                        }

                        if (data.content.maintenanceTypeId) {
                            self.maintenance_type_id = {
                                value: data.content.maintenanceTypeId,
                                text: self.titleCase(data.content.maintenanceTypeName)
                            };
                        }

                        self.tax = data.content.tax;
                        self.total_tax = data.content.tax_amount;

                        self.miles = data.content.miles;

                        self.discount = data.content.discount;
                        self.total_discount = data.content.discount_amount;
                        self.other_charges = data.content.other_charges;
                        self.billable_charges = data.content.other_charges;
                        self.shop_supplies = data.content.shop_supplies;

                        self.total = data.content.total_amount;
                        self.OutOfService = data.content.out_of_service;

                        if(data.content.vehicle_id != '' && data.content.vehicle_type_id != '' && data.content.vUnitNo != ''){
                          self.getSectionForReading(data.content.vehicle_id, data.content.vehicle_type_id, data.content.vUnitNo);
                        }

                        if (data.content.sectionData){
                            self.sectionArr = data.content.sectionData;

                            self.existingReading = self.sectionArr.map(item => item.reading);
                        }
                        if (data.content.is_miscellaneous == 1 ) {

                            $("#is_miscellaneous").prop("checked",true);
                            self.is_miscellaneous = true;
                            self.showMiscellaneousFields = true;
                            self.customer_email = data.content.customer_email;
                            self.customer_vin_number = data.content.customer_vin_number;
                            self.customer_unit_no = data.content.customer_unit_no;
                            self.woIsMiscellaneous = "Yes";
                            self.woCustomerEmailInfo = data.content.customer_email;
                            self.woCustomerVinInfo = data.content.customer_vin_number;
                            self.woCustomerUnitNoInfo = data.content.customer_unit_no;
                            // if(!$("#customer_id").hasClass("disable-field")){
                            //     $("#customer_id").addClass("disable-field");
                            // }
                            self.disableCustField = false;
                        }else{
                            $("#is_miscellaneous").prop("checked",false);
                            self.is_miscellaneous = false;
                            self.showMiscellaneousFields = false;
                            self.woIsMiscellaneous = "No";
                            // if($("#customer_id").hasClass("disable-field")){
                            //     $("#customer_id").removeClass("disable-field");
                            // }
                            self.disableCustField = false;
                        }
                        // setTimeout(function(){
                        //     $("#maintenance_type_id").addClass("disable-field");
                        // },100);
                        self.disableMaintenanceTypeField = true;
                        //self.poInputId  = {text:data.content.cust_po_no+' | '+data.content.cust_po_amount,value:data.content.customer_purchase_order};
                        self.customerPoNo = data.content.customer_po_no;
                        //Role is Technician
                        //if (self.role == 'technician') {

                            // tech can update anything according to : Breaanaa
                            // if (self.loggedInUser != '' && self.loggedInUser != null && self.loggedInUser != undefined ) {
                            //     if (self.loggedInUser.value == data.content.created_by) {
                            //         self.disableWOFields = false;
                            //     }else{
                            //         self.disableWOFields = true;
                            //         self.disableCustField = true;
                            //         self.disableWoStatusField = true;
                            //     }

                            // } else {
                            //     self.disableWOFields = false;
                            // }
                            self.disableWOFields = false;

                        // } else {
                        //     self.disableWOFields = false;
                        // }

                        if (data.content.selected_programs && data.content.selected_programs.length > 0){
                            self.selectedProgramArr = data.content.selected_programs;
                        }
                      }

                    }
                    setTimeout(function(){
                        //self.getPriceBookValue();
                        self.getLaborCostValue();
                    },1000);

                    //self.disableWoStatusField = true;
                    if (from == 'program'){
                        self.addMaintenanceTask();
                    }
                    if (from == 'program_skip'){
                        self.addMaintenanceTask('program_skip');
                    }
                    // self.getMappedProgram(self.vehicle_id.value)

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'load-workorder-details');
                }
            });
        },
        getWorkOrderNo() {
            let self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/workorder/number",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.work_order_no = data.content.work_order_no;
                        //self.work_order_no_temp = data.content.work_order_no;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-number');
                }
            });
        
        },
        getCurrentDateTime() {
            var today = new Date();

            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            var HH = today.getHours();
            var MM = today.getMinutes();
            var SS = today.getSeconds();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            if (HH < 10) {
                HH = '0' + HH;
            }

            if (MM < 10) {
                MM = '0' + MM;
            }

            if (SS < 10) {
                SS = '0' + SS;
            }

            var date = mm + '/' + dd + '/' + yyyy;
            var time = HH + ":" + MM + ":" + SS;

            today = date + " " + time;
            return today;
        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        formatString(data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },

        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                if(self.location_id != null && self.location_id.value){

                    var defaultWarehouse = 0;
                    // if (self.activeLineItemIdx != null && self.activeLineItemIdx != "") {
                        if (self.taskArr[self.activeLineItemIdx] != undefined && self.taskArr[self.activeLineItemIdx].default_warehouse != undefined && self.taskArr[self.activeLineItemIdx].default_warehouse != null) {
                            if (self.taskArr[self.activeLineItemIdx].default_warehouse === true) {
                                defaultWarehouse = 1;
                            }
                        }
                    // }
                    // self.searchWOComponent(loading, search, 'available component', self.location_id.value,defaultWarehouse);
                    if (defaultWarehouse == 1){
                        self.searchWOComponent(loading, search, 'available component', self.location_id.value,defaultWarehouse);
                    }else{
                        self.searchWOComponent(loading, search, 'available component', '',defaultWarehouse);
                    }
                }
                // else{

                //     self.searchField(loading, search, 'available component', '');

                // }
            }
        },

        removeLine(removeFrom, index) {
            var self = this;

            var removeLaborArr = [];
            var removeCompArr = [];

            if (removeFrom == 'task') {
                self.currentTaskIndex = index;
                if (self.taskArr[index].woiId == 0) {

                    if (confirm('Are you sure that you want to remove this line? ')) {
                        self.taskArr.splice(index, 1);

                        // Remove Service Task from the Service Task selection
                        self.serviceTaskArr.splice(index, 1);

                        // PR - Remove Labor assigned to perticular Service Task

                        for (var i = 0; i < self.laborArr.length; i++) {

                            if (self.laborArr[i].service_task_id != null) {

                                if (self.laborArr[i].service_task_id.index == index) {

                                    removeLaborArr.push(i);

                                }

                            }

                        }

                        for (var i = removeLaborArr.length - 1; i >= 0; i--) {

                            self.laborArr.splice(removeLaborArr[i], 1);

                        }

                        // PR - Remove Component assigned to perticular Service Task

                        for (var j = 0; j < self.compArr.length; j++) {

                            if (self.compArr[j].service_task_id != null) {

                                if (self.compArr[j].service_task_id.index == index) {
                                    removeCompArr.push(j);

                                }

                            }

                        }

                        for (var i = removeCompArr.length - 1; i >= 0; i--) {

                            self.compArr.splice(removeCompArr[i], 1);

                        }

                        self.manageLaborCompIndex(index);
                        self.calculateTotalAmount();
                    }

                } else {
                    //remove work order line item task
                    self.removeWorkOrderLineItem('task', self.taskArr[index].woiId, index);
                }

            } else if (removeFrom == 'labor') {

                if (self.laborArr[index].lid == 0) {

                    if (self.laborArr[index].service_task_id != null) {
                        var taskIndex = self.laborArr[index].service_task_id.index;
                        var lSubtotal = self.laborArr[index].laborsubtotal;

                        self.taskArr[taskIndex].laboramount = self.taskArr[taskIndex].laboramount - lSubtotal;
                        self.taskArr[taskIndex].subtotal = self.taskArr[taskIndex].subtotal - lSubtotal;

                        // TO DO :
                        if (self.taskArr[taskIndex].laboramount == 0) {
                            // if ($('#laboramount'+taskIndex).hasClass('disable-field')) {
                            //     $("#laboramount"+taskIndex).removeClass("disable-field");
                            // }
                            self.taskArr[taskIndex].hasLabor = false;
                        }
                    }

                    self.laborArr.splice(index, 1);
                    self.calculateTotalAmount();

                } else {
                    //remove work order line item labor
                    self.removeWorkOrderLineItem('labor', self.laborArr[index].lid, index);
                }

            } else if (removeFrom == 'component') {

                if (self.compArr[index].cid == 0) {

                    if (self.compArr[index].service_task_id != null) {
                        var taskIndex = self.compArr[index].service_task_id.index;
                        var cSubtotal = self.compArr[index].compsubtotal;

                        self.taskArr[taskIndex].partamount = self.taskArr[taskIndex].partamount - cSubtotal;
                        self.taskArr[taskIndex].subtotal = self.taskArr[taskIndex].subtotal - cSubtotal;

                        // TO DO :
                        if (self.taskArr[taskIndex].partamount == 0) {
                            // if ($('#partamount'+taskIndex).hasClass('disable-field')) {
                            //     $("#partamount"+taskIndex).removeClass("disable-field");
                            // }
                            self.taskArr[taskIndex].hasComp = false;
                        }
                    }

                    self.compArr.splice(index, 1);
                    self.calculateTotalAmount();

                } else {
                    //remove work order line item component
                    self.removeWorkOrderLineItem('component', self.compArr[index].cid, index);
                }

            } else {

                if (self.laborHourArr[index].timelog_id == 0) {
                    //get time difference
                    if (self.laborHourArr[index].duration != '-') {
                        self.serviceTaskLaborHour = self.getDifference(self.serviceTaskLaborHour, self.laborHourArr[index].duration, "diff");
                    }
                    self.laborHourArr.splice(index, 1);

                } else {
                    //get time difference
                    // self.serviceTaskLaborHour = self.getDifference(self.serviceTaskLaborHour,self.laborHourArr[index].duration,"diff");
                    //remove work order line item labor log
                    self.removeWorkOrderLineItem('log', self.laborHourArr[index].timelog_id, index);
                }
            }

        },

        manageLaborCompIndex(index) {
            var self = this;

            for (var i = 0; i < self.laborArr.length; i++) {
                if (self.laborArr[i].service_task_id != null) {
                    if (self.laborArr[i].service_task_id.index > index) {
                        self.laborArr[i].service_task_id.index = self.laborArr[i].service_task_id.index - 1;
                    }
                }
            }

            for (var j = 0; j < self.compArr.length; j++) {
                if (self.compArr[j].service_task_id != null) {
                    if (self.compArr[j].service_task_id.index > index) {
                        self.compArr[j].service_task_id.index = self.compArr[j].service_task_id.index - 1;
                    }
                }
            }

            //serviceTaskArr

            for (var k = 0; k < self.serviceTaskArr.length; k++) {
                if (self.serviceTaskArr[k].index > index) {
                    self.serviceTaskArr[k].index = self.serviceTaskArr[k].index - 1;
                }
            }

        },
        workOrderItemData(flag) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            let wo_id = (segments[3] != undefined) ? segments[3] : self.woId;
            //unbind jScrollPane
            setTimeout(function () {
                $(function () {
                    /*var pane = $('.comment-list-btm');
                    pane.jScrollPane();
                    var api = pane.data('jsp');
                    if (api != undefined) {
                        api.destroy();
                    }*/

                    //activity jScrollPane
                    var paneActivity = $('.activity-list-btm');
                    paneActivity.jScrollPane();
                    var apiActivity = paneActivity.data('jsp');
                    if (typeof apiActivity !== 'undefined') {
                        apiActivity.destroy();
                    }
                });
            }, 200);
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/get-workorder-item",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: wo_id,
                },
                success: function (data) {
                    self.loading = false;
                    //blank flag used in time log
                    self.logFlag = "";
                    self.logStartAt = "";
                    if (data.code == 200) {
                        self.taskArr = [];
                        self.compArr = [];
                        self.laborArr = [];
                        self.commentArr = [];
                        self.laborHourArr = [];
                        self.activityArr = [];
                        self.getExistingWOI = [];

                        if (data.content.item != undefined) {
                            self.serviceTaskArr = []
                            self.getExistingWOI = data.content.item;
                            for (var i = 0; i < data.content.item.length; i++) {

                                self.taskArr.push({

                                    // wo_id: (data.content[i].wo_id != undefined && data.content[i].wo_id != null && data.content[i].wo_id != '')?data.content[i].wo_id:0,
                                    woiId: (data.content.item[i].wo_item_id != undefined && data.content.item[i].wo_item_id != null && data.content.item[i].wo_item_id != '') ? data.content.item[i].wo_item_id : 0,
                                    line_number: (data.content.item[i].line_number != undefined && data.content.item[i].line_number != null && data.content.item[i].line_number != '') ? data.content.item[i].line_number : '',
                                    taskid: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? {
                                        value: data.content.item[i].task_id,
                                        text: self.titleCase(data.content.item[i].task_name + " (" + data.content.item[i].task_code + ")")
                                    } : null,
                                    laboramount: data.content.item[i].labor_amount,
                                    partamount: data.content.item[i].component_amount,
                                    component_category_id: (data.content.item[i].component_category_id != undefined && data.content.item[i].component_category_id != null && data.content.item[i].component_category_id != '') ? {
                                        value: data.content.item[i].component_category_id,
                                        text: self.titleCase(data.content.item[i].component_category_name + " (" + data.content.item[i].component_category_code + ")")
                                    } : null,
                                    unit_id: (data.content.item[i].vehicle_id != undefined && data.content.item[i].vehicle_id != null && data.content.item[i].vehicle_id != '') ? {
                                        value: data.content.item[i].vehicle_id,
                                        text: self.titleCase(data.content.item[i].unit_no),
                                        unit_no: self.titleCase(data.content.item[i].unit_no)
                                    } : null,
                                    wi_reason_id: (data.content.item[i].wi_reason_id != undefined && data.content.item[i].wi_reason_id != null && data.content.item[i].wi_reason_id != '') ? {
                                        value: data.content.item[i].wi_reason_id,
                                        text: self.titleCase(data.content.item[i].wi_reason_name + " (" + data.content.item[i].wi_reason_code + ")")
                                    } : null,
                                    billable_code: (data.content.item[i].billable_code != undefined && data.content.item[i].billable_code != null && data.content.item[i].billable_code != '') ? {
                                        value: data.content.item[i].billable_code,
                                        text: self.titleCase(data.content.item[i].billable_code_name + " (" + data.content.item[i].billable_code + ")")
                                    } : null,
                                    defect_id: (data.content.item[i].standard_defect_id != undefined && data.content.item[i].standard_defect_id != null && data.content.item[i].standard_defect_id != '') ? {
                                        value: data.content.item[i].standard_defect_id,
                                        text: self.titleCase(data.content.item[i].standard_defect_name + " (" + data.content.item[i].standard_defect_code + ")")
                                    } : null,
                                    woistatus: {
                                        value: data.content.item[i].woistatus,
                                        text: self.titleCase(data.content.item[i].woistatus)
                                    },
                                    woicomplaint: data.content.item[i].complaint,
                                    woicause: data.content.item[i].cause,
                                    woicorrection: data.content.item[i].correction,
                                    woinotes: data.content.item[i].notes,

                                    issublet: data.content.item[i].issublet,
                                    purchaseorderid: (data.content.item[i].purchaseorderid != undefined && data.content.item[i].purchaseorderid != null && data.content.item[i].purchaseorderid != '') ? {
                                        value: data.content.item[i].purchaseorderid,
                                        text: self.titleCase(data.content.item[i].purchaseorderno) + " | " + data.content.item[i].purchaseordertotal,
                                        vendor_id:(data.content.item[i].vendorid != undefined && data.content.item[i].vendorid != null && data.content.item[i].vendorid != '')?data.content.item[i].vendorid:"",
                                        vendor:(data.content.item[i].vendorid != undefined && data.content.item[i].vendorid != null && data.content.item[i].vendorid != '')?self.titleCase(data.content.item[i].vendorcode + " | " + data.content.item[i].vendorname):"",
                                        bill_id:(data.content.item[i].bill_id != undefined && data.content.item[i].bill_id != null && data.content.item[i].bill_id != '') ? data.content.item[i].bill_id:"",
                                        voucher_number:(data.content.item[i].voucher != undefined && data.content.item[i].voucher != null && data.content.item[i].voucher != '') ? data.content.item[i].voucher:"",
                                    } : null,
                                    po_number:data.content.item[i].purchaseorderno,
                                    billId: (data.content.item[i].bill_id != undefined && data.content.item[i].bill_id != null && data.content.item[i].bill_id != '') ? {
                                        value: data.content.item[i].bill_id,
                                        text: data.content.item[i].voucher
                                    } : null,
                                    vendorid: (data.content.item[i].vendorid != undefined && data.content.item[i].vendorid != null && data.content.item[i].vendorid != '') ? {
                                        value: data.content.item[i].vendorid,
                                        text: self.titleCase(data.content.item[i].vendorcode + " | " + data.content.item[i].vendorname)
                                    } : null,
                                    estimatedwoiId: (data.content.item[i].estimate_wo_item_id != undefined && data.content.item[i].estimate_wo_item_id != null && data.content.item[i].estimate_wo_item_id != '') ? data.content.item[i].estimate_wo_item_id : 0,
                                    estimatedlaboramount: data.content.item[i].estimate_wo_item_labor_amount,

                                    vendor_est_id:	data.content.item[i].vendor_est_id,
                                    vendor_estimate_no:	data.content.item[i].vendor_estimate_no,
                                    sent_status:data.content.item[i].sent_status,
                                    estimation_status:data.content.item[i].estimation_status,
                                    vendor_estimate_part_amount:data.content.item[i].vendor_estimate_part_amount,
                                    vendor_estimate_labor_amount:data.content.item[i].vendor_estimate_labor_amount,

                                    cust_est_id:	data.content.item[i].cust_est_id,
                                    cust_estimate_no:	data.content.item[i].cust_estimate_no,
                                    cust_sent_status:data.content.item[i].cust_sent_status,
                                    cust_estimate_part_amount:data.content.item[i].cust_estimate_part_amount,
                                    cust_estimate_labor_amount:data.content.item[i].cust_estimate_labor_amount,
                                    wo_item_created_by:data.content.item[i].wo_item_created_by,
                                    disable_task:data.content.item[i].disable_task,//Disable Line Item Update Flag From Backend
                                    labor_found:data.content.item[i].labor_found,
                                    task_labor:data.content.item[i].task_labor,
                                    log_btn_title:data.content.item[i].log_btn_title,
                                    task_labor_user:data.content.item[i].task_labor_user,
                                    service_task_index:i,
                                    log_found:data.content.item[i].log_found,
                                    est_repair_time:data.content.item[i].est_repair_time,
                                    etcExtend:(data.content.item[i].etc_reason != undefined && data.content.item[i].etc_reason != null && data.content.item[i].etc_reason != '') ? true : false,
                                    std_repair_time:data.content.item[i].std_repair_time,
                                    sublet_amount:data.content.item[i].sublet_amount,
                                    disable_sublet:data.content.item[i].disable_sublet,
                                    program_id:(data.content.item[i].program_id != undefined && data.content.item[i].program_id != null && data.content.item[i].program_id != '') ? {
                                        value: data.content.item[i].program_id,
                                        text: data.content.item[i].program
                                    } : null,
                                    warrantyArr:[],
                                    warranty_id:(data.content.item[i].warranty_id != undefined && data.content.item[i].warranty_id != null && data.content.item[i].warranty_id != '') ? {
                                        value: data.content.item[i].warranty_id,
                                        text: data.content.item[i].warranty
                                    } : null,
                                    available_warranty_msg:'',
                                    po_error_msg:'',
                                    specialUnitNo:'',
                                    specialItemsArr:[],
                                    selectedSpItemsArr:[],
                                    isItemModal:0,
                                    isItemErrorMsg:'',
                                    disable_task_id:false,
                                    bill_item_id:(data.content.item[i].bill_item_id != undefined && data.content.item[i].bill_item_id != null && data.content.item[i].bill_item_id != '') ? data.content.item[i].bill_item_id:'',
                                    disable_billable:(data.content.item[i].disable_billable != undefined && data.content.item[i].disable_billable != null)?data.content.item[i].disable_billable:false,
                                    disable_amount_sublet:(data.content.item[i].disable_amount_sublet != undefined && data.content.item[i].disable_amount_sublet != null)?data.content.item[i].disable_amount_sublet:false,
                                    disable_po_sublet:(data.content.item[i].disable_po_sublet != undefined && data.content.item[i].disable_po_sublet != null)?data.content.item[i].disable_po_sublet:false,
                                    disable_vendor_sublet:(data.content.item[i].disable_vendor_sublet != undefined && data.content.item[i].disable_vendor_sublet != null)?data.content.item[i].disable_vendor_sublet:false,
                                    default_warehouse:true,
                                    isPartAdd:0,
                                    partAddArr:[],
                                    etc_reason:(data.content.item[i].etc_reason != undefined && data.content.item[i].etc_reason != null && data.content.item[i].etc_reason != '') ? data.content.item[i].etc_reason:'',

                                    // subtotal: 0,
                                    // hasLabor: false,
                                    // hasComp: false

                                });

                                self.serviceTaskArr.push({
                                    value: (data.content.item[i].task_id != undefined && data.content.item[i].task_id != null && data.content.item[i].task_id != '') ? data.content.item[i].task_id : null,
                                    text: data.content.item[i].task_name,
                                    index: self.taskArr.length - 1
                                });

                            }
                        }

                        if (data.content.comp != undefined) {
                            for (var i = 0; i < data.content.comp.length; i++) {

                                self.compArr.push({
                                    cid: (data.content.comp[i].cid != undefined && data.content.comp[i].cid != null && data.content.comp[i].cid != '') ? data.content.comp[i].cid : 0,
                                    compid: {
                                        value: data.content.comp[i].compid,
                                        text: data.content.comp[i].compname,
                                        quantity: data.content.comp[i].quantity,
                                        category_code:data.content.comp[i].item_category,
                                        bin_id:data.content.comp[i].bin_mapper_id
                                    },
                                    service_task_id: {
                                        value: data.content.comp[i].service_task_id,
                                        text: data.content.comp[i].service_task_name,
                                        index: data.content.comp[i].service_task_index
                                    },
                                    compcost: data.content.comp[i].compcost,
                                    compquantity: data.content.comp[i].compquantity,
                                    compsubtotal: data.content.comp[i].compsubtotal,
                                    compdescription: data.content.comp[i].compdescription,
                                    estimatedcid: (data.content.comp[i].estimate_cid != undefined && data.content.comp[i].estimate_cid != null && data.content.comp[i].estimate_cid != '') ? data.content.comp[i].estimate_cid : 0,
                                    comp_created_by:data.content.comp[i].comp_created_by,
                                    oldquantity:data.content.comp[i].compquantity,
                                    is_issued:data.content.comp[i].is_issued,
                                    wr_location:data.content.comp[i].wr_location,
                                    warehouse_id:null,
                                });

                            }
                        }

                        if (data.content.comment != undefined) {
                            for (var i = 0; i < data.content.comment.length; i++) {

                                self.commentArr.push({
                                    wocId: (data.content.comment[i].wocId != undefined && data.content.comment[i].wocId != null && data.content.comment[i].wocId != '') ? data.content.comment[i].wocId : 0,
                                    service_task_id: {
                                        value: data.content.comment[i].service_task_id,
                                        text: data.content.comment[i].service_task_name,
                                        index: data.content.comment[i].service_task_index
                                    },
                                    wocType: {
                                        value: data.content.comment[i].wocTypeId,
                                        text: self.titleCase(data.content.comment[i].wocTypeName) + ' (' + data.content.comment[i].wocType + ')'
                                    },
                                    woc: data.content.comment[i].woc,
                                    wocBy: data.content.comment[i].wocBy,
                                    wocAt: data.content.comment[i].wocAt,
                                    estimatedwocId: (data.content.comment[i].estimate_wocId != undefined && data.content.comment[i].estimate_wocId != null && data.content.comment[i].estimate_wocId != '') ? data.content.comment[i].estimate_wocId : 0,
                                    comment_created_by:data.content.comment[i].comment_created_by
                                });

                            }
                        }

                        if (data.content.labor != undefined) {
                            for (var i = 0; i < data.content.labor.length; i++) {

                                self.laborArr.push({
                                    lid: (data.content.labor[i].lid != undefined && data.content.labor[i].lid != null && data.content.labor[i].lid != '') ? data.content.labor[i].lid : 0,
                                    laborid: (data.content.labor[i].laborid != undefined && data.content.labor[i].laborid != null && data.content.labor[i].laborid != '') ? {
                                        value: data.content.labor[i].laborid,
                                        text: data.content.labor[i].laborname
                                    } : null,
                                    service_task_id: {
                                        value: data.content.labor[i].service_task_id,
                                        text: data.content.labor[i].service_task_name,
                                        index: data.content.labor[i].service_task_index
                                    },
                                    laborhours: parseFloat(data.content.labor[i].laborhours).toFixed(2),
                                    laborhourrate: data.content.labor[i].laborhourrate,
                                    laborsubtotal: data.content.labor[i].laborsubtotal,
                                    labordescription: data.content.labor[i].labordescription,
                                    labor_created_by:data.content.labor[i].labor_created_by
                                });

                                if (data.content.timelog != undefined) {
                                    for (var k = 0; k < data.content.timelog.length; k++) {
                                        if (data.content.timelog[k].lid == data.content.labor[i].lid) {
                                            self.laborHourArr.push({
                                                woiId:(data.content.timelog[k].woiId != undefined && data.content.timelog[k].woiId != null && data.content.timelog[k].woiId != '') ? data.content.timelog[k].woiId : 0,
                                                timelog_id: (data.content.timelog[k].timelogid != undefined && data.content.timelog[k].timelogid != null && data.content.timelog[k].timelogid != '') ? data.content.timelog[k].timelogid : 0,
                                                labor_id: data.content.timelog[k].lid,
                                                start_time: (data.content.timelog[k].start_time != null && data.content.timelog[k].start_time != undefined && data.content.timelog[k].start_time != '') ? data.content.timelog[k].start_time : '-',
                                                end_time: (data.content.timelog[k].end_time != null && data.content.timelog[k].end_time != undefined && data.content.timelog[k].end_time != '') ? data.content.timelog[k].end_time : '-',
                                                duration: (data.content.timelog[k].duration != null && data.content.timelog[k].duration != undefined && data.content.timelog[k].duration != '') ? data.content.timelog[k].duration : '-',
                                                labor_index: i,
                                                timelog_created_by:data.content.timelog[k].timelog_created_by,
                                                duration_decimal:data.content.timelog[k].duration_decimal,
                                                labor_name:data.content.timelog[k].laborname,
                                                service_task_index:data.content.timelog[k].service_task_index,
                                                log_status:data.content.timelog[k].log_status
                                            });
                                        }
                                    }
                                }
                            }
                        }

                        //crm activity for work order
                        if (data.content.activity != undefined) {
                            for (var i = 0; i < data.content.activity.length; i++) {

                                self.activityArr.push({
                                    // woiId: (data.content.activity[i].woiId != undefined && data.content.activity[i].woiId != null && data.content.activity[i].woiId != '') ? data.content.activity[i].woiId : 0,
                                    // crmId: (data.content.activity[i].crmId != undefined && data.content.activity[i].crmId != null && data.content.activity[i].crmId != '') ? data.content.activity[i].crmId : 0,
                                    service_task_index: data.content.activity[i].service_task_index,
                                    activity_type: data.content.activity[i].name,
                                    notes: (data.content.activity[i].details != null && data.content.activity[i].details != undefined && data.content.activity[i].details != '') ? data.content.activity[i].details : '',
                                    activityBy: data.content.activity[i].performed_by,
                                    activityAt: data.content.activity[i].performed_at,
                                });
                            }
                        }

                        //bind jScrollPane
                        setTimeout(function () {
                            $(function () {
                                var settings = {
                                    showArrows: true
                                };
                                //activity jScrollPane
                                var settingsActivity = {
                                    showArrows: true
                                };
                                var paneActivity = $('.activity-list-btm')
                                paneActivity.jScrollPane();
                                var apiActivity = paneActivity.data('jsp');
                                if (typeof apiActivity !== 'undefined') {
                                    apiActivity.reinitialise();
                                }
                            });
                            if( self.taskArr.length > 0){
                            //in order to show entire line item on add line item button click...
                            if(self.activeLineItemIdx == null || self.activeLineItemIdx == ''){
                                self.activeLineItemIdx = self.currentTaskIndex;
                            }

                        }
                        }, 1000);


                    } else if (data.code == 201) {
                        self.compArr = [];
                        self.laborArr = [];
                        self.taskArr = [];
                        self.calculateTotalAmount();

                        if(!self.estimateFlag){
                            self.addSetOfTask();
                            self.taskArr.splice(0, 1);
                        }

                        // Remove Service Task from the Service Task selection
                        self.serviceTaskArr.splice(0, 1);

                    }

                    if(flag == 'loadAfterSave'){

                        var issubVal = 0;
                        var venId = null;
                        var po_number = '';
                        var purchaseorderid = null;
                        var compId = null;
                        var taskId = null;
                        var sublet_amount = 0;
                        var existingTaskId = null;
                        var existingCompCatId = null;
                        var existingBillCode = null;

                        if (!self.assetRequired){
                            var populateDetail = 'false';
                            issubVal = 1;
                            if (self.taskArr[0].component_category_id != undefined && self.taskArr[0].component_category_id.text != undefined && self.taskArr[0].component_category_id.text.includes('WA000000')
                               && self.taskArr[0].taskid != undefined && self.taskArr[0].taskid.text != undefined && self.taskArr[0].taskid.text.includes('52')){
                                populateDetail = 'true';
                                self.requireEtc = '';
                            }

                            if (self.taskArr[0] && self.taskArr[0].vendorid){
                                venId = self.taskArr[0].vendorid;
                            }
                            if (self.taskArr[0] && self.taskArr[0].po_number && populateDetail == 'true'){
                                po_number = self.taskArr[0].po_number;
                            }
                            if (self.taskArr[0] && self.taskArr[0].purchaseorderid && populateDetail == 'true'){
                                // if (self.taskArr[0].component_category_id != undefined && self.taskArr[0].component_category_id.text != undefined && self.taskArr[0].component_category_id.text.includes('WA000000')){
                                    purchaseorderid = self.taskArr[0].purchaseorderid;
                                // }
                            }
                            if (self.taskArr[0] && self.taskArr[0].component_category_id){
                                compId = self.taskArr[0].component_category_id;
                            }
                            if (self.taskArr[0] && self.taskArr[0].taskid){
                                taskId = self.taskArr[0].taskid;
                            }
                            if (self.taskArr[0] && self.taskArr[0].sublet_amount && populateDetail == 'true'){
                                sublet_amount = self.taskArr[0].sublet_amount;
                            }
                        }

                        self.activeLineItemIdx = self.taskArr.length - 1;
                        self.currentTaskIndex = self.activeLineItemIdx;
                        var l_no = '';
                        if (self.taskArr[self.currentTaskIndex].line_number != undefined && self.taskArr[self.currentTaskIndex].line_number > 0){
                            l_no = parseInt(self.taskArr[self.currentTaskIndex].line_number) + 1;
                        }

                        existingTaskId = (self.getExistingWOI[0].task_id != undefined && self.getExistingWOI[0].task_id != null && self.getExistingWOI[0].task_id != '') ? {
                            value: self.getExistingWOI[0].task_id,
                            text: self.titleCase(self.getExistingWOI[0].task_name + " (" + self.getExistingWOI[0].task_code + ")")
                        } : null;

                        existingCompCatId = (self.getExistingWOI[0].component_category_id != undefined && self.getExistingWOI[0].component_category_id != null && self.getExistingWOI[0].component_category_id != '') ? {
                            value: self.getExistingWOI[0].component_category_id,
                            text: self.titleCase(self.getExistingWOI[0].component_category_name + " (" + self.getExistingWOI[0].component_category_code + ")")
                        } : null;

                        existingBillCode = (self.getExistingWOI[0].billable_code != undefined && self.getExistingWOI[0].billable_code != null && self.getExistingWOI[0].billable_code != '') ? {
                            value: self.getExistingWOI[0].billable_code,
                            text: self.titleCase(self.getExistingWOI[0].billable_code + " | " + self.getExistingWOI[0].billable_code_name)
                        } : null;

                        self.taskArr.push({
                            woiId: 0,
                            taskid: (self.work_order_type.value == 'multi unit') ? existingTaskId : null,
                            line_number:l_no,
                            unit_id: null,
                            component_category_id: (self.work_order_type.value == 'multi unit') ? existingCompCatId : null,
                            wi_reason_id: null,
                            billable_code: (self.work_order_type.value == 'multi unit') ? existingBillCode : null,
                            defect_id: null,
                            woistatus: {
                                value: "open",
                                text: "Open"
                            },
                            issublet: issubVal,
                            purchaseorderid: purchaseorderid,
                            po_number:po_number,
                            vendorid: venId,
                            woinotes: '',
                            woicomplaint: '',
                            woicause: '',
                            woicorrection: '',
                            laboramount: 0,
                            partamount: 0,
                            subtotal: 0,
                            hasLabor: false,
                            hasComp: false,
                            hasComment: false,
                            estimatedwoiId: 0,
                            estimatedlaboramount: 0,
                            disable_task:false,
                            labor_found:0,
                            task_labor:0,
                            log_btn_title:"Start Log Time",
                            task_labor_user:0,
                            log_found:0,
                            sublet_amount:sublet_amount,
                            disable_sublet:false,
                            specialUnitNo:'',
                            specialItemsArr:[],
                            selectedSpItemsArr:[],
                            isItemModal:0,
                            isItemErrorMsg:'',
                            disable_task_id:false,
                            bill_item_id:'',
                            disable_billable:false,
                            disable_amount_sublet:false,
                            disable_po_sublet:false,
                            disable_vendor_sublet:false,
                            default_warehouse:true,
                            isPartAdd:0,
                            partAddArr:[],
                            etc_reason:'',
                            etcExtend:false
                        });

                        if (!self.assetRequired){
                            self.$set(self.taskArr[self.activeLineItemIdx],'issublet',true);

                            // billableCodeArr
                            if (self.billableCodeArr && self.billableCodeArr.length > 0){
                                for(var j = 0; j < self.billableCodeArr.length;j++){
                                    if (self.billableCodeArr[j].value == 'S'){
                                        self.taskArr[self.activeLineItemIdx].billable_code = self.billableCodeArr[j];
                                    }
                                }
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-item-detail');
                }
            });
        },
        validateWorkOrder() {

            var self = this;
            var error = false;
            self.vehicle_error_msg = "";
            self.miles_error_msg = "";
            self.maintenance_type_error_msg = "";
            self.customer_error_msg = "";
            self.location_error_msg = "";
            self.user_error_msg = "";

            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

            if (self.vehicle_id == null || !self.vehicle_id.value) {
                self.vehicle_error_msg = "Unit Required.";
                error = true;
            }

            if (self.miles == null || self.miles == "") {
                //self.miles_error_msg = "Miles Required.";
                //error = true;
            } else {

                //check amount is valid or not
                if (!String(self.miles).match(checkNumber)) {
                    self.miles_error_msg = "Miles is not valid.";
                    error = true;
                }
            }

            if (self.maintenance_type_id == null || !self.maintenance_type_id.value) {
                self.maintenance_type_error_msg = "Maintenance Type Required.";
                error = true;
            }

            if (self.customer_id == null || !self.customer_id.value) {
                self.customer_error_msg = "Customer Required.";
                error = true;
            }

            if (self.location_id == null || !self.location_id.value) {
                self.location_error_msg = "Location Required.";
                error = true;
            }

            if (self.user_id == null || !self.user_id.value) {
                self.user_error_msg = "User Required.";
                error = true;
            }

            if (!error) {
                self.displayLineItem = true;
            }

        },

        //task validations
        taskValidations(flag, index) {

            var self = this;
            var error = false;

            if (flag == "labor") {
                var showComponent = 'addLabor' + index;
                //assign laborIndex in case of Add Labor

                if (self.laborArr.length > 0) {
                    self.laborIndex = self.laborArr.length;
                }

                self.showActiveLaborLog = 'addLaborLog';
                //check active Line Item and change time label
                self.currentTaskIndex = index;
                if (self.activeLineItemIdx == index) {
                    self.timeLabel = 'Start Log Time';
                    self.taskArr[index].log_btn_title = 'Start Log Time';
                    //to handle labor log time button title in case of technician
                    if (self.role.toLowerCase() == "technician") {
                        var startCnt = 0;
                        var endCnt = 0;
                        for(var i = 0;i < self.laborArr.length;i++) {
                            if (self.laborArr[i] != undefined && self.laborArr[i] != null) {
                                if (self.laborArr[i].service_task_id != null) {
                                    if (self.laborArr[i].service_task_id.index == index) {
                                        if (self.laborArr[i].laborid != undefined && self.laborArr[i].laborid != null) {
                                            if (self.loggedInUser != undefined && self.loggedInUser != null) {
                                                if (self.laborArr[i].laborid.value == self.loggedInUser.value) {
                                                    for(var j = 0;j < self.laborHourArr.length;j++) {
                                                        if (self.laborHourArr[j].labor_index != undefined && self.laborHourArr[j].labor_index != null) {
                                                            if (self.laborHourArr[j].labor_index == i) {
                                                                if (self.laborHourArr[j].start_time != undefined && self.laborHourArr[j].start_time != null) {
                                                                    if (self.laborHourArr[j].start_time == "" || self.laborHourArr[j].start_time == "-") {
                                                                        startCnt++;
                                                                    }
                                                                }
                                                                if (self.laborHourArr[j].end_time != undefined && self.laborHourArr[j].end_time != null) {
                                                                    if (self.laborHourArr[j].end_time == "" || self.laborHourArr[j].end_time == "-") {
                                                                        endCnt++;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (startCnt > 0) {
                            self.timeLabel = 'Start Log Time';
                            self.taskArr[index].log_btn_title = 'Start Log Time';
                        }else{
                            if (startCnt < 1 && endCnt > 0) {
                                self.timeLabel = 'End Log Time';
                                self.taskArr[index].log_btn_title = 'End Log Time';
                            }
                        }
                    }
                }
                //disable in case of technician and service manager
                /*if (self.canAddLaborActivityLog && (self.role.toLowerCase() == "technician" || self.role.toLowerCase() == "service manager")) {
                    $("#serviceTaskLaborHour" + index).addClass("disable-field");
                }*/
                self.disableTechnicianField = false;


            } else if (flag == "serviceTaskComp") {
                var showComponent = 'addComponent' + index;
                self.componentArr = [];
                self.serviceTaskQty_error_msg = "";
                self.serviceTaskComp_error_msg = "";
            } else {
                var showComponent = 'addComment' + index;
            }
            if (self.taskArr != undefined) {

                $("#unit_id" + index + " .dropdown-toggle").removeClass('border-red');
                $("#component_category_id" + index + " .dropdown-toggle").removeClass('border-red');
                $("#taskid" + index + " .dropdown-toggle").removeClass('border-red');
                $("#billable_code" + index + " .dropdown-toggle").removeClass('border-red');
                $("#woistatus" + index + " .dropdown-toggle").removeClass('border-red');
                $("#woicomplaint" + index).removeClass('border-red');
                $("#woicause" + index).removeClass('border-red');
                $("#woicorrection" + index).removeClass('border-red');
                $("#vendorpo" + index+" .dropdown-toggle").removeClass('border-red');
                $("#vendorid" + index + " .dropdown-toggle").removeClass('border-red');
                $("#sublet_amount" + index).removeClass('border-red');
                //$("#po_number" + index).removeClass('border-red');
                $("#line_number" + index).removeClass('border-red');

                if (!self.assetRequired){
                    if (self.taskArr[index].unit_id == null || !self.taskArr[index].unit_id.value) {
                        $("#unit_id" + index + " .dropdown-toggle").addClass('border-red');
                        self.showActiveTaskLabor = showComponent;
                    }
                }
                if (self.taskArr[index].component_category_id == null || !self.taskArr[index].component_category_id.value) {
                    $("#component_category_id" + index + " .dropdown-toggle").addClass('border-red');
                    self.showActiveTaskLabor = showComponent;
                }
                if (self.taskArr[index].line_number == null || self.taskArr[index].line_number == '') {
                    $("#line_number" + index).addClass('border-red');
                    self.showActiveTaskLabor = showComponent;
                }
                if (self.taskArr[index].taskid == null || !self.taskArr[index].taskid.value) {
                    $("#taskid" + index + " .dropdown-toggle").addClass('border-red');
                    self.showActiveTaskLabor = showComponent;
                }

                if (self.taskArr[index].woistatus.value == "closed") {
                  if (self.taskArr[index].billable_code == null || !self.taskArr[index].billable_code.value) {
                      $("#billable_code" + index + " .dropdown-toggle").addClass('border-red');
                      self.showActiveTaskLabor = showComponent;
                  }
                }
                if (self.taskArr[index].woistatus == null || !self.taskArr[index].woistatus.value) {
                    $("#woistatus" + index + " .dropdown-toggle").addClass('border-red');
                    self.showActiveTaskLabor = showComponent;
                }
                if (self.taskArr[index].issublet == true) {
                    if (self.taskArr[index].purchaseorderid == null || !self.taskArr[index].purchaseorderid.value) {
                        if (self.taskArr[index].vendorid == null || !self.taskArr[index].vendorid.value) {
                            $("#vendorid" + index + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }
                    }
                    if (self.taskArr[index].sublet_amount == null || !self.taskArr[index].sublet_amount) {
                        $("#sublet_amount" + index).addClass('border-red');
                        error = true;
                    }

                }
                if(self.assetRequired && (self.taskArr[index].woistatus.value == 'closed' || self.taskArr[index].woistatus.value == 'review')){

                    if (self.taskArr[index].woicomplaint == "" || self.taskArr[index].woicomplaint == '') {
                        $("#woicomplaint" + index).addClass('border-red');
                        self.showActiveTaskLabor = showComponent;
                    }
                    if (self.taskArr[index].woicause == "" || self.taskArr[index].woicause == '') {
                        $("#woicause" + index).addClass('border-red');
                        self.showActiveTaskLabor = showComponent;
                    }
                    if (self.taskArr[index].woicorrection == "" || self.taskArr[index].woicorrection == '') {
                        $("#woicorrection" + index).addClass('border-red');
                        self.showActiveTaskLabor = showComponent;
                    }
                }

                if(self.taskArr[index].woistatus != null && self.taskArr[index].woistatus.value == 'closed'){
                    if ((self.taskArr[index].purchaseorderid == null || !self.taskArr[index].purchaseorderid.value) && self.taskArr[index].issublet == true) {
                        $("#vendorpo"+ index +" .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        if ((self.taskArr[index].billId == null || !self.taskArr[index].billId.value) && self.taskArr[index].issublet == true) {
                            alert('Purchase Order does not have vendor invoice');
                            error = true;
                        }else{
                            if (!self.assetRequired) {
                                if ((self.taskArr[index].bill_item_id == null || self.taskArr[index].bill_item_id == "") && self.taskArr[index].issublet == true) {
                                    alert('Vendor Invoice does not have work order line item');
                                    error = true;
                                }
                            }
                        }
                    }
                }
            }

            if (flag == 'labor'){
                //as per new changes
                self.serviceTaskLaborSubTotal = 0;
                self.serviceTaskLaborHour = '0';
                self.serviceTaskLaborHourRate = 0;
                self.serviceTaskLabor_error_msg = "";
                self.oldLaborUserId = 0;
                self.serviceTaskLaborHourRate_error_msg = "";

                self.labor_description = '';

                self.serviceTaskLaborIndex = 'create';
                self.serviceTaskLaborId = 0;
                self.serviceTaskLabor = null;
                if (self.serviceTaskLaborHourRate == null || self.serviceTaskLaborHourRate == '' || self.serviceTaskLaborHourRate == 0){
                    //as per new changes
                    var fromPriceBook = 0;
                    var laborRate = 0;
                    //Labor Cost Customer Wise
                    if ( self.laborCostArr.length) {

                        // var laborCost = self.arrayCostColumn(self.laborCostArr,"INT");
                        // var laborCostDef = self.arrayCostColumn(self.defaultLaborCostArr,"INT");

                        // if ( laborCostDef != undefined) {
                        //     laborRate = laborCostDef.rate;
                        // }

                        // if (laborCost != undefined) {
                        //     laborRate = laborCost.rate;
                        // }else{
                        //     if (laborCostDef != undefined) {
                        //         laborRate = laborCostDef.rate;
                        //     }else{
                        //         var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                        //         if (laborDefObj.rate_type != undefined && laborDefObj.rate_type == "H") {
                        //             laborRate = laborDefObj.rate;
                        //         }
                        //     }
                        // }

                        // if (self.customerPriceBookArr.length){

                        //     if (self.taskArr[index].issublet){
                        //         var laborObj = self.arrayColumn(self.customerPriceBookArr,'X');
                        //     }else{
                        //         var laborObj = self.arrayColumn(self.customerPriceBookArr,'L');
                        //     }
                        //     var laborAmount = 0;
                        //     if (laborObj != undefined && (laborObj.rate_type == 'L' || laborObj.rate_type == 'M' || laborObj.rate_type == 'G')){
                        //         if (laborObj.rate_type == 'L') {
                        //             var laborAmount = laborRate + (laborRate * laborObj.rate / 100);
                        //         }else if (laborObj.rate_type == 'M') {
                        //             //Mark Up
                        //             var laborAmount = self.calculateMarginMarkup(laborRate,laborObj.rate,'M');
                        //         }else if (laborObj.rate_type == 'G') {
                        //             //Margin
                        //             var laborAmount = self.calculateMarginMarkup(laborRate,laborObj.rate,'G');
                        //         }
                        //     }else{
                        //         //Rate Type L not found in Customer Price Book
                        //         var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                        //         var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');

                        //         if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                        //             var laborAmount = self.calculateMarginMarkup(laborRate,laborMarginDefObj.rate,'G');
                        //         }
                        //         if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                        //             var laborAmount = self.calculateMarginMarkup(laborRate,laborMarkUpDefObj.rate,'M');
                        //         }
                        //     }
                        //     if (laborAmount == 0) {
                        //         laborAmount = laborRate;
                        //     }
                        //     setTimeout(function(){
                        //         if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                        //             self.serviceTaskLaborHourRate = laborAmount;
                        //         }else{
                        //             var laborCost = self.arrayCostColumn(self.defaultLaborCostArr,"INT");
                        //             if (laborCost != undefined) {
                        //                 self.serviceTaskLaborHourRate = laborCost.rate;
                        //             }else{
                        //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                        //                 if (laborDefObj.rate_type != undefined && laborDefObj.rate_type == "H") {
                        //                     self.serviceTaskLaborHourRate = laborDefObj.rate;
                        //                 }
                        //             }
                        //         }
                        //     },500);

                        // }else{

                        //     if (self.taskArr[index].issublet){
                        //         var laborObj = self.arrayColumn(self.defaultPriceBookArr,'X');
                        //     }else{
                        //         var laborObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                        //     }

                        //     var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                        //     var laborAmount = 0;
                        //     //as per new changes
                        //     var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                        //     var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');
                        //     if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                        //         laborAmount = self.calculateMarginMarkup(laborRate,laborMarginDefObj.rate,'G');
                        //     }
                        //     if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                        //         laborAmount = self.calculateMarginMarkup(laborRate,laborMarkUpDefObj.rate,'M');
                        //     }
                        //     if (laborAmount == 0) {
                        //         laborAmount = laborRate;
                        //     }
                        //     setTimeout(function(){
                        //         if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                        //             self.serviceTaskLaborHourRate = laborAmount;
                        //         }else{
                        //             var laborCost = self.arrayCostColumn(self.defaultLaborCostArr,"INT");
                        //             if (laborCost != undefined) {
                        //                 self.serviceTaskLaborHourRate = laborCost.rate;
                        //             }else{
                        //                 if (laborDefObj.rate_type != undefined && laborDefObj.rate_type == "H") {
                        //                     self.serviceTaskLaborHourRate = laborDefObj.rate;
                        //                 }
                        //             }
                        //         }
                        //     },500);
                        // }

                    } else {
                        //Labor Cost Location Wise
                        var laborCostDef = self.arrayCostColumn(self.defaultLaborCostArr,"INT");
                        if ( laborCostDef != undefined ) {

                            laborRate = laborCostDef.rate;
                            self.serviceTaskLaborHourRate = laborRate;

                            // if (self.customerPriceBookArr.length){

                            //     if (self.taskArr[index].issublet){
                            //         var laborObj = self.arrayColumn(self.customerPriceBookArr,'X');
                            //     }else{
                            //         var laborObj = self.arrayColumn(self.customerPriceBookArr,'L');
                            //     }
                            //     var laborAmount = 0;
                            //     if (laborObj != undefined && (laborObj.rate_type == 'L' || laborObj.rate_type == 'M' || laborObj.rate_type == 'G')){
                            //         if (laborObj.rate_type == 'L') {
                            //             var laborAmount = laborRate + (laborRate * laborObj.rate / 100);
                            //         }else if (laborObj.rate_type == 'M') {
                            //             //Mark Up
                            //             var laborAmount = self.calculateMarginMarkup(laborRate,laborObj.rate,'M');
                            //         }else if (laborObj.rate_type == 'G') {
                            //             //Margin
                            //             var laborAmount = self.calculateMarginMarkup(laborRate,laborObj.rate,'G');
                            //         }
                            //     }else{
                            //         //Rate Type L not found in Customer Price Book
                            //         var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                            //         var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');

                            //         if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                            //             var laborAmount = self.calculateMarginMarkup(laborRate,laborMarginDefObj.rate,'G');
                            //         }
                            //         if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                            //             var laborAmount = self.calculateMarginMarkup(laborRate,laborMarkUpDefObj.rate,'M');
                            //         }
                            //     }
                            //     if (laborAmount == 0) {
                            //         laborAmount = laborRate;
                            //     }
                            //     setTimeout(function(){
                            //         if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                            //             self.serviceTaskLaborHourRate = laborAmount;
                            //         }else{
                            //             var laborCost = self.arrayCostColumn(self.defaultLaborCostArr,"INT");
                            //             if (laborCost != undefined) {
                            //                 self.serviceTaskLaborHourRate = laborCost.rate;
                            //             }else{
                            //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                            //                 if (laborDefObj.rate_type != undefined && laborDefObj.rate_type == "H") {
                            //                     self.serviceTaskLaborHourRate = laborDefObj.rate;
                            //                 }
                            //             }
                            //         }
                            //     },500);

                            // }else{

                            //     if (self.taskArr[index].issublet){
                            //         var laborObj = self.arrayColumn(self.defaultPriceBookArr,'X');
                            //     }else{
                            //         var laborObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                            //     }
                            //     var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                            //     var laborAmount = 0;
                            //     //as per new changes
                            //     var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                            //     var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');
                            //     if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                            //         laborAmount = self.calculateMarginMarkup(laborRate,laborMarginDefObj.rate,'G');
                            //     }
                            //     if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                            //         laborAmount = self.calculateMarginMarkup(laborRate,laborMarkUpDefObj.rate,'M');
                            //     }
                            //     if (laborAmount == 0) {
                            //         laborAmount = laborRate;
                            //     }

                            //     setTimeout(function(){
                            //         if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                            //             self.serviceTaskLaborHourRate = laborAmount;
                            //         }else{
                            //             var laborCost = self.arrayCostColumn(self.defaultLaborCostArr,"INT");
                            //             if (laborCost != undefined) {
                            //                 self.serviceTaskLaborHourRate = laborCost.rate;
                            //             }else{
                            //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                            //                 if (laborDefObj.rate_type != undefined && laborDefObj.rate_type == "H") {
                            //                     self.serviceTaskLaborHourRate = laborDefObj.rate;
                            //                 }
                            //             }
                            //         }
                            //     },500);
                            // }
                        }else{
                            fromPriceBook = 1;
                        }
                    }

                    // if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                    //     fromPriceBook = 1;
                    // }
                    //Price Book Configuration
                    // if (fromPriceBook == 1) {

                    //     if (self.customerPriceBookArr.length){
                    //         if (self.taskArr[index].issublet){
                    //             var laborObj = self.arrayColumn(self.customerPriceBookArr,'X');
                    //         }else{
                    //             var laborObj = self.arrayColumn(self.customerPriceBookArr,'L');
                    //         }
                    //         if (laborObj != undefined && laborObj.rate_type == 'H'){
                    //             setTimeout(function(){
                    //                 self.serviceTaskLaborHourRate = laborObj.rate;
                    //             },500);
                    //         }else if (laborObj != undefined && (laborObj.rate_type == 'L' || laborObj.rate_type == 'M' || laborObj.rate_type == 'G')){
                    //             // var laborObj = self.arrayColumn(self.customerPriceBookArr,'L');
                    //             if (self.taskArr[index].issublet){
                    //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'X');
                    //             }else{
                    //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                    //             }
                    //             if (laborDefObj != undefined && laborDefObj.rate_type == 'H'){
                    //                 if (laborObj.rate_type == 'L') {
                    //                     var laborAmount = laborDefObj.rate + (laborDefObj.rate * laborObj.rate / 100);
                    //                 }else if (laborObj.rate_type == 'M') {
                    //                     //Mark Up
                    //                     var laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborObj.rate,'M');
                    //                 }else if (laborObj.rate_type == 'G') {
                    //                     //Margin
                    //                     var laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborObj.rate,'G');
                    //                 }

                    //                 setTimeout(function(){
                    //                     if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                    //                         self.serviceTaskLaborHourRate = laborAmount;
                    //                     }else{
                    //                         self.serviceTaskLaborHourRate = laborDefObj.rate;
                    //                     }
                    //                 },500);
                    //             }
                    //         }else{
                    //             //if labor rate not found in customer price book
                    //             if (self.taskArr[index].issublet){
                    //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'X');
                    //                 //as per new changes
                    //                 if (laborDefObj != undefined && laborDefObj.rate_type == 'H'){
                    //                     var laborAmount = laborDefObj.rate;
                    //                     setTimeout(function(){
                    //                         self.serviceTaskLaborHourRate = laborAmount;
                    //                     },500);
                    //                 }
                    //             } else {
                    //                 var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                    //                 //as per new changes
                    //                 var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                    //                 var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');
                    //                 if (laborDefObj != undefined && laborDefObj.rate_type == 'H'){
                    //                     var laborAmount = laborDefObj.rate;
                    //                     if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                    //                         laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborMarginDefObj.rate,'G');
                    //                     }
                    //                     if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                    //                         laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborMarkUpDefObj.rate,'M');
                    //                     }
                    //                     setTimeout(function(){
                    //                         if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                    //                             self.serviceTaskLaborHourRate = laborAmount;
                    //                         }else{
                    //                             self.serviceTaskLaborHourRate = laborDefObj.rate;
                    //                         }
                    //                     },500);
                    //                 }
                    //             }
                    //         }
                    //         // var key = self.customerPriceBookArr.find('L',self.arrayColumn(self.customerPriceBookArr,'cost_type'));
                    //     }else{
                    //         if (self.taskArr[index].issublet){
                    //             var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'X');
                    //             if (laborDefObj != undefined && laborDefObj.rate_type == 'H'){
                    //                 var laborAmount = laborDefObj.rate;
                    //                 setTimeout(function(){
                    //                     self.serviceTaskLaborHourRate = laborAmount;
                    //                 },500);
                    //             }
                    //         }else{
                    //             var laborDefObj = self.arrayColumn(self.defaultPriceBookArr,'L');
                    //             //as per new changes
                    //             var laborMarginDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','G');
                    //             var laborMarkUpDefObj = self.arrayCostRateColumn(self.defaultPriceBookArr,'L','M');
                    //             if (laborDefObj != undefined && laborDefObj.rate_type == 'H'){
                    //                 var laborAmount = laborDefObj.rate;
                    //                 if (laborMarginDefObj != undefined && laborMarginDefObj.rate_type == 'G'){//Margin
                    //                     laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborMarginDefObj.rate,'G');
                    //                 }
                    //                 if (laborMarkUpDefObj != undefined && laborMarkUpDefObj.rate_type == 'M'){//Mark Up
                    //                     laborAmount = self.calculateMarginMarkup(laborDefObj.rate,laborMarkUpDefObj.rate,'M');
                    //                 }
                    //                 setTimeout(function(){
                    //                     if (self.taskArr[index].billable_code != null && self.taskArr[index].billable_code.value == 'B'){
                    //                         self.serviceTaskLaborHourRate = laborAmount;
                    //                     }else{
                    //                         self.serviceTaskLaborHourRate = laborDefObj.rate;
                    //                     }
                    //                 },500);
                    //             }
                    //         }
                    //     }
                    // }

                    self.calculateSubTotalForLabor();
                }
            }
        },
        //remove work order line item task, labor or component
        removeWorkOrderLineItem(flag, params, index) {

            var self = this;
            if (flag == 'task'){
                if (self.taskArr[index].program_id != null && self.taskArr[index].program_id.value){
                    self.$swal({
                        title: "Reschedule the program?",
                        text: "Program will be removed from every line item",
                        type: "warning",
                        confirmButtonText: "Yes",
                        cancelButtonText: "Skip",
                        showCloseButton: true,
                        showLoaderOnConfirm: false,
                        showCancelButton:true,
                        allowOutsideClick:false
                    }).then(result => {
                        if (result.value) {
                            self.removeLineItemAfterConfirm(flag, params, index,'reset')
                        } else if (result.dismiss == 'cancel') {
                            self.removeLineItemAfterConfirm(flag, params, index,'skip')
                        }else if(result.dismiss == 'close'){
                            return;
                        }
                    });
                }else{
                    var confirmMsg = 'Are you sure that you want to remove this line? ';
                    //check whether line item added in vendor invoice or not for current work order line item
                    if (self.work_order_type.value && self.work_order_type.value == 'multi unit'){
                        if (self.taskArr[index].bill_item_id != undefined) {
                            if (self.taskArr[index].bill_item_id != null && self.taskArr[index].bill_item_id != "") {
                                confirmMsg = "Vendor Invoice Item will be removed for this work order item.Are you sure that you want to remove this line? ";
                            }else{
                                confirmMsg = "Purchase Order Item will be removed for this work order item.Are you sure that you want to remove this line? ";
                            }
                        }
                    }
                    if (confirm(confirmMsg)) {
                        self.removeLineItemAfterConfirm(flag, params, index,'')
                    }
                }
            }else if (flag == "labor") {
                //display warning on remove labor with logs
                if (self.laborArr[index] != undefined && self.laborArr[index] != null) {
                    var laborId = self.laborArr[index].lid;
                    if (laborId != undefined && laborId != null) {
                        var laborLogFound = 0;
                        for(var i = 0;i < self.laborHourArr.length;i++) {
                            if (self.laborHourArr[i] != undefined && self.laborHourArr[i] != null) {
                                if (self.laborHourArr[i].labor_id != undefined && self.laborHourArr[i].labor_id != null) {
                                    if (self.laborHourArr[i].labor_id == laborId) {
                                        laborLogFound = 1;
                                    }
                                }
                            }
                        }
                        if (laborLogFound == 1) {
                            var confirmMessage = "All technician logs can be deleted with this operation, are you sure you want to delete this labor line item?";
                            if (confirm(confirmMessage)) {
                                self.removeLineItemAfterConfirm(flag, params, index,'')
                            }
                        }else{
                            if (confirm('Are you sure that you want to remove this line? ')) {
                                self.removeLineItemAfterConfirm(flag, params, index,'')
                            }
                        }
                    }
                }else{
                    if (confirm('Are you sure that you want to remove this line? ')) {
                        self.removeLineItemAfterConfirm(flag, params, index,'')
                    }
                }
            }else{
                if (confirm('Are you sure that you want to remove this line? ')) {
                    self.removeLineItemAfterConfirm(flag, params, index,'')
                }
            }

        },
        removeLineItemAfterConfirm(flag, params, index,prFlag) {
            var self = this;
            //current Duration of LaborTime Log

            var currentDuration = 0;
            if (flag == "log") {
                currentDuration = self.laborHourArr[index].duration_decimal;
            }
            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/workorder/remove-work-order-line-item",
                type: "POST",
                data: {
                    'flag': flag,
                    'params': params,
                    pr_flag:prFlag
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    if (data.status == "success") {
                        //labor time log remove
                        if (flag == "log") {
                            //get time difference
                            if (self.serviceTaskLaborHour != 0) {
                                var difference = self.serviceTaskLaborHour - currentDuration;
                                self.serviceTaskLaborHour = difference.toFixed(2);
                            }else{
                                self.serviceTaskLaborHour = 0;
                            }
                        }
                        self.loadWorkOrder();
                    }else if(data.status == "work_order_deleted"){
                      self.BackWorkOrderList();
                    }else{
                        self.loading = false;
                        if (data.code == 201) {
                            if (data.message && data.message != "") {
                                self.$swal('',data.message,'info');
                            }
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'remove-wo-line-item');
                },
            });

        },
        //service task labor hour input
        serviceTaskLaborHourInput(serviceTaskLabor, task, taskIndex) {
            var self = this;

            if (self.serviceTaskLaborHour != "") {

                if (self.validateTime(self.serviceTaskLaborHour)) {

                    if (self.laborHourArr.length < 1) {

                        self.laborHourArr = [];
                        self.laborHourArr.push({
                            timelog_id: 0,
                            labor_id: self.serviceTaskLaborId,
                            start_time: '-',
                            end_time: '-',
                            duration: self.serviceTaskLaborHour
                        });
                    } else {

                        // if(self.laborHourArr[0].start_time != '-'){
                        //push element at 0 index
                        self.laborHourArr.splice(0, 0, {
                            timelog_id: 0,
                            labor_id: self.serviceTaskLaborId,
                            start_time: '-',
                            end_time: '-',
                            duration: self.serviceTaskLaborHour
                        });
                        // }
                    }
                } else {

                    self.laborHourArr.splice(0, 1);
                }
            }

        },
        //validate time
        validateTime(value) {

            var timeValue = value;
            if (timeValue == "" || timeValue.indexOf(":") < 0) {
                return false;
            } else {
                var sHours = timeValue.split(':')[0];
                var sMinutes = timeValue.split(':')[1];

                if(sHours == "" || isNaN(sHours) || sHours.length < 2 )
                {
                    return false;
                }

                if (sMinutes == "" || isNaN(sMinutes) || parseInt(sMinutes) > 59 || sMinutes.length < 2 || sMinutes.length > 2) {
                    // alert("Invalid Time format minutes");
                    return false;
                }

                value = sHours + ":" + sMinutes;
            }
            return true;
        },
        toSeconds(time_str) {
            // Extract hours, minutes and seconds
            var time=time_str.toString();

            if(time.indexOf(':') != -1)
            {
                var parts = time.split(':');
            }else if(time.indexOf('.') != -1){
                var parts = time.split('.');
                parts[1]="0."+parts[1]*60;
            }else{
                var parts = time;
            }

            // compute  and return total seconds
            return parseInt(parts[0]) * 3600 + // an hour has 3600 seconds
                parseInt(parts[1]) * 60; // a minute has 60 seconds
        },

        getDifference(time1, time2, flag) {
            var self = this;
            var t1 = time1;
            var t2 = time2;

            if (flag == "add") {
                var difference = Math.abs(self.toSeconds(t1) + self.toSeconds(t2));
            } else if (flag == "diff") {
                var difference = Math.abs(self.toSeconds(t1) - self.toSeconds(t2));
            }

            var result = [
                Math.floor(difference / 3600), // an hour has 3600 seconds
                Math.floor((difference % 3600) / 60) // a minute has 60 seconds
            ];

            // 0 padding and concatation
            result = result.map(function (v) {
                return v < 10 ? '0' + v : v;
            }).join(':');

            return result;
        },
        getTotalTime(logTimeArr) {
            // var self = this;
            // var totalTime = 0;

            // for (var i = 0; i < logTimeArr.length; i++) {
            //     totalTime += self.toSeconds(logTimeArr[i]);
            // }

            // var result = [
            //     Math.floor(totalTime / 3600), // an hour has 3600 seconds
            //     Math.floor((totalTime % 3600) / 60) // a minute has 60 seconds
            // ];
            // // 0 padding and concatation
            // result = result.map(function (v) {
            //     return v < 10 ? '0' + v : v;
            // }).join(':');
            // return result;
            var self = this;
            var totalTime = 0;

            for (var i = 0; i < logTimeArr.length; i++) {
                totalTime += self.toSeconds(logTimeArr[i]);
            }

            var result = [
                Math.floor(totalTime / 3600), // an hour has 3600 seconds
                Math.floor((totalTime % 3600) / 60) // a minute has 60 seconds
            ];

            //converting minutes into 0.5 formate like minuts is 30 so ve consider 0.5 minutes
            result[1]=result[1]/60;

            var time=result[0]+result[1];
            return time;
        },

        getPurchaseOrderDetail(po_id) {
            var self = this;

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/customer-purchase-order/" + po_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.open_date = data.content.order_date;
                        //self.poInputId = {text:data.content.po_no+' | '+data.content.formattedtotal,value:data.content.id};
                        self.customerPoNo = data.content.customer_po_no;
                        self.wonotes = data.content.notes;

                        if (data.content.assigned_loc_id == null) {
                            self.location_id = null;
                        } else {
                            self.location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code + ")")
                            };
                        }

                        if ((data.content.cust_id) != null) {
                            var name = (data.content.cust_name != null) ? data.content.cust_name : "";
                            var code = (data.content.cust_code != null) ? data.content.cust_code : "";

                            self.customer_id = {
                                value: data.content.cust_id,
                                text: self.titleCase(name + " (" + code + ")")
                            };
                        } else {
                            self.customer_id = null;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-customer-po-detail');
                }
            });

        },

        getVendorEstimateDetail() {
            var self = this;
            self.loading = true;

            var path = window.location.pathname;
            var segments = path.split("/");

            $.ajax({
                url: process.env.ROOT_API + "/get-vendor-estimate-items/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                    work_order_id: segments[3]
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if (data.content.item != undefined) {
                            // self.serviceTaskArr = []

                            for (var i = 0; i < data.content.item.length; i++) {
                                var task = {};
                                task['partsamount'] = data.content.item[i].component_amount;
                                task['vendorlaboramount'] = data.content.item[i].labor_amount;

                                console.info('amount', task);
                                self.estimateArr.push(task);
                            }
                        }
                        console.info('this task arr...', self.taskArr);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-vendor-estimate-items');
                }
            });

        },
        getCustomerEstimateItemDetail() {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            $.ajax({
                url: process.env.ROOT_API + "/get-customer-estimate-items",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    work_order_id: segments[3],
                },
                success: function (data) {

                    if (data.code == 200) {

                        if (data.content.item != undefined) {

                            for (var i = 0; i < data.content.item.length; i++) {
                                var task = {};
                                task['custestpartamount'] = data.content.item[i].component_amount;
                                task['custestlaboramount'] = data.content.item[i].labor_amount;

                                console.info('amount', task);
                                self.custestimateArr.push(task);
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-items');
                }
            });
        },
        callCreateWorkOrderItemAPI(fields, segments, flag,oos) {
            var self = this;

            if ( self.requestInProgress == true ) {
                return;
            }
            self.requestInProgress = true;

            $.ajax({
                url: process.env.ROOT_API + "/workorder-items/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.requestInProgress = false;
                    // remove localStorage value
                    localStorage.removeItem('newAsset');
                    localStorage.removeItem('newCustomer');

                    if (segments[3]) {
                        $("#createWorkOrderBtn").val("Update");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled", false);
                    } else {
                        $("#createAndContinueWorkOrderBtn").val("Save");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled", false);
                    }

                    if (data.code == 201) {
                        if (data.status == 'quantity_not_available'){

                        }else{
                            self.$swal('',data.message,'info');

                        }
                        if (self.compArr.length != undefined && data.status != 'un_issued_part'){
                            self.showActiveTaskLabor = 'addComponent'+self.activeLineItemIdx;
                            var ind = self.compArr.length - 1;
                            self.serviceTaskComp = self.compArr[ind].compid;
                            self.serviceTaskCompCost = self.compArr[ind].compcost;
                            self.serviceTaskCompQuantity = self.compArr[ind].compquantity;
                            if (data.status == 'quantity_not_available'){
                                self.serviceTaskQty_error_msg = data.content;
                            }
                            self.serviceTaskCompSubTotal = self.compArr[ind].compsubtotal;

                            self.comp_description = self.compArr[ind].compdescription;
                            self.wr_location = self.compArr[ind].wr_location;

                            //to edit service task labor...
                            self.serviceTaskCompId = self.compArr[ind].cid;
                            self.serviceTaskEstimateCompId = self.compArr[ind].estimatedcid;
                            self.serviceTaskIssued = self.compArr[ind].is_issued
                            self.serviceTaskCompIndex = 'create';

                            self.compArr.splice(ind,1);
                        }

                        return;
                    }

                    if (data.status == "success") {

                        $("#select-date").modal("hide");
                        if(data.code == 201) {
                          self.$swal('',data.message,'info');
                        } else {
                          //sub system closed message
                          if (data.content.sub_system != undefined) {
                              if (data.content.sub_system.length > 0) {
                                  self.$swal('',"Subsystem A/P BATCH POST has been closed.",'info');
                              }
                          }

                          if(flag == 'loadAfterSave'){

                              self.workOrderItemData('loadAfterSave');

                          }else{

                              self.workOrderItemData('');
                          }
                          if (flag == 'final') {

                              //if work order add then redirect to view else to list page
                              if (self.$route.params.id != undefined && self.$route.params.id != null) {
                                self.loadWorkOrder();
                                //in case of update work order line item remain on same page
                                self.$swal('','Work Order Details Updated Successfully.','success');
                              }else{
                                var urlPath = self.$route.path;
                                if(self.fromUrl != "" && self.fromUrl != undefined){
                                    self.redirectPageUrl(self.fromUrl);
                                }else if (urlPath != undefined && urlPath != null) {
                                    if (urlPath.indexOf("create") !== -1) {

                                        self.$router.push("/workorder/view/"+data.content.id);
                                    }else{
                                        self.$router.push("/workorder/list");
                                    }
                                }else{
                                    self.$router.push("/workorder/view/"+data.content.id);
                                }
                              }
                          }
                        }

                    } else {

                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.requestInProgress = false;
                    self.loading = false;
                    if (segments[3]) {
                        $("#createWorkOrderBtn").val("Update");
                        $("#createWorkOrderBtn").prop("disabled", false);
                        $("#cancelWorkOrderBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#WorkOrderForm").trigger("reset");

                            $("#createAndContinueWorkOrderBtn").val("Save and Continue");
                            $("#createWorkOrderBtn").prop("disabled", false);
                            $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                            $("#cancelWorkOrderBtn").prop("disabled", false);

                        } else {

                            $("#createWorkOrderBtn").val("Save");
                            $("#createWorkOrderBtn").prop("disabled", false);
                            $("#createAndContinueWorkOrderBtn").prop("disabled", false);
                            $("#cancelWorkOrderBtn").prop("disabled", false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR, true, 'create-workorder-itmes');
                }
            });

        },
        amountFormat(amount) {
            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },

        //for program related changes so commented above method
        selectMaintenance: function(main,evt,from){
            var self = this;

            if (from == 'warranty'){
                if(evt.target.checked == true){

                    self.warArr.push({id:main.warranty_id});

                }else{

                    var i = self.warArr.indexOf(main.warranty_id);
                    const filteredItems = self.warArr.filter(function(item) {
                        return item.id !== main.warranty_id
                    })
                    self.warArr = filteredItems;
                }
            }else{
                if(evt.target.checked == true){

                    self.mainArr.push({id:main.program_id});

                }else{

                    var i = self.mainArr.indexOf(main.program_id);
                    const filteredItems = self.mainArr.filter(function(item) {
                        return item.id !== main.program_id
                    })
                    self.mainArr = filteredItems;
                }
            }

        },

        isMiscellaneous: function(e) {
            var self = this;

            self.disableCustField = false;
            self.miles_error_msg = "";

            if(e.target.checked) {

                self.showMiscellaneousFields = true;
                self.is_miscellaneous = true;
                self.customer_id = {text:"001-00000000-000 | MISCELLANEOUS | Existing",value:0,stage:"existing"};
                self.vehicle_id = null;
                self.schedule_maintenance_id = null;
                self.vehicle_error_msg = "";
                self.customer_error_msg = "";
                self.customerPoNo = "";

            } else {

                self.showMiscellaneousFields = false;
                self.is_miscellaneous = false;
                self.customer_id = null;
                self.customer_email = "";
                self.customer_vin_number = "";
                self.customer_unit_no = "";
                self.customer_email_error_msg = "";
                self.customer_vin_number_error_msg = "";
                self.customer_unit_no_error_msg = "";
            }
        },
        checkWoAmount(){
            var self = this;
            var totalLineitem=0;
            totalLineitem=self.taskArr.length;
            var statuscount=0;

            for(var i=0; i < self.taskArr.length;i++){
                if (self.taskArr[i] != undefined) {
                    if (self.taskArr[i] != null) {
                        if (self.taskArr[i].woistatus != null && self.taskArr[i].woistatus != "") {
                            if((self.taskArr[i].woistatus.value=='closed' || self.taskArr[i].woistatus.value=='review') ){
                                statuscount++;
                            }
                        }
                    }
                }
            }
          if (totalLineitem > 0 && !self.is_miscellaneous && self.assetRequired && self.displayLineItem) {
            if (statuscount == totalLineitem) {
              // self.sectionArr

              if (self.sectionArr.length) {
                self.addMiles = false;
                var showSideBar = false
                for (var j = 0; j < self.sectionArr.length; j++) {
                  if (self.sectionArr[j].reading < 0 || self.sectionArr[j].reading == '' || self.sectionArr[j].reading == null) {
                    if (self.sectionArr[j].read_on_wo == "mandatory") {
                      $("#wo-detail-section").animate({
                        right: "0",
                      }, 300);
                      setTimeout(function () {
                        $('#woMiles' + j).focus();
                      }, 400);
                      //to enable input for enter reading
                      self.addMiles = true;
                      return 1;
                    }
                  }
                }
              }
            }
          }
            return 0;

        },
        statusChange(evt,index){

            var self = this;
            var error = false;
            self.checkWoAmount();
            if ( self.assetRequired && ( self.taskArr[index] && (self.taskArr[index].woistatus.value == 'closed' || self.taskArr[index].woistatus.value == 'review'))){

                if (self.taskArr[index].woicomplaint == "" || self.taskArr[index].woicomplaint == '') {
                $("#woicomplaint" + index).addClass('border-red');
                }
                if (self.taskArr[index].woicause == "" || self.taskArr[index].woicause == '') {
                    $("#woicause" + index).addClass('border-red');
                }
                if (self.taskArr[index].woicorrection == "" || self.taskArr[index].woicorrection == '') {
                    $("#woicorrection" + index).addClass('border-red');
                }

            }

            if(self.taskArr[index].woistatus != null && self.taskArr[index].woistatus.value == 'closed'){
                if ((self.taskArr[index].purchaseorderid == null || !self.taskArr[index].purchaseorderid.value) && self.taskArr[index].issublet == true) {
                    $("#vendorpo"+ index +" .dropdown-toggle").addClass('border-red');
                    error = true;
                }else{
                    if ((self.taskArr[index].billId == null || !self.taskArr[index].billId.value) && self.taskArr[index].issublet == true) {
                        alert('Purchase Order does not have vendor invoice');
                        error = true;
                    }else{
                        if (!self.assetRequired) {
                            if ((self.taskArr[index].bill_item_id == null || self.taskArr[index].bill_item_id == "") && self.taskArr[index].issublet == true) {
                                alert('Vendor Invoice does not have work order line item');
                                error = true;
                            }
                        }
                    }
                }
            }
        },
        redirectToItem: function(){
            var self = this;
            self.displaySchedule = false;
            self.displayLineItem = true;
            self.itemClass = 'undefined';
            self.loadWorkOrder();
            $("#myModal").modal('hide');
        },
        editWODetails: function() {
            var self = this;
            self.displaySchedule = false;
            self.displayLineItem = false;
            self.itemClass = '';
        },

        changeBillableCode:function(evt,index){
            var self = this;
            if (self.taskArr[index].billable_code != undefined && self.taskArr[index].billable_code != null && self.taskArr[index].billable_code != "") {
                if (self.taskArr[index].billable_code.value != undefined && self.taskArr[index].billable_code.value != null && self.taskArr[index].billable_code.value == "B") {
                    if (self.billable_charges == 0) {
                        //self.getPriceBookValue();
                    }
                }
            }

            self.billableCodeChange(index);//for special po item
        },
        onSearchVMRS(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'vmrs', '');
            }
        },
        selectVendorPo:function(val,index){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (val != null) {
                self.taskArr[index].sublet_amount = val.amount;
                self.taskArr[index].vendorid = {
                    text:val.vendor,
                    value:val.vendor_id
                };
                if (val.po_number != undefined){
                    self.taskArr[index].po_number = val.po_number;
                }
            }else{
                self.taskArr[index].sublet_amount = 0;
                self.taskArr[index].vendorid = null;
                return;
            }
            var cust = 0;
            if(self.customer_id != null && self.customer_id.value){
                cust = self.customer_id.value;
            }
            var billableCode = "";
            if (self.taskArr[index].billable_code != undefined) {
                if (self.taskArr[index].billable_code != null) {
                    if (self.taskArr[index].billable_code.value && self.taskArr[index].billable_code.value != null) {
                        billableCode = self.taskArr[index].billable_code.value;
                    }
                }
            }

            $.ajax({
                url: process.env.ROOT_API + "/get-vendor-invoice-items",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    id: val.value,
                    customer_id:cust,
                    type:billableCode
                },
                success: function (data) {

                    if (data.code == 200) {
                        if (data.content.bill_id != undefined){
                            self.taskArr[index].billId = JSON.parse(data.content.bill_id);
                        }else{
                            self.taskArr[index].billId = null;
                        }

                        if (data.content.items != undefined) {
                            var itemData = data.content.items;
                            var removeCompArr = []
                            //remove old item if vendor invoice changed
                            for (var j = 0; j < self.compArr.length; j++) {

                                if (self.compArr[j].service_task_id != null) {

                                    if (self.compArr[j].service_task_id.index == index) {
                                        removeCompArr.push(j);
                                    }
                                }
                            }

                            for (var i = removeCompArr.length - 1; i >= 0; i--) {

                                self.compArr.splice(removeCompArr[i], 1);

                            }
                            for(var i =0; i < itemData.length;i++){
                                self.compArr.push({
                                    cid: 0,
                                    compid: JSON.parse(itemData[i].item),
                                    service_task_id: {
                                        value: self.taskArr[index].taskid.value,
                                        text: self.taskArr[index].taskid.text,
                                        index: index
                                    },
                                    compcost: itemData[i].price,
                                    compquantity: itemData[i].qty,
                                    compsubtotal: itemData[i].total,
                                    compdescription: itemData[i].description,
                                    oldquantity: itemData[i].qty,
                                    is_issued:itemData[i].is_issued
                                });
                            }
                        }
                        if (data.content.labor != undefined) {
                            var laborData = data.content.labor;
                            var removelaborArr = [];
                            //remove old item if vendor invoice changed
                            for (var j = 0; j < self.laborArr.length; j++) {

                                if (self.laborArr[j].service_task_id != null) {

                                    if (self.laborArr[j].service_task_id.index == index) {
                                        removelaborArr.push(j);
                                    }
                                }
                            }

                            for (var i = removelaborArr.length - 1; i >= 0; i--) {

                                self.laborArr.splice(removelaborArr[i], 1);

                            }

                            for(var i =0; i < laborData.length;i++){
                                self.taskArr[index].hasLabor = true;
                                self.laborArr.push({
                                    lid: 0,
                                    laborid: null,
                                    service_task_id: {value: self.taskArr[index].taskid.value, text:self.taskArr[index].taskid.text, index: index},
                                    laborhours: laborData[i].qty,
                                    laborhourrate: laborData[i].price,
                                    laborsubtotal: laborData[i].total,
                                    labordescription: laborData[i].description
                                });
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-customer-estimate-items');
                }
            });
        },
        onSubletSelect(index,evt) {
            var self = this;
            var laborFound = 0;
            var partFound = 0;
            if(self.taskArr[index].issublet == true){
                self.taskArr[index].po_error_msg = '';
            }
            if (self.taskArr[index] != undefined) {
                if (self.taskArr[index].issublet != undefined) {
                    if (!self.taskArr[index].issublet) {
                        //reset value of special order items
                        self.uncheckSpItem(index);
                        self.taskArr[index].selectedSpItemsArr = [];
                        self.taskArr[index].isItemModal = 0;
                        for (var i = 0; i < self.laborArr.length;i++) {
                            if (self.laborArr[i].service_task_id != undefined) {
                                if (self.laborArr[i].service_task_id.index != undefined) {
                                    if (self.laborArr[i].service_task_id.index == index) {
                                        laborFound = 1;
                                    }
                                }
                            }
                        }

                        for (var i = 0; i < self.compArr.length;i++) {
                            if (self.compArr[i].service_task_id != undefined) {
                                if (self.compArr[i].service_task_id.index != undefined) {
                                    if (self.compArr[i].service_task_id.index == index) {
                                        partFound = 1;
                                    }
                                }
                            }
                        }

                        var message = "";
                        if (laborFound == 1 && partFound == 0) {
                            message = "Labor of Current Line Item will be removed on Update.";
                        }
                        if (partFound == 1 && laborFound == 0) {
                            message = "Part of Current Line Item will be removed on Update.";
                        }
                        if (partFound == 1 && laborFound == 1) {
                            message = "Labor and Part of Current Line Item will be removed on Update.";
                        }

                        if (message != "" && (laborFound == 1 || partFound == 1)) {
                            // self.$swal('',message,'info');
                            if (self.taskArr[index].woiId != undefined) {
                                if (self.taskArr[index].woiId != null) {
                                    self.laborComponentRemove(self.taskArr[index].woiId,message,index);
                                }
                            }
                        }
                    }else{
                        $("#vendorid" + index + " .dropdown-toggle").removeClass('border-red');
                        $("#sublet_amount" + index).removeClass('border-red');
                    }
                }
            }
        },
        saveMiles(){
            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");
            var error=false;
            if (self.sectionArr.length){
                for(var k = 0; k < self.sectionArr.length; k++ ){
                  if (self.sectionArr[k].read_on_wo == "mandatory") {
                    if (self.sectionArr[k].reading == null || self.sectionArr[k].reading == "" || self.sectionArr[k].reading == 0) {
                      // self.miles_error_msg = "Reading Required.";
                      $('#woMiles'+k).addClass('border-red');
                      error = true;
                    }
                  }
                }
            }

            if (!error) {
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/workorder/add-miles",
                    type: "POST",
                    data: {
                        'wo_id': self.woId,
                        'woMiles':JSON.stringify(self.sectionArr),
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.addMiles = false;
                            self.milesInfo=data.content.miles;
                            $( "#wo-detail-section" ).animate({
                                right: "-350px",
                            }, 300 );
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'labor-component-remove');
                    },
                });
            }
        },
        laborComponentRemove(lineItemId,message,taskIndex) {
            var self = this;

            if (lineItemId != null) {

                if (confirm(message)) {

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/labor-component/remove",
                        type: "POST",
                        data: {
                            'id': lineItemId,
                        },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.loadWorkOrder();
                                //if any line item closed or labor log approved then show message
                                if (data.content.validate.length > 0) {
                                    var message = "";
                                    for (var i = 0;i < data.content.validate.length; i++) {
                                        if (i == 0) {
                                            message = data.content.validate[i];
                                        }else{
                                            message += " ";
                                            message += data.content.validate[i];
                                        }
                                    }
                                    if (message != "") {
                                        self.$swal('',message,'info');
                                    }
                                }else{
                                    setTimeout(function () {
                                        if (self.taskArr[taskIndex] != undefined && self.taskArr[taskIndex] != null) {
                                            self.$set(self.taskArr[taskIndex],'issublet',true);
                                        }
                                    }, 1500);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'labor-component-remove');
                        },
                    });

                } else {

                    self.taskArr[taskIndex].issublet = false;
                    self.taskArr[taskIndex].purchaseorderid = null;
                    self.taskArr[taskIndex].po_number = '';
                    self.taskArr[taskIndex].vendorid = null;
                    self.taskArr[taskIndex].disable_sublet = false;
                    self.taskArr[taskIndex].billId = null;
                    self.taskArr[taskIndex].disable_po_sublet = false;
                    self.taskArr[taskIndex].disable_amount_sublet = false;
                    self.taskArr[taskIndex].disable_vendor_sublet = false;
                }

            }
        },
        durationToDecimal(duration) {

            var decimalDuration = 0;

            var arr = duration.split(':');
            var dec = parseInt((arr[1]/6)*10, 10);

            decimalDuration = parseFloat(parseInt(arr[0], 10) + '.' + (dec<10?'0':'') + dec);

            return decimalDuration;
        },
        arrayCostRateColumn(array, cost_type,rate_type) {

            if (array.length){
                for(var i =0;i<array.length;i++){
                    if (array[i].cost_type == cost_type){
                        if (array[i].rate_type == rate_type){
                            return array[i];
                        }
                    }
                }
            }
        },
        calculateMarginMarkup(baseValue,marginOrMarkUpVal,type) {
            var finalAmount = 0;

            if (baseValue > 0 && marginOrMarkUpVal > 0) {
                if (type == "M") {//Mark Up (M)
                    finalAmount = ((marginOrMarkUpVal/100) * baseValue) + baseValue; // Mark Up = (SP - C) / C; (Mark Up In Cost not in Percentage)
                }else {//Margin (G)
                    finalAmount = baseValue / (1 - (marginOrMarkUpVal/100));// Revenue = Cost / (1 - Margin (In Cost not Percentage))
                }
                return finalAmount.toFixed(2);
            }else{
                return baseValue;
            }
        },

        getLaborCostValue:function(){
            var self = this;
            var vehicleId = "";
            if (self.vehicle_id != null && self.vehicle_id != "") {
                if (self.vehicle_id.value) {
                    vehicleId = self.vehicle_id.value;
                }
            }
            var customerId = "";
            if ( self.customer_id !== null ) {
                customerId = self.customer_id.value;
            }

            var locId = '';
            if (self.location_id != null && self.location_id.value){
                locId = self.location_id.value;
            }

            $.ajax({
                url: process.env.ROOT_API + "/labor-cost/location",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    location_id:locId,
                    customer_id:customerId,
                    vehicle_id:vehicleId
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.defaultLaborCostArr = data.content.default;
                        self.laborCostArr = data.content.customer;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-labor-cost');
                }
            });
        },
        arrayCostColumn(array, type) {

            if (array.length){
                for(var i =0;i<array.length;i++){
                    if (array[i].cost_code == type){
                        return array[i];
                    }
                }
            }
        },
        selectVmrs:function(catId,index){
            var self = this;
            var vehicleId = "";
            if (catId && catId.task != undefined && catId.task[0]){
                self.taskArr[self.activeLineItemIdx].taskid = catId.task[0];
                self.taskArr[self.activeLineItemIdx].disable_task_id = true;
            }

            if (self.assetRequired){
                if (self.vehicle_id != null && self.vehicle_id != "") {
                    if (self.vehicle_id.value) {
                        vehicleId = self.vehicle_id.value;
                    }
                }
            }else{
                if (self.taskArr[self.activeLineItemIdx].unit_id != undefined && self.taskArr[self.activeLineItemIdx].unit_id.value != undefined){
                    vehicleId = self.taskArr[self.activeLineItemIdx].unit_id.value;
                }
            }

            var miles = self.miles;
            var path = window.location.pathname;
            var segments = path.split("/");
            var url = segments[1];

            $.ajax({
                url: process.env.ROOT_API + "/warranties/search",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:vehicleId,
                    miles:miles,
                    open_date:self.open_date,
                    vmrs: catId ? catId.value : -1 ,
                    url:url,
                },
                success: function (data) {
                    self.loading = false;
                    if (data && data.length > 0){
                        self.taskArr[index].available_warranty_msg = 'This component is listed under above warranties';
                        self.taskArr[index].warrantyArr = data;
                    }else{
                        self.taskArr[index].available_warranty_msg = '';
                        self.taskArr[index].warrantyArr = data;
                        self.taskArr[index].warranty_id = '';
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-labor-cost');
                }
            });
            self.fetchStdRepairTime(index);
        },
        getSectionForReading:function(vehicleId,ttid,uid){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/section-by-truck-type/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_type_id:ttid,
                    vehicle_id:vehicleId,
                    unit_no: uid
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.sectionArr = data.content;

                        if(self.checkSegment){
                          for (let i = 0; i < self.sectionArr.length; i++) {
                              self.sectionArr[i].reading = self.sectionArr[i].reading === '' ? self.existingReading[i] : self.sectionArr[i].reading;
                          }
                        }

                        // self.taskArr[index].warrantyArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-section');
                }
            });

        },
        backButton() {
          var self = this;
          var url = "/workorder/list";
          if ( self.fromUrl != "" && self.fromUrl != undefined ) {
            if(self.$route.query.from == "assetView"){
              url = self.fromUrl+'?viewTab=workOrder';
            }else{
              url = self.fromUrl;
            }
          }
          if (self.$route.params.redirectFrom != undefined && self.$route.params.redirectFrom == 'CustomerPurchaseOrderList'){
                self.$router.push("/order-history/list?from=cust_po_wo&type=contract");
                return;
            }
          if (self.$route.path.includes('create')) {
            if (localStorage.getItem("newAsset") != undefined && localStorage.getItem("newAsset") != null) {
                localStorage.removeItem("newAsset");
            }
            if (localStorage.getItem("newCustomer") != undefined && localStorage.getItem("newCustomer") != null) {
                localStorage.removeItem("newCustomer");
            }
          }
          self.redirectPageUrl(url);

        },
        specialPOItems(taskIndex) {
            var self = this;
            var error = false;
            if (self.taskArr != undefined) {

                $("#component_category_id" + taskIndex + " .dropdown-toggle").removeClass('border-red');
                $("#taskid" + taskIndex + " .dropdown-toggle").removeClass('border-red');
                $("#billable_code" + taskIndex + " .dropdown-toggle").removeClass('border-red');
                $("#woistatus" + taskIndex + " .dropdown-toggle").removeClass('border-red');
                $("#woicomplaint" + taskIndex).removeClass('border-red');
                $("#woicause" + taskIndex).removeClass('border-red');
                $("#woicorrection" + taskIndex).removeClass('border-red');
                $("#vendorpo" + taskIndex+" .dropdown-toggle").removeClass('border-red');
                $("#vendorid" + taskIndex + " .dropdown-toggle").removeClass('border-red');
                $("#sublet_amount" + taskIndex).removeClass('border-red');
                $("#line_number" + taskIndex).removeClass('border-red');

                if (self.taskArr[taskIndex].component_category_id == null || !self.taskArr[taskIndex].component_category_id.value) {
                    $("#component_category_id" + taskIndex + " .dropdown-toggle").addClass('border-red');
                    error = true;
                }
                if (self.taskArr[taskIndex].line_number == null || self.taskArr[taskIndex].line_number == '') {
                    $("#line_number" + taskIndex).addClass('border-red');
                    error = true;
                }
                if (self.taskArr[taskIndex].taskid == null || !self.taskArr[taskIndex].taskid.value) {
                    $("#taskid" + taskIndex + " .dropdown-toggle").addClass('border-red');
                    error = true;
                }

                if (self.taskArr[taskIndex].woistatus.value == "closed") {
                  if (self.taskArr[taskIndex].billable_code == null || !self.taskArr[taskIndex].billable_code.value) {
                      $("#billable_code" + taskIndex + " .dropdown-toggle").addClass('border-red');
                      error = true;
                  }
                }
                if (self.taskArr[taskIndex].woistatus == null || !self.taskArr[taskIndex].woistatus.value) {
                    $("#woistatus" + taskIndex + " .dropdown-toggle").addClass('border-red');
                    error = true;
                }
                if (self.taskArr[taskIndex].issublet == true) {
                    if (self.taskArr[taskIndex].purchaseorderid == null || !self.taskArr[taskIndex].purchaseorderid.value) {
                        if (self.taskArr[taskIndex].vendorid == null || !self.taskArr[taskIndex].vendorid.value) {
                            $("#vendorid" + taskIndex + " .dropdown-toggle").addClass('border-red');
                            error = true;
                        }
                    }
                    if (self.taskArr[taskIndex].sublet_amount == null || !self.taskArr[taskIndex].sublet_amount) {
                        $("#sublet_amount" + taskIndex).addClass('border-red');
                        error = true;
                    }
                }
                if(self.taskArr[taskIndex].woistatus.value == 'closed' || self.taskArr[taskIndex].woistatus.value == 'review'){

                    if (self.taskArr[taskIndex].woicomplaint == "" || self.taskArr[taskIndex].woicomplaint == '') {
                        $("#woicomplaint" + taskIndex).addClass('border-red');
                        error = true;
                    }
                    if (self.taskArr[taskIndex].woicause == "" || self.taskArr[taskIndex].woicause == '') {
                        $("#woicause" + taskIndex).addClass('border-red');
                        error = true;
                    }
                    if (self.taskArr[taskIndex].woicorrection == "" || self.taskArr[taskIndex].woicorrection == '') {
                        $("#woicorrection" + taskIndex).addClass('border-red');
                        error = true;
                    }

                }
                if(self.taskArr[taskIndex].woistatus != null && self.taskArr[taskIndex].woistatus.value == 'closed'){
                    if ((self.taskArr[taskIndex].purchaseorderid == null || !self.taskArr[taskIndex].purchaseorderid.value) && self.taskArr[taskIndex].issublet == true) {
                        $("#vendorpo"+ taskIndex +" .dropdown-toggle").addClass('border-red');
                        error = true;
                    }else{
                        if ((self.taskArr[taskIndex].billId == null || !self.taskArr[taskIndex].billId.value) && self.taskArr[taskIndex].issublet == true) {
                            alert('Purchase Order does not have vendor invoice');
                            error = true;
                        }else{
                            if (!self.assetRequired) {
                                if ((self.taskArr[taskIndex].bill_item_id == null || self.taskArr[taskIndex].bill_item_id == "") && self.taskArr[taskIndex].issublet == true) {
                                    alert('Vendor Invoice does not have work order line item');
                                    error = true;
                                }
                            }
                        }
                    }
                }
            }
            if (!error) {
                var vehicleId = "";
                var locationId = "";
                if (self.vehicle_id != null && self.vehicle_id != "") {
                    if (self.vehicle_id.value) {
                        vehicleId = self.vehicle_id.value;
                    }
                }
                if (self.location_id != null && self.location_id != "") {
                    if (self.location_id.value) {
                        locationId = self.location_id.value;
                    }
                }
                if (vehicleId != "" && locationId != "") {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/purchase-order/special",
                        type: "POST",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data:{
                            vehicle_id:vehicleId,
                            location_id:locationId
                        },
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                if (data.content.found == 1) {
                                    self.uncheckSpItem(taskIndex);
                                    self.$set(self.taskArr[taskIndex], 'selectedSpItemsArr',[]);
                                    self.$set(self.taskArr[taskIndex], 'specialItemsArr',[]);
                                    var unitDetail = '';
                                    unitDetail = data.content.unit_no;
                                    var itemsArr = [];
                                    itemsArr = data.content.items;
                                    self.$set(self.taskArr[taskIndex], 'specialItemsArr',itemsArr);
                                    self.$set(self.taskArr[taskIndex], 'isItemModal',0);
                                    self.$set(self.taskArr[taskIndex], 'specialUnitNo',unitDetail);
                                    self.$set(self.taskArr[taskIndex], 'isItemErrorMsg','');
                                    $("#select-special-item"+taskIndex).modal("show");
                                }else{
                                    self.$swal('','No Special Order Item Found.','info');
                                }
                            }else{
                                self.$swal('',data.message,'info');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, true, 'special-po-items');
                        }
                    });
                }
            }
        },
        hideSpecialItemsModal(taskIndex){
            var self = this;
            self.uncheckSpItem(taskIndex);
            $("#select-special-item"+taskIndex).modal("hide");
            self.$set(self.taskArr[taskIndex], 'selectedSpItemsArr',[]);
            self.$set(self.taskArr[taskIndex], 'specialItemsArr',[]);
            self.$set(self.taskArr[taskIndex], 'isItemModal',0);
            self.$set(self.taskArr[taskIndex], 'specialUnitNo','');
            self.$set(self.taskArr[taskIndex], 'isItemErrorMsg','');
        },
        clickRows(evt,spItem,spIndex,taskIndex){
            var self = this;
            if(evt.target.checked == true){
                var subTotal = 0;
                //var unit_price = self.applyCompPriceBook(spItem.base_price,taskIndex);
                var unit_price = spItem.base_price;
                subTotal = spItem.received_quantity * unit_price;
                var itemId = {};
                var itemName = "";
                if (spItem.item_id != null && spItem.item_id != undefined) {
                    itemId.value = spItem.item_id;
                }
                if (spItem.item_code != null && spItem.item_code != undefined) {
                    itemName = spItem.item_code;
                }
                if (spItem.item_name != null && spItem.item_name != undefined) {
                    if (itemName == "") {
                        itemName = spItem.item_name;
                    }else{
                        itemName += " | ";
                        itemName += spItem.item_name;
                    }
                }
                itemId.text = itemName;
                itemId.price = spItem.base_price;
                itemId.quantity = spItem.available_qty;
                itemId.bin_id = spItem.bin_id;
                itemId.category_code = spItem.item_category;
                itemId.po_location = spItem.po_location;
                self.taskArr[taskIndex].selectedSpItemsArr.push({
                    sp_item_index:spIndex,
                    item_id:spItem.item_id,
                    item_code:spItem.item_code,
                    item_name:spItem.item_name,
                    po_quantity:spItem.po_quantity,
                    received_quantity:spItem.received_quantity,
                    available_qty:spItem.available_qty,
                    base_price:spItem.base_price,
                    task_index:taskIndex,
                    comp_subtotal:subTotal,
                    item:itemId,
                    item_error_msg:"",
                    description:"",
                    quantity:spItem.received_quantity,
                    quantity_error_msg:"",
                    comp_cost:unit_price
                });
            }else{
                const filteredItems = self.taskArr[taskIndex].selectedSpItemsArr.filter(function(item) {
                    return item.sp_item_index !== spIndex
                })
                self.taskArr[taskIndex].selectedSpItemsArr = filteredItems;
            }
        },
        uncheckSpItem(taskIndex) {
            var self = this;
            for (var i = 0;i < self.taskArr[taskIndex].specialItemsArr.length;i++) {
                $("#itemSpSelect" + i). prop("checked", false); //uncheck selected item
            }
        },
        removeSelectedSpItem(index,taskIndex) {
            var self = this;
            if (self.taskArr[taskIndex].selectedSpItemsArr != undefined) {
                self.taskArr[taskIndex].selectedSpItemsArr.splice(index, 1);
                if (self.taskArr[taskIndex].selectedSpItemsArr.length < 1) {
                    self.taskArr[taskIndex].selectedSpItemsArr = [];
                    self.taskArr[taskIndex].isItemModal = 0;
                }
            }
        },
        calculateSpItemTotal(index,taskIndex) {
            var self = this;
            var subtotal = 0;

            if (self.taskArr[taskIndex].selectedSpItemsArr[index].comp_cost != "" || self.taskArr[taskIndex].selectedSpItemsArr[index].quantity != "") {

                var cost = 0;
                if (self.taskArr[taskIndex].selectedSpItemsArr[index].comp_cost != "") {
                    cost = self.removeFormat(self.taskArr[taskIndex].selectedSpItemsArr[index].comp_cost);
                }
                subtotal = parseFloat(cost * self.taskArr[taskIndex].selectedSpItemsArr[index].quantity);
                self.taskArr[taskIndex].selectedSpItemsArr[index].comp_subtotal = subtotal;
            }
        },
        addSpecialPOItem(taskIndex) {
            var self = this;
            var error = false;
            var itemArr = [];
            var itemMsg = "";
            var errorMsg = "Item Quantity not available in inventory.";
            self.taskArr[taskIndex].isItemErrorMsg = "";
            if (self.taskArr[taskIndex].selectedSpItemsArr != undefined && self.taskArr[taskIndex].selectedSpItemsArr != null) {
                if (self.taskArr[taskIndex].selectedSpItemsArr.length < 1){
                   self.taskArr[taskIndex].isItemErrorMsg = "Special Order Item Required.";
                   error = true;
                }else{
                    var selectedItemArr = self.taskArr[taskIndex].selectedSpItemsArr;
                    for(var i = 0;i < selectedItemArr.length;i++) {
                        if (selectedItemArr[i].category_code != undefined && selectedItemArr[i].category_code != null) {
                            if (selectedItemArr[i].category_code != "SHOP") {
                                if (selectedItemArr[i].available_qty != undefined) {
                                    if (selectedItemArr[i].available_qty != null && selectedItemArr[i].available_qty != "") {
                                        if (selectedItemArr[i].received_quantity > 0) {
                                            if (selectedItemArr[i].received_quantity > selectedItemArr[i].available_qty) {
                                                if (!itemArr.includes(selectedItemArr[i].item_code)) {
                                                    itemArr.push(selectedItemArr[i].item_code);
                                                }
                                            }
                                        }else{
                                            if (!itemArr.includes(selectedItemArr[i].item_code)) {
                                                itemArr.push(selectedItemArr[i].item_code);
                                            }
                                        }
                                    }else{
                                        if (!itemArr.includes(selectedItemArr[i].item_code)) {
                                            itemArr.push(selectedItemArr[i].item_code);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            //item array to check whether item quantity available or not
            if (itemArr.length > 0) {
                for(var i = 0;i < itemArr.length;i++) {
                    if (itemArr[i] != "") {
                        if (itemMsg == "") {
                            itemMsg = itemArr[i];
                        }else{
                            itemMsg += " | ";
                            itemMsg += itemArr[i];
                        }
                    }
                }
            }
            if (itemMsg != "") {
                errorMsg = "Item ";
                errorMsg += itemMsg;
                errorMsg += " Quantity not available in inventory.";
                self.taskArr[taskIndex].isItemErrorMsg = errorMsg;
                error = true;
            }
            if (!error) {
                self.taskArr[taskIndex].isItemModal = 1;
                $("#select-special-item"+taskIndex).modal("hide");
                self.uncheckSpItem(taskIndex);
            }
        },
        changeSpecialItem(event,index,taskIndex) {
            var self = this;
            //index is for selected item Index
            if (event != null) {
                if (event.price != undefined && event.price != null) {

                    //var unit_price = self.applyCompPriceBook(event.price,taskIndex);
                    var unit_price = event.price;
                    for(var i = 0;i < self.taskArr.length;i++) {
                        if (taskIndex == i) {
                            for(var j = 0;j < self.taskArr[i].selectedSpItemsArr.length;j++) {
                                if (j == index) {
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'comp_cost',unit_price);
                                    var amount = self.taskArr[i].selectedSpItemsArr[j].quantity * self.taskArr[i].selectedSpItemsArr[j].comp_cost;
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'comp_subtotal',amount);
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'base_price',event.price);//set base price of selected item
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'available_qty',event.quantity);//set component quantity of selected item
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'item_code',event.item_code)
                                }
                            }
                        }
                    }
                }
            }
        },

        billableCodeChange(taskIndex) {
            var self = this;
            for(var i = 0;i < self.taskArr.length;i++) {
                if (self.taskArr[i].issublet == false) {
                    if (self.taskArr[i].isItemModal == 1) {
                        if (taskIndex == i) {
                            for(var j = 0;j < self.taskArr[i].selectedSpItemsArr.length;j++) {
                                //var unit_price = self.applyCompPriceBook(self.taskArr[i].selectedSpItemsArr[j].base_price,taskIndex);
                                var unit_price = self.taskArr[i].selectedSpItemsArr[j].base_price;
                                this.$set(self.taskArr[i].selectedSpItemsArr[j],'comp_cost',unit_price);
                                if (self.taskArr[i].selectedSpItemsArr[j].quantity != '') {
                                    var amount = self.taskArr[i].selectedSpItemsArr[j].quantity * self.taskArr[i].selectedSpItemsArr[j].comp_cost;
                                    this.$set(self.taskArr[i].selectedSpItemsArr[j],'comp_subtotal',amount);
                                }
                            }
                        }
                    }
                }
            }
        },
        onSelectWoType:function(){
            var self = this;

            if (self.work_order_type.value && self.work_order_type.value == 'multi unit'){
                self.assetRequired = false;
            }else{
                self.assetRequired = true;
            }
        },
        onChangeVendor:function(venObj,ind){
            var self = this;
            if (!self.assetRequired){
                if (ind > 0){
                    self.$swal('','This vendor will be override in all line item','info');
                }
                for(var i = 0;i < self.taskArr.length;i++) {
                    self.taskArr[i].vendorid = venObj;
                }
            }
        },
        onProgramChange:function(prid,index){
            var self = this;

            if (prid != null && prid != undefined){
                if (prid.vmrs != undefined && prid.vmrs.length > 0){
                    //self.vmrsArr = prid.vmrs;
                    self.taskArr[index].component_category_id = prid.vmrs[0];
                }
                if (prid.task != undefined && prid.task.length > 0){
                    //self.workOrderTaskArr = prid.task;
                    self.taskArr[index].taskid = prid.task[0];
                    //self.taskArr[index].disable_task_id = true;
                }
            }
        },
        laborRateValue(index) {
            var self = this;
            var laborValue = 0;
            var laborRate = 0;
            //as per new changes
            var fromPriceBook = 0;

            var laborCostDef = self.arrayCostColumn(self.defaultLaborCostArr,"INT");

            if (laborCostDef != undefined) {
                laborRate = laborCostDef.rate;
                laborValue = laborRate;
            }

            return laborValue;
        },
        onPOSelect(poData,index) {
            var self = this;
            if (self.taskArr[index].disable_po_sublet == false) {
                if (poData != undefined && poData != null) {
                    if (poData.vendor_id != undefined && poData.vendor_id != null && poData.vendor_id != "") {
                        if (poData.vendor != undefined && poData.vendor != null && poData.vendor != "") {
                            self.taskArr[index].vendorid = {text:poData.vendor,value:poData.vendor_id};
                            self.taskArr[index].disable_vendor_sublet = true;
                        }else{
                            self.taskArr[index].disable_vendor_sublet = false;
                        }
                    }else{
                        self.taskArr[index].disable_vendor_sublet = false;
                    }
                    if (poData.bill_id != undefined && poData.bill_id != null && poData.bill_id != "") {
                        if (poData.voucher_number != undefined && poData.voucher_number != null && poData.voucher_number != "") {
                            self.taskArr[index].billId = {text:poData.voucher_number,value:poData.bill_id};
                            self.taskArr[index].disable_sublet = true;
                        }else{
                            self.taskArr[index].disable_sublet = false;
                            self.taskArr[index].billId = null;
                        }
                    }else{
                        self.taskArr[index].disable_sublet = false;
                        self.taskArr[index].billId = null;
                    }
                    if (poData.po_number != undefined){
                        self.taskArr[index].po_number = poData.po_number;
                    }
                }else{
                    self.taskArr[index].vendorid = null;
                    self.taskArr[index].disable_vendor_sublet = false;
                    self.taskArr[index].disable_sublet = false;
                    self.taskArr[index].billId = null;
                }
            }
        },

        onLocationChange(){
            var self = this;
            if (self.location_id != null && self.location_id.value != null) {
                //self.fetchTaxRate();
            }
        },

        fetchStdRepairTime(taskIndex){
            var self = this;
            //for non miscellaneous work orders
            if (!self.showMiscellaneousFields) {
                if (self.taskArr[taskIndex] != undefined && self.taskArr[taskIndex] != null) {
                    if (self.taskArr[taskIndex].component_category_id != undefined && self.taskArr[taskIndex].component_category_id != null) {
                        if (self.taskArr[taskIndex].component_category_id.value != undefined && self.taskArr[taskIndex].component_category_id.value != null) {
                            if (self.taskArr[taskIndex].taskid != undefined && self.taskArr[taskIndex].taskid != null) {
                                if (self.taskArr[taskIndex].taskid.value != undefined && self.taskArr[taskIndex].taskid.value != null) {
                                    var itemVrms = self.taskArr[taskIndex].component_category_id.value;
                                    var itemTask = self.taskArr[taskIndex].taskid.value;
                                    var woLocation = null;
                                    if (self.location_id != null && self.location_id.value) {
                                        woLocation = self.location_id.value;
                                    }
                                    var woVehicle = null;
                                    if (self.assetRequired) {
                                        if (self.vehicle_id != null && self.vehicle_id.value) {
                                            woVehicle = self.vehicle_id.value;
                                        }
                                    }else{
                                        if (self.taskArr[taskIndex].unit_id != undefined && self.taskArr[taskIndex].unit_id != null) {
                                            if (self.taskArr[taskIndex].unit_id.value != undefined && self.taskArr[taskIndex].unit_id.value != null) {
                                                    woVehicle = self.taskArr[taskIndex].unit_id.value;
                                            }
                                        }
                                    }
                                    $.ajax({
                                        url: process.env.ROOT_API + "/std-repair-time/fetch",
                                        type: "POST",
                                        headers: this.ajxHeaders,
                                        dataType: "json",
                                        data:{
                                            vrms_id:itemVrms,
                                            task_id:itemTask,
                                            location_id:woLocation,
                                            vehicle_id:woVehicle
                                        },
                                        success: function (data) {
                                            self.loading = false;
                                            if (data.status == "success" && data.content != 0) {
                                                self.$set(self.taskArr[taskIndex],'std_repair_time',data.content);
                                            }
                                        },
                                        error: function (jqXHR, exception) {
                                            self.loading = false;
                                            self.generateStatusCodeMessage(jqXHR, true, 'fetch-std-repair-time');
                                        }
                                    });
                                }
                            }
                        }
                    }
                    if (self.taskArr[taskIndex] != undefined && self.taskArr[taskIndex].component_category_id != undefined && self.taskArr[taskIndex].component_category_id.text != undefined && self.taskArr[taskIndex].component_category_id.text.includes('WA000000')
                        && self.taskArr[taskIndex].taskid != undefined && self.taskArr[taskIndex].taskid.text != undefined && self.taskArr[taskIndex].taskid.text.includes('52')){
                        self.requireEtc = '';
                    }
                }
            }
        },
        searchWOComponent(loading, search, flag,locationId,defaultWarehouse) {
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/search",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                data: {
                    search: search,
                    flag:flag,
                    contractWiseAssetId:locationId,
                    for:defaultWarehouse,
                },
                dataType: "json",
                success: function (data) {
                    if (data.status == "success") {
                        loading(false);
                        self.componentArr = [];
                        self.componentArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'ach-check-customer')
                }
            });

        },
        partAddLine(taskIndex) {
            var self = this;
            if (self.taskArr[taskIndex].isPartAdd == 0) {
                self.taskValidations('serviceTaskComp',taskIndex);
                self.clearServiceTaskComp(taskIndex);
                self.showActiveTaskLabor = (self.showActiveTaskLabor == 'addComponent'+taskIndex)?'':'addComponent'+taskIndex;
                if (self.showActiveTaskLabor == 'addComponent'+taskIndex) {
                    self.taskArr[taskIndex].isPartAdd = 1;
                }
            }
            if (self.taskArr[taskIndex].isPartAdd == 1) {
                var partItmInd = 0;
                if (self.taskArr[taskIndex].partAddArr.length > 0) {
                    partItmInd = self.taskArr[taskIndex].partAddArr.length - 1;
                }
                if (self.taskArr[taskIndex].partAddArr.length < 1) {
                    self.taskArr[taskIndex].partAddArr.push({
                        base_price:0,
                        task_index:taskIndex,
                        item:null,
                        item_error_msg:"",
                        description:"",
                        quantity:0,
                        quantity_error_msg:"",
                        comp_cost:0,
                        comp_subtotal:0,
                        is_issued:0,
                        warehouse_id:null
                    });
                }else{
                    var partErr = false;
                    self.taskArr[taskIndex].partAddArr[partItmInd].item_error_msg = "";
                    self.taskArr[taskIndex].partAddArr[partItmInd].quantity_error_msg = "";
                    if (self.taskArr[taskIndex].partAddArr[partItmInd].item == null || self.taskArr[taskIndex].partAddArr[partItmInd].item == "") {
                        self.taskArr[taskIndex].partAddArr[partItmInd].item_error_msg = "Specify Component";
                        partErr = true;
                    }
                    if (self.taskArr[taskIndex].partAddArr[partItmInd].quantity == null || self.taskArr[taskIndex].partAddArr[partItmInd].quantity == ""
                        || !self.taskArr[taskIndex].partAddArr[partItmInd].quantity || self.taskArr[taskIndex].partAddArr[partItmInd].quantity == undefined) {
                        self.taskArr[taskIndex].partAddArr[partItmInd].quantity_error_msg = "Quantity is Required";
                        partErr = true;
                    } else if (self.taskArr[taskIndex].partAddArr[partItmInd].quantity == 0) {
                        self.taskArr[taskIndex].partAddArr[partItmInd].quantity_error_msg = "Quantity can not be 0";
                        partErr = true;
                    }
                    if (!partErr) {
                        self.taskArr[taskIndex].partAddArr.push({
                            base_price:0,
                            task_index:taskIndex,
                            item:null,
                            item_error_msg:"",
                            description:"",
                            quantity:0,
                            quantity_error_msg:"",
                            comp_cost:0,
                            comp_subtotal:0,
                            is_issued:0,
                            warehouse_id:null
                        });
                    }
                }
            }
            self.serviceTaskIssued = 0;
        },
        isInvalidQuantity(input) {
            // Regular expression to match a number with 1 or 2 decimal places
            let decimalRegex = /^-?\d+(\.\d{1,2})?$/;
            let flag = true;
            if (decimalRegex.test(input)) {
                flag = false;
            }
            return flag;
        },
        removePartItem(index,taskIndex) {
            var self = this;
            if (self.taskArr[taskIndex].partAddArr != undefined) {
                self.taskArr[taskIndex].partAddArr.splice(index, 1);
                if (self.taskArr[taskIndex].partAddArr.length < 1) {
                    self.taskArr[taskIndex].partAddArr = [];
                    self.taskArr[taskIndex].isPartAdd = 0;
                    self.showActiveTaskLabor = '';
                }
            }
        },
        calculatePartItemTotal(index,taskIndex) {
            var self = this;
            var subtotal = 0;

            if (self.taskArr[taskIndex].partAddArr[index].comp_cost != "" || self.taskArr[taskIndex].partAddArr[index].quantity != "") {

                var cost = 0;
                if (self.taskArr[taskIndex].partAddArr[index].comp_cost != "") {
                    cost = self.removeFormat(self.taskArr[taskIndex].partAddArr[index].comp_cost);
                }
                subtotal = parseFloat(cost * self.taskArr[taskIndex].partAddArr[index].quantity);
                self.taskArr[taskIndex].partAddArr[index].comp_subtotal = subtotal;
            }
        },
        onWorkOrderTypeIn(){
          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");
          var error = false;
          if(self.seqCheck == self.work_order_no){
            //when edit form is loaded then,
            self.work_order_no_error_msg = "";
            error = false;
            self.work_order_duplicate = false;
          }else{
                $.ajax({
                url: process.env.ROOT_API + "/work-order/duplicate-check",
                type: "POST",
                headers: this.ajxHeaders,
                data: {work_order_no : self.work_order_no},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if ( data.code == 200 ) {
                            self.work_order_no_error_msg = "This Work Order No already exist!!";
                            error = true;
                            self.work_order_duplicate = true;
                        } else if ( data.code == 201) {
                            self.work_order_no_error_msg = "";
                            error = false;
                            self.work_order_duplicate = false;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-code')
                }
            });
          }
        },
        changePartItem(event,index,taskIndex,flag) {
            var self = this;
            //index is for selected item Index
            if (flag == 'add_part'){
                if (event != null) {
                    if (event.price != undefined && event.price != null) {

                        //var unit_price = self.applyCompPriceBook(event.price,taskIndex);
                        var unit_price = event.price;
                        for(var i = 0;i < self.taskArr.length;i++) {
                            if (taskIndex == i) {
                                for(var j = 0;j < self.taskArr[i].partAddArr.length;j++) {
                                    if (j == index) {
                                        this.$set(self.taskArr[i].partAddArr[j],'comp_cost',unit_price);
                                        var amount = self.taskArr[i].partAddArr[j].quantity * self.taskArr[i].partAddArr[j].comp_cost;
                                        this.$set(self.taskArr[i].partAddArr[j],'comp_subtotal',amount);
                                        this.$set(self.taskArr[i].partAddArr[j],'base_price',event.price);//set base price of selected item
                                        this.$set(self.taskArr[i].partAddArr[j],'available_qty',event.quantity);//set component quantity of selected item
                                        this.$set(self.taskArr[i].partAddArr[j],'item_code',event.item_code)
                                        this.$set(self.taskArr[i].partAddArr[j],'warehouse_id',event.warehouse_id)
                                    }
                                }
                            }
                        }
                    }
                }
            }else{
                if (flag == 'change_part'){
                    if (self.serviceTaskComp.price != undefined){
                        self.serviceTaskCompCost = self.serviceTaskComp.price;
                    }
                }
            }

        },

        addEtcDate:function(task,index){
            var self = this;
            if (self.taskArr[index].est_repair_time != '' && self.taskArr[index].est_repair_time != undefined){
                var open_date = self.open_date;
                if (self.open_date.includes(' ')){
                    open_date = self.open_date.split(' ');
                    open_date = open_date[0];
                }
                var term = self.monthDiff(new Date(open_date),new Date(self.taskArr[index].est_repair_time));
                if (term > 60){
                    self.taskArr[index].etcExtend = true;
                }else{
                    self.taskArr[index].etcExtend = false;
                }
            }
        },

        monthDiff(date1, date2) {
            var months;

            var Difference_In_Time = date2.getTime() - date1.getTime();

            // To calculate the no. of days between two dates
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

            return Difference_In_Days;
            // months = (d2.getFullYear() - d1.getFullYear()) * 12;
            // months -= d1.getMonth();
            // months += d2.getMonth();
            // return months <= 0 ? 0 : months;
        },
        // get Schedule Maintenance data
        getScheduledata(){
           var self = this;
           $.ajax({
                url: process.env.ROOT_API + "/workorder/getscheduledata",
                type: "POST",
                data: {'schedule_id': self.$route.params.schedule_id},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    if (data.status == "success") {
                        self.wonotes = data.content.notes;
                        self.requested_completion = moment(data.content.schedule_date).format('MM DD YYYY, h:mm:ss a');
                        if (data.content.lCode != null && data.content.lCode != '') {
                            self.location_id = {
                                value: data.content.lId,
                                text: self.titleCase(data.content.lCode) + " | " + data.content.lName
                            };
                        }
                        if (data.content.vehicleUnitNo != null && data.content.vehicleUnitNo != '') {
                            self.vehicle_id = {
                                value: data.content.vehicleId,
                                text: self.titleCase(data.content.vehicleUnitNo) + " | " + data.content.vtCode
                            }
                        }
                        if (data.content.custCode != null && data.content.custCode != '') {
                            self.customer_id = {
                                value: data.content.custId,
                                text: self.titleCase(data.content.custCode) + " | " + data.content.custName
                            };
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'invoice-item-delete');
                },
            });
        },
        openModal: function(){
            var self = this;
            // if (self.batchProcess){
            //     self.$swal('','Previous batch already runnig','info');
            //     return;
            // }
            self.selectedFile = [];
            // self.duplicatePolicy = [];
            $("#dnFile").val('');
            self.import_error = '';
            self.generateExcelSample();
            self.importIssue = [];
            $('#wo-item-modal').modal('show');
        },
        generateExcelSample:function(){
            var self = this;

            $.ajax({
                url:
                process.env.ROOT_API +
                "/wo-item-excel/generate",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    self.fileName = data.content.file;
                    self.file = data.content.web;

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'debt note-import')

                }
            });
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            var self = this;
            self.selectedFile = file;
            self.import_error = '';
        },
        downloadSample(){
            var self = this;
            var docPath = self.file;
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },

        importWoItem:function(){
            var self = this;

            self.import_error = "";
            if( self.selectedFile == "" || self.selectedFile == null){
                self.import_error = "Please Select Excel File.";
                return;
            }
            var fileExtension = ['xls', 'xlsx'];
            if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                return;
            }

            var formData = new FormData();
            formData.append('myFile', self.selectedFile);
            formData.append('id', self.woId);

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/wo-item/import",
                type: "POST",
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.content.asset != undefined && data.content.asset.length){
                        self.importIssue = data.content;
                        return;
                    }
                    if (data.content.task != undefined && data.content.task.length){
                        self.importIssue = data.content;
                        return;
                    }
                    $('#wo-item-modal').modal('hide');
                    self.loadWorkOrder();
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    $('#importButton').text('Import');
                    $('#importButton').prop('disabled',false);
                    $('#cancelButton').prop('disabled',false);
                    self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                }
            });
        },
        selectComp:function(evt,id,flag){
            var self = this;

            if(evt.target.checked == true){
                self.selectedCompArr.push({id:id});
            }else{
                const filteredItems = self.selectedCompArr.filter(function(item) {
                    return item.id !== id
                })
                self.selectedCompArr = filteredItems;
            }
        },
        percentageValidation: function (btnId){
            var self = this;
            self.percentageErr = '';
            document.getElementById(btnId).disabled = false;
            if (self.tax > 100){
            self.percentageErr = 'tax should be less or equal to 100';
            document.getElementById(btnId).disabled = true
            }
        },
        leavepoFocus(event,index){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            let wo_id = (segments[3] != undefined) ? segments[3] : self.woId;
            var fields_err = [];
            $.ajax({
                url: process.env.ROOT_API + "/workorder/checkpo",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    wo_id:wo_id,
                    po_number:event.target.value,
                },
                success: function (data) {
                    self.loading =  false;
                    if (data.status == "success") {
                        self.taskArr[index].po_error_msg = "";
                    }else if(data.status == "errormessage"){
                        self.$set(self.taskArr[index],'po_error_msg',data.message);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'close-wo-items');
                }
            });
        },
        onselectwarehouse(){
            var self = this;
            self.componentArr = [];
        }
    }
};
</script>
<style scoped>

.disable-btn {
    border-right-color: #a5a6a6 !important;
    pointer-events: none;
    cursor: default;
}
.adjMarginRV{
    margin-right:15px !important;
}
.swal2-overflow{
  overflow-x: visible;
  overflow-y: visible;
  max-height: 550px !important;
  min-height: 550px !important;
}
.pre-formatted {
  white-space: pre;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkOrderCreate.vue